(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1202],{

/***/ 34428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[slug]/[id]",
      function () {
        return __webpack_require__(66376);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ pinewoodBodyMat; },
/* harmony export */   "Jj": function() { return /* binding */ getRGBFromRAL; },
/* harmony export */   "RQ": function() { return /* binding */ milkyGlassMat; },
/* harmony export */   "RV": function() { return /* binding */ ashwoodMat; },
/* harmony export */   "Rv": function() { return /* binding */ rattanMat; },
/* harmony export */   "Sy": function() { return /* binding */ securityGlassMat; },
/* harmony export */   "Xw": function() { return /* binding */ pinewoodFrameMat; },
/* harmony export */   "ZP": function() { return /* binding */ foressoMat; },
/* harmony export */   "hP": function() { return /* binding */ metalMat; },
/* harmony export */   "id": function() { return /* binding */ transparentGlassMat; },
/* harmony export */   "zw": function() { return /* binding */ mirrorGlassMat; }
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99477);

var pinewoodFrameMat = {
    bumpMap: "bumpMapFrame",
    bumpScale: 0.001,
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    name: "pinewood_frame",
    wrap: three__WEBPACK_IMPORTED_MODULE_0__/* .MirroredRepeatWrapping */ .OoA,
    roughnessMap: "roughnessMapFrame",
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    uvScale: {
        u: 2,
        v: 2
    }
};
var pinewoodBodyMat = {
    aoMap: "aoMapBody",
    aoMapIntensity: 1,
    bumpMap: "bumpMapBody",
    bumpScale: 0.002,
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    wrap: three__WEBPACK_IMPORTED_MODULE_0__/* .MirroredRepeatWrapping */ .OoA,
    name: "pinewood_body",
    normalMap: "normalMapBody",
    normalScale: {
        x: 3,
        y: 3
    },
    roughnessMap: "roughnessMapBody",
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    uvScale: {
        u: 2.8,
        v: 2.8
    }
};
var metalMat = {
    aoMapIntensity: 0.1,
    color: 0x0e0e10,
    emissive: 0x000000,
    emissiveIntensity: 0.001,
    metalness: 0.4,
    name: "metal",
    roughness: 0.7
};
var ashwoodMat = {
    // bumpMap: 'ashBump',
    // bumpScale: 1,
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    name: "ashwood_body",
    roughnessMap: "ashRoughness",
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    uvScale: {
        u: 2,
        v: 2
    }
};
var foressoMat = {
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    name: "foresso",
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    uvScale: {
        u: 3,
        v: 3
    }
};
var rattanMat = {
    alphaMap: "rattanOpacity",
    aoMap: "rattanAO",
    bumpMap: "rattanBump",
    // bumpScale: 1,
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    name: "rattan",
    map: "rattanMap",
    normalMap: "rattanNormal",
    roughnessMap: "rattanRoughness",
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    transparent: true,
    uvScale: {
        u: 6,
        v: 6
    }
};
var transparentGlassMat = {
    clearcoat: 1,
    clearcoatRoughness: 0.1,
    name: "transparent_glass",
    roughness: 0.01,
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    thickness: 0.5,
    transmission: 1
};
var milkyGlassMat = {
    clearcoat: 1,
    clearcoatRoughness: 0.1,
    // color: '#ffffff',
    name: "milky_glass",
    roughness: 0.3,
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    thickness: 0.5,
    transmission: 0.8
};
var securityGlassMat = {
    clearcoat: 1,
    clearcoatRoughness: 0.1,
    colorSpace: three__WEBPACK_IMPORTED_MODULE_0__/* .SRGBColorSpace */ .KI_,
    map: "wiredGlassMap",
    name: "security_glass",
    roughness: 0.3,
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3,
    thickness: 0.5,
    transmission: 0.8,
    uvScale: {
        u: 3,
        v: 3
    }
};
var mirrorGlassMat = {
    clearcoat: 1,
    clearcoatRoughness: 0.1,
    color: 0xd3d3d3,
    name: "mirror_glass",
    // opacity: 0.25,
    // roughness: 0,
    // reflectivity: 0.5,
    side: three__WEBPACK_IMPORTED_MODULE_0__/* .FrontSide */ .Wl3
};
var getRGBFromRAL = function(ralColor) {
    var rals = {
        white: 0xf0efe9,
        black: 0x0e0e10,
        ral1001: 0xd0b084,
        ral1005: 0xcb8e00,
        ral1018: 0xfaca30,
        ral2003: 0xf67828,
        ncs3010: 0xb7b9a6,
        ral3014: 0xf2838f,
        ral3015: 0xd8a0a6,
        ral5001: 0x0f4c64,
        ral5024: 0x6093ac,
        ral6005: 0x114232,
        ral6017: 0x587f40,
        ral6033: 0x46877f,
        ral7003: 0x7a7669,
        ral7004: 0x9b9b9b,
        ral7016: 0x383e42,
        ral9001: 0xe9e0d2,
        ral9003: 0xecece7,
        ral9005: 0x0e0e10,
        ral9010: 0xfcfaf5,
        ralcustom: 0xf56fa1,
        ral2012: 0xd5655d,
        ral5019: 0x005e83,
        ral6019: 0xb9ceac,
        ral7045: 0x8d9295,
        ral3005: 0x59191f,
        ral5003: 0x1f3855,
        ral6011: 0x6c7c59,
        ral7024: 0x45494e,
        ral7032: 0xb5b0a1
    };
    return rals[ralColor];
};


/***/ }),

/***/ 72722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uk": function() { return /* binding */ ModelFactory; },
  "$T": function() { return /* binding */ isDot; },
  "GG": function() { return /* binding */ isMinimalist; },
  "VY": function() { return /* binding */ isSystemHidden; },
  "ht": function() { return /* binding */ isSystemTop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/utils/BufferGeometryUtils.js
var BufferGeometryUtils = __webpack_require__(40140);
// EXTERNAL MODULE: ./src/@lib/Configurator3D/helpers.js
var helpers = __webpack_require__(54622);
// EXTERNAL MODULE: ./src/@lib/Configurator3D/Object3D.ts
var Object3D = __webpack_require__(67880);
;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Elegance/Base.ts
/* eslint-disable */ 







var braceStyle = {
    braced: "L",
    crossed: "X"
};
var EleganceDoor = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0,_inherits/* default */.Z)(EleganceDoor, Object3D);
    var _super = (0,_create_super/* default */.Z)(EleganceDoor);
    function EleganceDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, EleganceDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _this.materials = {
            metal: new three_module/* MeshStandardMaterial */.Wid(),
            mirror: new three_module/* MeshStandardMaterial */.Wid(),
            woodBody: new three_module/* MeshStandardMaterial */.Wid(),
            woodFrame: new three_module/* MeshStandardMaterial */.Wid()
        };
        _this.parameters.frameThickness = 40;
        _this.parameters.frameGroove = 20;
        _this.parameters.mirrorThickness = 4;
        _this.parameters.slatSize = 100;
        _this.parameters.handleHoleWidth = 40;
        _this.parameters.handleHoleLength = 160;
        _this.parameters.handleHoleRadius = 50;
        _this.parameters.handleHoleDepth = 12;
        _this.parameters.handleHoleOffset = 15;
        _this.parameters.handleOffset = 20;
        _this.parameters.braceWidth = 120;
        _this.parameters.braceThickness = 11;
        _this.parameters.hangerMargin = 60;
        _this.parameters.hangerOffset = -20;
        return _this;
    }
    var _proto = EleganceDoor.prototype;
    _proto.calculateModelParameters = function calculateModelParameters() {
        this.parameters.frameWidth = this.parameters.width > 1200 ? 160 : 120;
        this.parameters.frameWidth = this.parameters.width < 700 ? 80 : 120;
        this.parameters.hangerMargin = isSystemHidden(this.parameters.system) ? 120 : this.parameters.frameWidth / 2;
        this.parameters.hangerOffset = isSystemHidden(this.parameters.system) ? 20 : -20;
        this.parameters.hangerHeightOffset = isSystemHidden(this.parameters.system) ? -100 : 1;
        this.parameters.railWidth = this.parameters.width - 2 * this.parameters.frameWidth;
        this.parameters.slatThickness = this.parameters.style !== "mirror" ? 18 : 14;
        this.parameters.slatCentering = this.parameters.style !== "mirror" ? 0 : this.parameters.slatThickness / 2;
        this.parameters.slatLength = (this.parameters.height - 2 * (this.parameters.frameWidth - this.parameters.frameGroove) - this.parameters.density * (this.parameters.frameWidth - 2 * this.parameters.frameGroove)) / (this.parameters.density + 1);
        this.parameters.slatWidth = this.parameters.width - 2 * (this.parameters.frameWidth - this.parameters.frameGroove);
    };
    _proto.buildFrameGeometry = function buildFrameGeometry() {
        var geometries = [];
        /* create the base geometries */ var leftStile = helpers/* CreateLeftStyle */.PR(this.parameters.frameWidth, this.parameters.height, this.parameters.frameThickness);
        var rightStile = helpers/* CreateRightStyle */.Us(this.parameters.frameWidth, this.parameters.height, this.parameters.frameThickness);
        var topRail = helpers/* CreateTopRail */.G3(this.parameters.frameWidth, this.parameters.railWidth, this.parameters.frameThickness, this.parameters.slatThickness, this.parameters.frameGroove);
        var bottomRail = helpers/* CreateBottomRail */.qN(this.parameters.frameWidth, this.parameters.railWidth, this.parameters.frameThickness, this.parameters.slatThickness, this.parameters.frameGroove);
        /* position the geometries */ leftStile.translate(this.parameters.frameWidth / 2, 0, 0);
        rightStile.translate(this.parameters.width - this.parameters.frameWidth / 2, 0, 0);
        topRail.translate(this.parameters.frameWidth + this.parameters.railWidth / 2 - this.parameters.frameGroove, 0, this.parameters.height - this.parameters.frameWidth);
        bottomRail.translate(this.parameters.frameWidth + this.parameters.railWidth / 2 - this.parameters.frameGroove, 0, 0);
        if (this.parameters.handle) {
            /* create the hole for the handle */ var handleHole = helpers/* CreateHandleInnerHole */.s1(this.parameters.handleHoleWidth, this.parameters.handleHoleLength, this.parameters.handleHoleRadius, this.parameters.handleHoleDepth);
            handleHole.translate(this.parameters.frameWidth / 2, -this.parameters.handleHoleOffset, this.parameters.height / 2);
            leftStile = helpers/* BooleanDifference */.i1(leftStile, handleHole);
        }
        /* push the geometries into the array */ geometries.push(this.updateGeometry(leftStile, 90));
        geometries.push(this.updateGeometry(rightStile, 90));
        geometries.push(this.updateGeometry(topRail));
        geometries.push(this.updateGeometry(bottomRail));
        /* create the middle rail */ for(var i = 0; i < this.parameters.density; i++){
            var centralRail = helpers/* CreateMiddleRail */.Qu(this.parameters.frameWidth, this.parameters.railWidth, this.parameters.frameThickness, this.parameters.slatThickness, this.parameters.frameGroove);
            centralRail.translate(this.parameters.frameWidth + this.parameters.railWidth / 2 - this.parameters.frameGroove, 0, (i + 1) * (this.parameters.slatLength + (this.parameters.frameWidth - 2 * this.parameters.frameGroove)));
            geometries.push(this.updateGeometry(centralRail));
        }
        return geometries;
    };
    _proto.buildSlatGeometry = function buildSlatGeometry() {
        var _loop = function(i) {
            slats.forEach(function(s) {
                var slat = s.clone();
                if (i % 2 === 0) {
                    slat = helpers/* MirrorObjectZ */.ri(slat, false);
                    slat.translate(0, 0, _this.parameters.slatLength);
                }
                slat.translate(_this.parameters.frameWidth - _this.parameters.frameGroove, _this.parameters.slatCentering, _this.parameters.frameWidth - _this.parameters.frameGroove + i * (_this.parameters.slatLength + _this.parameters.frameWidth - 2 * _this.parameters.frameGroove));
                geometries.push(_this.updateGeometry(slat, Math.pow(-1, i) * slatsAngle));
            });
        };
        var _this = this;
        var geometries = [];
        /* create the base geometries */ var slats = helpers/* CreateSlats */.mp(this.parameters.slatWidth, this.parameters.slatLength, this.parameters.slatSize, this.parameters.slatThickness, this.parameters.style);
        var slatsAngle = this.getOrientation();
        /* create mirror and duplicate the elements */ for(var i = 0; i < this.parameters.density + 1; i++)_loop(i);
        slats.forEach(function(s) {
            s.dispose();
        }); // Clean geometries to avoid leak
        return geometries;
    };
    _proto.buildBodyGeometry = function buildBodyGeometry() {
        var geometries = [];
        /* Create the base objects */ var plate = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(this.parameters.frameWidth - this.parameters.frameGroove, this.parameters.mirrorThickness - this.parameters.slatThickness / 2, this.parameters.frameWidth - this.parameters.frameGroove), new three_module/* Vector3 */.Pa4(this.parameters.frameWidth - this.parameters.frameGroove + this.parameters.slatWidth, this.parameters.mirrorThickness + this.parameters.slatThickness / 2, this.parameters.frameWidth - this.parameters.frameGroove + this.parameters.slatLength));
        var bodyAngle = this.getOrientation();
        /* Copy the element for each the cell */ for(var i = 0; i <= this.parameters.density; i++){
            if (i === 0) {
                geometries.push(this.updateGeometry(plate, Math.pow(-1, 1) * bodyAngle));
            } else {
                var tmp = plate.clone();
                tmp.translate(0, 0, i * (this.parameters.slatLength + this.parameters.frameWidth - 2 * this.parameters.frameGroove));
                if (this.parameters.style === "oblic") {
                    geometries.push(this.updateGeometry(tmp, Math.pow(-1, i + 1) * bodyAngle));
                } else {
                    geometries.push(this.updateGeometry(tmp, Math.pow(-1, 1) * bodyAngle));
                }
            }
        }
        return geometries;
    };
    _proto.buildMirrorGeometry = function buildMirrorGeometry() {
        var geometries = [];
        /* Create the base objects */ var plate = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(this.parameters.frameWidth - this.parameters.frameGroove, -(this.parameters.mirrorThickness + this.parameters.slatThickness) / 2, this.parameters.frameWidth - this.parameters.frameGroove), new three_module/* Vector3 */.Pa4(this.parameters.frameWidth - this.parameters.frameGroove + this.parameters.slatWidth, (this.parameters.mirrorThickness - this.parameters.slatThickness) / 2, this.parameters.frameWidth - this.parameters.frameGroove + this.parameters.slatLength));
        /* Copy the element for each the cell */ for(var i = 0; i <= this.parameters.density; i++){
            if (i === 0) {
                geometries.push(plate);
            } else {
                var tmp = plate.clone();
                tmp.translate(0, 0, i * (this.parameters.slatLength + this.parameters.frameWidth - 2 * this.parameters.frameGroove));
                geometries.push(tmp);
            }
        }
        return geometries;
    };
    _proto.buildBraceGeometry = function buildBraceGeometry() {
        var _loop = function(i) {
            var index = 0;
            list.forEach(function(b) {
                var brace = b.clone();
                if (i % 2 !== 0 && _this.parameters.brace === braceStyle.braced) {
                    brace = helpers/* MirrorObjectZ */.ri(brace, false);
                    brace.translate(0, 0, braceHeight);
                }
                brace.translate(_this.parameters.frameWidth, -_this.parameters.frameGroove, (i + 1) * _this.parameters.frameWidth + i * braceHeight);
                if (_this.parameters.brace === braceStyle.braced) {
                    geometries.push(_this.updateGeometry(brace, 90 - Math.pow(-1, (i + 1) % 2) * Math.pow(-1, index) * theta));
                } else {
                    geometries.push(_this.updateGeometry(brace, 90 + Math.pow(-1, index) * theta));
                }
                index++;
            });
            list.forEach(function(b) {
                b.dispose();
            }); // Clean geometries to avoid leak
        };
        var _this = this;
        var geometries = [];
        /* create the base geometries */ var braceWidth = this.parameters.width - 2 * this.parameters.frameWidth;
        var braceHeight = (this.parameters.height - (2 + this.parameters.density) * this.parameters.frameWidth) / (this.parameters.density + 1);
        var ref = helpers/* CreateBrace */.bS(braceWidth, braceHeight, this.parameters.braceWidth, this.parameters.braceThickness, this.parameters.brace), list = ref.list, theta = ref.theta;
        /* mirror the element based on the density */ for(var i = 0; i < this.parameters.density + 1; i++)_loop(i);
        return geometries;
    };
    _proto.buildHandleGeometry = function buildHandleGeometry() {
        var geometries = [];
        var handleObj = this.resourceManager.getObject("handleInner");
        if (!handleObj) {
            return [];
        }
        var handle = handleObj.children[0].geometry.clone();
        helpers/* RotateObject */.JJ(handle, null, 90, "X");
        handle.translate(0, -this.parameters.handleOffset, 0);
        var handleClone = handle.clone();
        handleClone.rotateX(Math.PI);
        if (this.parameters.orientation === "left") {
            handle.translate(this.parameters.frameWidth / 2, 0, this.parameters.height / 2);
            handleClone.translate(this.parameters.frameWidth / 2, 0, this.parameters.height / 2);
        } else {
            handle.translate(this.parameters.width - this.parameters.frameWidth / 2, 0, this.parameters.height / 2);
            handleClone.translate(this.parameters.width - this.parameters.frameWidth / 2, 0, this.parameters.height / 2);
        }
        geometries.push(handle);
        geometries.push(handleClone);
        return geometries;
    };
    _proto.buildHangerGeometry = function buildHangerGeometry() {
        var _this = this;
        var geometries = [];
        var hangerObj;
        if (this.parameters.system === "hamak") {
            hangerObj = this.resourceManager.getObject("hamakSystem");
        } else if (this.parameters.system === "roller") {
            hangerObj = this.resourceManager.getObject("rollerSystem");
        } else if (this.parameters.system === "hidden") {
            hangerObj = this.resourceManager.getObject("hiddenSystem");
        } else if (this.parameters.system === "simple") {
            hangerObj = this.resourceManager.getObject("simpleSystem");
        }
        if (!hangerObj) {
            return [];
        }
        hangerObj.children.forEach(function(z) {
            var geom = z.geometry.clone();
            helpers/* RotateObject */.JJ(geom, null, 90, "X");
            geom.translate(_this.parameters.hangerMargin, _this.parameters.hangerOffset, _this.parameters.height + _this.parameters.hangerHeightOffset);
            var geomClone = geom.clone();
            geomClone.translate(_this.parameters.width - 2 * _this.parameters.hangerMargin, 0, 0);
            geometries.push(geom);
            geometries.push(geomClone);
        });
        return geometries;
    };
    _proto.getOrientation = function getOrientation() {
        if (this.parameters.style === "horizontal") {
            return 0;
        }
        if (this.parameters.style === "oblic") {
            return 45;
        }
        return 90;
    };
    return EleganceDoor;
}(Object3D/* Object3D */.T);


// EXTERNAL MODULE: ./src/@lib/Configurator3D/Materials.ts
var Materials = __webpack_require__(71170);
;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Elegance/Rattan.ts
/* eslint-disable */ 









var mediaBucketUrl = "https://images.renodoors.eu/";
var RattanDoor = /*#__PURE__*/ function(EleganceDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(RattanDoor, EleganceDoor);
    var _super = (0,_create_super/* default */.Z)(RattanDoor);
    function RattanDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, RattanDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "handleInner",
            "simpleSystem",
            "hamakSystem",
            "hiddenSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            woodBody: (0,_object_spread/* default */.Z)({}, Materials/* rattanMat */.Rv),
            woodFrame: (0,_object_spread/* default */.Z)({}, Materials/* pinewoodFrameMat */.Xw)
        };
        _this.parameters.handle = true;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = RattanDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        //  Set the parameters
        var doorStyle = attributes["door-style"] ? attributes["door-style"] : "density-1";
        var styleParams = doorStyle.split("-");
        this.parameters.style = styleParams[0];
        this.parameters.density = parseInt(styleParams[1], 10) || 1;
        this.parameters.system = "hamak";
        // Set the new texture
        var doorColor = attributes["door-color-rattan"] ? attributes["door-color-rattan"] : "rattan_pinewood_kamel";
        this.parameters.color = doorColor;
        var colorParams = doorColor.split("_");
        var systemColor = attributes["system-color"] ? attributes["system-color"] : "system-hamak-black";
        var systemcolorParams = systemColor.split("-");
        this.parameters.systemColor = systemColor;
        this.parameters.system = systemcolorParams[1];
        if ((0,Materials/* getRGBFromRAL */.Jj)(colorParams[colorParams.length - 1])) {
            this.materialDefinitions.woodFrame.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[colorParams.length - 1]);
            this.materialDefinitions.woodFrame.map = null;
        } else {
            this.materialDefinitions.woodFrame.color = null;
            this.materialDefinitions.woodFrame.map = "".concat(mediaBucketUrl, "textures/pinewood_").concat(colorParams[colorParams.length - 1], "_frame.jpg");
        }
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(systemcolorParams[systemcolorParams.length - 1]);
        this.updateMaterial(this.materials.woodBody, this.materialDefinitions.woodBody);
        this.updateMaterial(this.materials.woodFrame, this.materialDefinitions.woodFrame);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.calculateModelParameters = function calculateModelParameters() {
        this.parameters.frameWidth = 80;
        this.parameters.hangerMargin = isSystemHidden(this.parameters.system) ? 120 : this.parameters.frameWidth / 2;
        this.parameters.hangerOffset = isSystemHidden(this.parameters.system) ? 20 : -20;
        this.parameters.hangerHeightOffset = isSystemHidden(this.parameters.system) ? -100 : 1;
        this.parameters.railWidth = this.parameters.width - 2 * this.parameters.frameWidth;
        this.parameters.slatThickness = 18;
        this.parameters.slatCentering = 0;
        this.parameters.slatLength = (this.parameters.height - 2 * (this.parameters.frameWidth - this.parameters.frameGroove) - this.parameters.density * (this.parameters.frameWidth - 2 * this.parameters.frameGroove)) / (this.parameters.density + 1);
        this.parameters.slatWidth = this.parameters.width - 2 * (this.parameters.frameWidth - this.parameters.frameGroove);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Handle = this.buildHandleGeometry();
        var Hanger = this.buildHangerGeometry();
        if (Frame) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Frame), this.materials.woodFrame));
        }
        if (Body) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Body), this.materials.woodBody));
        }
        Handle.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return RattanDoor;
}(EleganceDoor);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Elegance/NewRustic.ts
/* eslint-disable */ 









var NewRustic_mediaBucketUrl = "https://images.renodoors.eu/";
var NewRusticDoor = /*#__PURE__*/ function(EleganceDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(NewRusticDoor, EleganceDoor);
    var _super = (0,_create_super/* default */.Z)(NewRusticDoor);
    function NewRusticDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, NewRusticDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "handleInner",
            "simpleSystem",
            "hamakSystem",
            "rollerSystem",
            "hiddenSystem", 
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            mirror: (0,_object_spread/* default */.Z)({}, Materials/* mirrorGlassMat */.zw),
            woodBody: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Materials/* pinewoodBodyMat */.Hr), {
                aoMapIntensity: 2.5
            }),
            woodFrame: (0,_object_spread/* default */.Z)({}, Materials/* pinewoodFrameMat */.Xw)
        };
        _this.parameters.handle = false;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = NewRusticDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        // Set the parameters
        var doorStyle = attributes["door-style"] ? attributes["door-style"] : "vertical-1";
        var styleParams = doorStyle.split("-");
        this.parameters.style = styleParams[0];
        this.parameters.density = typeof styleParams[1] === "undefined" ? 1 : +styleParams[1];
        this.parameters.system = attributes["system-style"] ? attributes["system-style"] : this.parameters.system;
        this.parameters.brace = braceStyle[styleParams[0]];
        // Set the new texture
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-oil"] ? attributes["door-color-oil"] : attributes["door-color-paint"] ? attributes["door-color-paint"] : "pinewood_ral9010";
        this.parameters.color = doorColor;
        var colorParams = doorColor.split("_");
        this.parameters.color = doorColor;
        if (/ral|ncs/.test(colorParams[1])) {
            this.materialDefinitions.woodFrame.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
            this.materialDefinitions.woodBody.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
            this.materialDefinitions.woodFrame.map = null;
            this.materialDefinitions.woodBody.map = null;
        } else {
            this.materialDefinitions.woodFrame.color = null;
            this.materialDefinitions.woodBody.color = null;
            this.materialDefinitions.woodFrame.map = "".concat(NewRustic_mediaBucketUrl, "textures/").concat(doorColor, "_frame.jpg");
            this.materialDefinitions.woodBody.map = "".concat(NewRustic_mediaBucketUrl, "textures/").concat(doorColor, "_body.jpg");
        }
        this.updateMaterial(this.materials.woodFrame, this.materialDefinitions.woodFrame);
        this.updateMaterial(this.materials.woodBody, this.materialDefinitions.woodBody);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Brace = this.parameters.brace ? this.buildBraceGeometry() : null;
        var Mirror = this.parameters.style === "mirror" ? this.buildMirrorGeometry() : null;
        //const Handle = this.buildHandleGeometry();
        var Hanger = this.buildHangerGeometry();
        if (Frame) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Frame), this.materials.woodFrame));
        }
        if (Body) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Body), this.materials.woodBody));
        }
        if (Brace) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Brace), this.materials.woodFrame));
        }
        if (Mirror) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Mirror), this.materials.mirror));
        }
        //Handle.forEach((geometry) => {
        // this.group.add(new Mesh(geometry, this.materials.metal));
        //});
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return NewRusticDoor;
}(EleganceDoor);


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Elegance/index.ts



;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Modern/Modern.ts
/* eslint-disable */ 








var ModernDoor = /*#__PURE__*/ function(EleganceDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(ModernDoor, EleganceDoor);
    var _super = (0,_create_super/* default */.Z)(ModernDoor);
    function ModernDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ModernDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        //  load the key resources
        _this.resourceManager.loadResources([
            "handleInner",
            "simpleSystem",
            "hamakSystem",
            "hiddenSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        //  Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            woodBody: {
                metalness: 0.3,
                roughness: 0.6
            },
            woodFrame: (0,_object_spread/* default */.Z)({}, Materials/* pinewoodFrameMat */.Xw)
        };
        _this.parameters.handle = true;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = ModernDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        //  Set the parameters
        var doorStyle = attributes["door-style"] ? attributes["door-style"] : "density-1";
        var styleParams = doorStyle.split("-");
        this.parameters.style = styleParams[0];
        this.parameters.density = parseInt(styleParams[1], 10) || 0;
        // Set the new texture
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-paint"] ? attributes["door-color-paint"] : "pinewood_ral9010";
        var colorParams = doorColor.split("_");
        this.parameters.color = doorColor;
        var systemColor = attributes["system-color"] ? attributes["system-color"] : "system-simple-black";
        var systemcolorParams = systemColor.split("-");
        this.parameters.systemColor = systemColor;
        this.parameters.system = systemcolorParams[1];
        this.materialDefinitions.woodFrame.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
        this.materialDefinitions.woodBody.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(systemcolorParams[systemcolorParams.length - 1]);
        this.updateMaterial(this.materials.woodFrame, this.materialDefinitions.woodFrame);
        this.updateMaterial(this.materials.woodBody, this.materialDefinitions.woodBody);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Handle = this.buildHandleGeometry();
        var Hanger = this.buildHangerGeometry();
        if (Frame) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Frame), this.materials.woodFrame));
        }
        if (Body) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Body), this.materials.woodBody));
        }
        Handle.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return ModernDoor;
}(EleganceDoor);
// const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Modern/Gladern.ts
/* eslint-disable */ 








var GladernDoor = /*#__PURE__*/ function(EleganceDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(GladernDoor, EleganceDoor);
    var _super = (0,_create_super/* default */.Z)(GladernDoor);
    function GladernDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, GladernDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        //  load the key resources
        _this.resourceManager.loadResources([
            "handleInner",
            "simpleSystem",
            "hamakSystem",
            "rollerSystem",
            "hiddenSystem", 
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        _this.materials = {
            metal: new three_module/* MeshStandardMaterial */.Wid(),
            milky: new three_module/* MeshPhysicalMaterial */.EJi(),
            transparent: new three_module/* MeshPhysicalMaterial */.EJi(),
            wood: new three_module/* MeshPhysicalMaterial */.EJi(),
            woodFrame: new three_module/* MeshStandardMaterial */.Wid()
        };
        //  Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            woodFrame: (0,_object_spread/* default */.Z)({}, Materials/* pinewoodFrameMat */.Xw),
            wood: {
                metalness: 0.15,
                roughness: 0.7
            },
            milky: (0,_object_spread/* default */.Z)({}, Materials/* milkyGlassMat */.RQ),
            transparent: (0,_object_spread/* default */.Z)({}, Materials/* transparentGlassMat */.id)
        };
        _this.parameters.handle = true;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = GladernDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        //  Set the parameters
        var doorStyle = attributes["door-style"] ? attributes["door-style"] : "density-1";
        var styleParams = doorStyle.split("-");
        this.parameters.style = styleParams[0];
        this.parameters.density = parseInt(styleParams[1], 10) || 0;
        this.parameters.system = attributes["system-style"] ? attributes["system-style"] : "simple";
        this.parameters.type = attributes["glass-type"] ? attributes["glass-type"] : "milky";
        // Set the new texture
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-paint"] ? attributes["door-color-paint"] : "pinewood_ral9010";
        var colorParams = doorColor.split("_");
        this.parameters.color = doorColor;
        var systemColor = attributes["system-color"] ? attributes["system-color"] : "system-simple-black";
        var systemcolorParams = systemColor.split("-");
        this.parameters.systemColor = systemColor;
        this.parameters.system = systemcolorParams[1];
        this.materialDefinitions.woodFrame.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
        this.materialDefinitions.wood.color = (0,Materials/* getRGBFromRAL */.Jj)(colorParams[1]);
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(systemcolorParams[systemcolorParams.length - 1]);
        this.updateMaterial(this.materials.woodFrame, this.materialDefinitions.woodFrame);
        this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Handle = this.buildHandleGeometry();
        var Hanger = this.buildHangerGeometry();
        if (Frame) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Frame), this.materials.woodFrame));
        }
        if (Body) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Body), this.materials[this.parameters.type]));
        }
        Handle.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return GladernDoor;
}(EleganceDoor);
// const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Modern/index.ts



;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Industrial/Base.ts
/* eslint-disable */ 






var IndustrialDoor = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0,_inherits/* default */.Z)(IndustrialDoor, Object3D);
    var _super = (0,_create_super/* default */.Z)(IndustrialDoor);
    function IndustrialDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, IndustrialDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _this.materials = {
            "double-mirror": new three_module/* MeshPhysicalMaterial */.EJi(),
            metal: new three_module/* MeshStandardMaterial */.Wid(),
            milky: new three_module/* MeshPhysicalMaterial */.EJi(),
            security: new three_module/* MeshPhysicalMaterial */.EJi(),
            transparent: new three_module/* MeshPhysicalMaterial */.EJi(),
            wood: new three_module/* MeshPhysicalMaterial */.EJi()
        };
        _this.parameters.frameWidth = 20;
        _this.parameters.frameThickness = 40;
        _this.parameters.frameMargin = 1;
        _this.parameters.materialThickness = 2;
        _this.parameters.parcloseDepth = 15;
        _this.parameters.glassThickness = 6;
        _this.parameters.hangerMargin = 90;
        _this.parameters.slatSize = 100;
        _this.parameters.slatThickness = 18;
        return _this;
    }
    var _proto = IndustrialDoor.prototype;
    _proto.calculateModelParameters = function calculateModelParameters() {
        this.parameters.parcloseLength = (this.parameters.height - (2 + this.parameters.density) * this.parameters.frameWidth) / (this.parameters.density + 1);
        this.parameters.parcloseWidth = this.parameters.width - 2 * (this.parameters.frameWidth + this.parameters.parcloseDepth);
        this.parameters.slatLength = (this.parameters.height - (2 + this.parameters.density) * this.parameters.frameWidth) / (this.parameters.density + 1);
        this.parameters.slatWidth = this.parameters.width - 2 * this.parameters.frameWidth;
    };
    _proto.buildSlatGeometry = function buildSlatGeometry() {
        var _loop = function(i) {
            slats.forEach(function(s) {
                var slat = s.clone();
                if (i % 2 === 0) {
                    slat = helpers/* MirrorObjectZ */.ri(slat, false);
                    slat.translate(0, 0, _this.parameters.slatLength);
                }
                slat.translate(_this.parameters.frameWidth, 0, _this.parameters.frameWidth + i * (_this.parameters.slatLength + _this.parameters.frameWidth));
                geometries.push(_this.updateGeometry(slat, Math.pow(-1, i) * slatsAngle));
            });
        };
        var _this = this;
        var geometries = [];
        /* create the base geometries */ var slats = helpers/* CreateSlats */.mp(this.parameters.slatWidth, this.parameters.slatLength, this.parameters.slatSize, this.parameters.slatThickness, this.parameters.style);
        var slatsAngle = this.getOrientation();
        /* create mirror and duplicate the elements */ for(var i = 0; i < this.parameters.density + 1; i++)_loop(i);
        slats.forEach(function(s) {
            s.dispose();
        }); // Clean geometries to avoid leak
        return geometries;
    };
    _proto.buildFrameGeometry = function buildFrameGeometry() {
        var geometries = [];
        /* create the base geometries */ var leftStile = helpers/* CreateOFrame */.yy(this.parameters.height, this.parameters.frameWidth, this.parameters.frameThickness, this.parameters.materialThickness, true, false, this.parameters.hangerMargin);
        var rightStile = helpers/* MirrorObjectX */.up(leftStile, true);
        var topRail = helpers/* CreateOFrame */.yy(this.parameters.width, this.parameters.frameWidth, this.parameters.frameThickness, this.parameters.materialThickness, true, this.parameters.system === "hamak" ? true : false, this.parameters.hangerMargin);
        var bottomRail = helpers/* CreateOFrame */.yy(this.parameters.width, this.parameters.frameWidth, this.parameters.frameThickness, this.parameters.materialThickness, true, false, this.parameters.hangerMargin);
        /* position the geometries */ leftStile.translate(0, -this.parameters.frameThickness / 2, 0);
        rightStile.translate(this.parameters.width, -this.parameters.frameThickness / 2, 0);
        helpers/* RotateObject */.JJ(topRail, null, 90, "Y");
        topRail.translate(0, -this.parameters.frameThickness / 2, this.parameters.height);
        helpers/* RotateObject */.JJ(bottomRail, null, -90, "Y");
        bottomRail.translate(this.parameters.width, -this.parameters.frameThickness / 2, 0);
        /* push the geometries into the array */ geometries.push(leftStile);
        geometries.push(rightStile);
        geometries.push(topRail);
        geometries.push(bottomRail);
        /* create the middle rail */ for(var i = 0; i < this.parameters.density; i++){
            var middleRail = helpers/* CreateOFrame */.yy(this.parameters.width - 2 * this.parameters.frameWidth, this.parameters.frameWidth, this.parameters.frameThickness, this.parameters.materialThickness, false, false, this.parameters.hangerMargin);
            helpers/* RotateObject */.JJ(middleRail, null, 90, "Y");
            middleRail.translate(this.parameters.frameWidth, -this.parameters.frameThickness / 2, this.parameters.frameWidth + (i + 1) * (this.parameters.frameWidth + this.parameters.parcloseLength));
            geometries.push(this.updateGeometry(middleRail));
        }
        return geometries;
    };
    _proto.buildParcloseGeometry = function buildParcloseGeometry() {
        var _loop = function(i) {
            parcloses.forEach(function(z) {
                if (i === 0) {
                    geometries.push(z);
                } else {
                    pcClone = z.clone();
                    pcClone.translate(0, 0, (_this.parameters.parcloseLength + _this.parameters.frameWidth) * i);
                    geometries.push(pcClone);
                }
            });
        };
        var _this = this;
        var geometries = [];
        var parcloses = [];
        /* Create the base objects */ var pcStile = helpers/* CreateOFrame */.yy(this.parameters.parcloseLength - 2 * this.parameters.frameMargin, this.parameters.parcloseDepth, this.parameters.parcloseDepth, this.parameters.materialThickness, false, false, this.parameters.hangerMargin);
        var pcRail = helpers/* CreateOFrame */.yy(this.parameters.parcloseWidth - 2 * this.parameters.frameMargin, this.parameters.parcloseDepth, this.parameters.parcloseDepth, this.parameters.materialThickness, false, false, this.parameters.hangerMargin);
        /* Position the first parclose square */ pcStile.translate(this.parameters.frameWidth + this.parameters.frameMargin, -this.parameters.frameThickness / 2, this.parameters.frameWidth + this.parameters.frameMargin);
        parcloses.push(pcStile);
        var pcClone = pcStile.clone();
        pcClone.translate(this.parameters.width - 2 * this.parameters.frameWidth - this.parameters.parcloseDepth - 2 * this.parameters.frameMargin, 0, 0);
        parcloses.push(pcClone);
        helpers/* RotateObject */.JJ(pcRail, null, 90, "Y");
        pcRail.translate(this.parameters.frameWidth + this.parameters.parcloseDepth + this.parameters.frameMargin, -this.parameters.frameThickness / 2, this.parameters.frameWidth + this.parameters.parcloseDepth + this.parameters.frameMargin);
        parcloses.push(pcRail);
        pcClone = pcRail.clone();
        pcClone.translate(0, 0, this.parameters.parcloseLength - this.parameters.parcloseDepth - 2 * this.parameters.frameMargin);
        parcloses.push(pcClone);
        /* Mirror the parclose to the other side */ var parclosesMirrored = [];
        parcloses.forEach(function(z) {
            pcClone = z.clone();
            pcClone.translate(0, _this.parameters.frameThickness - _this.parameters.parcloseDepth, 0);
            parclosesMirrored.push(pcClone);
        });
        parcloses = parcloses.concat(parclosesMirrored);
        /* Copy the parclose for each the cell */ for(var i = 0; i <= this.parameters.density; i++)_loop(i);
        return geometries;
    };
    _proto.buildDecoGeometry = function buildDecoGeometry() {
        var _loop = function(i) {
            decoration.forEach(function(z) {
                if (i === 0) {
                    geometries.push(z);
                } else {
                    var tmp = z.clone();
                    tmp.translate(0, 0, (_this.parameters.parcloseLength + _this.parameters.frameWidth) * i);
                    geometries.push(tmp);
                }
            });
        };
        var _this = this;
        var geometries = [];
        var decoration = [];
        /* Create the base objects */ var element = helpers/* CreateOFrame */.yy(this.parameters.parcloseLength - 2 * this.parameters.parcloseDepth - 4 * this.parameters.frameMargin, this.parameters.parcloseDepth, this.parameters.parcloseDepth, this.parameters.materialThickness, false, false, this.parameters.hangerMargin);
        element.translate(this.parameters.width / 2 - this.parameters.parcloseDepth / 2, -this.parameters.frameThickness / 2, this.parameters.frameWidth + this.parameters.parcloseDepth + 2 * this.parameters.frameMargin);
        decoration.push(element);
        var tmp = element.clone();
        tmp.translate(0, this.parameters.frameThickness - this.parameters.parcloseDepth, 0);
        decoration.push(tmp);
        /* Copy the element for each the cell */ for(var i = 0; i <= this.parameters.density; i++)_loop(i);
        return geometries;
    };
    _proto.buildBodyGeometry = function buildBodyGeometry() {
        var geometries = [];
        /* Create the base objects */ var plate = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(this.parameters.frameWidth, 0 - this.parameters.glassThickness / 2, this.parameters.frameWidth), new three_module/* Vector3 */.Pa4(this.parameters.frameWidth + this.parameters.parcloseWidth + 2 * this.parameters.parcloseDepth, 0 + this.parameters.glassThickness / 2, this.parameters.frameWidth + this.parameters.parcloseLength));
        var bodyAngle = this.getOrientation();
        /* Copy the element for each the cell */ for(var i = 0; i <= this.parameters.density; i++){
            if (i === 0) {
                geometries.push(this.updateGeometry(plate, Math.pow(-1, i + 1) * bodyAngle));
            } else {
                var tmp = plate.clone();
                tmp.translate(0, 0, i * (this.parameters.slatLength + this.parameters.frameWidth));
                geometries.push(this.updateGeometry(tmp, Math.pow(-1, i + 1) * bodyAngle));
            }
        }
        return geometries;
    };
    _proto.buildHangerGeometry = function buildHangerGeometry() {
        var _this = this;
        var geometries = [];
        var hangerOffset = -20;
        var hangerObj = this.resourceManager.getObject("wheelSystem");
        if (!hangerObj) {
            return [];
        }
        hangerObj.children.forEach(function(z) {
            var geom = z.geometry.clone();
            helpers/* RotateObject */.JJ(geom, null, 90, "X");
            geom.translate(_this.parameters.hangerMargin, hangerOffset, _this.parameters.height);
            var geom2 = geom.clone();
            geom2.translate(_this.parameters.width - 2 * _this.parameters.hangerMargin, 0, 0);
            if (_this.parameters.system === "hamak") {
                geometries.push(geom);
                geometries.push(geom2);
            }
        });
        // hangerObj.traverse((node) => {
        //   this.disposeObject(node);
        // }); // Clean geometries to avoid memory leak
        return geometries;
    };
    _proto.getOrientation = function getOrientation() {
        if (this.parameters.style === "horizontal") {
            return 0;
        }
        if (this.parameters.style === "oblic") {
            return 45;
        }
        return 90;
    };
    return IndustrialDoor;
}(Object3D/* Object3D */.T);


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Industrial/Atelier.ts
/* eslint-disable */ 








var AtelierDoor = /*#__PURE__*/ function(IndustrialDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(AtelierDoor, IndustrialDoor);
    var _super = (0,_create_super/* default */.Z)(AtelierDoor);
    function AtelierDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, AtelierDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "wheelSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            "double-mirror": Materials/* mirrorGlassMat */.zw,
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            milky: (0,_object_spread/* default */.Z)({}, Materials/* milkyGlassMat */.RQ),
            security: (0,_object_spread/* default */.Z)({}, Materials/* securityGlassMat */.Sy),
            transparent: (0,_object_spread/* default */.Z)({}, Materials/* transparentGlassMat */.id)
        };
        _this.parameters.parcloseDepth = 15;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = AtelierDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        this.parameters.style = attributes["door-style"] ? attributes["door-style"] : "4-0";
        this.parameters.type = attributes["glass-type"] ? attributes["glass-type"] : "milky";
        this.parameters.density = attributes.density ? attributes.density : 3;
        this.parameters.decoration = this.parameters.style === "verriere" ? 1 : 0;
        var doorColor = attributes["system-color"] ? attributes["system-color"] : "system-hamak-black";
        var doorColorParams = doorColor.split("-");
        this.parameters.system = doorColorParams[doorColorParams.length - 2];
        this.parameters.color = doorColorParams[doorColorParams.length - 1];
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(this.parameters.color);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        // const Body = this.buildSlatGeometry();
        var Body = this.buildBodyGeometry();
        var Parclose = this.buildParcloseGeometry();
        // const Decoration = this.parameters.style === 'verriere' ? this.buildDecoGeometry() : null;
        var Hanger = this.buildHangerGeometry();
        var metalNumber = this.parameters.style.split("-").length > 1 ? 4 - parseInt(this.parameters.style.split("-")[0], 10) : 0;
        Frame.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Body.forEach(function(geometry, index) {
            var type = _this.parameters.type;
            var material = index < metalNumber ? _this.materials.metal : _this.materials[type];
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, material));
        });
        if (Parclose) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Parclose), this.materials.metal));
        }
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return AtelierDoor;
}(IndustrialDoor);


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Industrial/Loft.ts
/* eslint-disable */ 









var Loft_mediaBucketUrl = "https://images.renodoors.eu/";
var LoftDoor = /*#__PURE__*/ function(IndustrialDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(LoftDoor, IndustrialDoor);
    var _super = (0,_create_super/* default */.Z)(LoftDoor);
    function LoftDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, LoftDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "wheelSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            wood: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Materials/* pinewoodBodyMat */.Hr), {
                aoMapIntensity: 2.5,
                uvScale: {
                    u: 3,
                    v: 3
                }
            })
        };
        _this.parameters.parcloseDepth = 10;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = LoftDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        var doorStyle = attributes["door-style"] ? attributes["door-style"] : "vertical-0";
        var styleParams = doorStyle.split("-");
        this.parameters.style = styleParams[0];
        this.parameters.density = 0;
        // Set the new texture
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-oil"] ? attributes["door-color-oil"] : "pinewood_oak";
        this.parameters.color = doorColor;
        this.materialDefinitions.wood.map = "".concat(Loft_mediaBucketUrl, "textures/1K/").concat(doorColor, ".jpg");
        this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Parclose = this.buildParcloseGeometry();
        var Hanger = this.buildHangerGeometry();
        Frame.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Body.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.wood));
        });
        // if (Body) {
        //   this.group.add(
        //     new Mesh(
        //      BufferGeometryUtils.mergeGeometries(Body),
        //      this.materials.wood
        //    )
        //  );
        // }
        if (Parclose) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Parclose), this.materials.metal));
        }
        // Decoration.forEach((geometry) => {
        //   this.group.add(
        //     new Mesh(
        //       geometry,
        //       this.materials.mirror
        //     )
        //   );
        // });
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return LoftDoor;
}(IndustrialDoor);


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Industrial/Verriere.ts
/* eslint-disable */ 








var VerriereDoor = /*#__PURE__*/ function(IndustrialDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(VerriereDoor, IndustrialDoor);
    var _super = (0,_create_super/* default */.Z)(VerriereDoor);
    function VerriereDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, VerriereDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "wheelSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            "double-mirror": Materials/* mirrorGlassMat */.zw,
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            milky: (0,_object_spread/* default */.Z)({}, Materials/* milkyGlassMat */.RQ),
            security: (0,_object_spread/* default */.Z)({}, Materials/* securityGlassMat */.Sy),
            transparent: (0,_object_spread/* default */.Z)({}, Materials/* transparentGlassMat */.id)
        };
        _this.parameters.parcloseDepth = 15;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = VerriereDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        this.parameters.style = attributes["door-style"] ? attributes["door-style"] : "glasso";
        this.parameters.type = attributes["glass-type"] ? attributes["glass-type"] : "milky";
        this.parameters.density = this.parameters.style === "glasso" ? 0 : 3;
        this.parameters.decoration = this.parameters.style === "verriere" ? 1 : 0;
        this.parameters.style === "verriere" ? 1 : 0;
        var doorColor = attributes["system-color"] ? attributes["system-color"] : "system-hamak-black";
        var doorColorParams = doorColor.split("-");
        this.parameters.system = doorColorParams[doorColorParams.length - 2];
        this.parameters.color = doorColorParams[doorColorParams.length - 1];
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(this.parameters.color);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        // const Body = this.buildSlatGeometry();
        var Body = this.buildBodyGeometry();
        var Parclose = this.buildParcloseGeometry();
        var Decoration = this.parameters.style === "verriere" ? this.buildDecoGeometry() : null;
        var Hanger = this.buildHangerGeometry();
        var metalNumber = this.parameters.style.split("-").length > 1 ? 4 - parseInt(this.parameters.style.split("-")[0], 10) : 0;
        Frame.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        Body.forEach(function(geometry, index) {
            var type = _this.parameters.type;
            var material = index < metalNumber ? _this.materials.metal : _this.materials[type];
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, material));
        });
        if (Parclose) {
            this.group.add(new three_module/* Mesh */.Kj0(BufferGeometryUtils/* mergeGeometries */.n4(Parclose), this.materials.metal));
        }
        if (Decoration) {
            Decoration.forEach(function(geometry) {
                _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
            });
        }
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -38;
    };
    return VerriereDoor;
}(IndustrialDoor);


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Industrial/index.ts




;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Lara/Lara.ts
/* eslint-disable */ 








var LaraDoor = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0,_inherits/* default */.Z)(LaraDoor, Object3D);
    var _super = (0,_create_super/* default */.Z)(LaraDoor);
    function LaraDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, LaraDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "wheelSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        _this.materials = {
            metal: new three_module/* MeshStandardMaterial */.Wid(),
            mirror: new three_module/* MeshPhysicalMaterial */.EJi(),
            wood: new three_module/* MeshStandardMaterial */.Wid()
        };
        // Define the materials
        _this.materialDefinitions = {
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            mirror: (0,_object_spread/* default */.Z)({}, Materials/* mirrorGlassMat */.zw),
            wood: {
                color: 0xffffff,
                roughness: 0.9
            }
        };
        _this.parameters.frameWidth = 28;
        _this.parameters.frameThickness = 2;
        _this.parameters.mirrorThickness = 4;
        _this.parameters.plateThickness = 18;
        _this.parameters.margin = 5;
        _this.parameters.hangerMargin = 90;
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = LaraDoor.prototype;
    _proto.calculateModelParameters = function calculateModelParameters() {
        this.parameters.delta = this.parameters.frameWidth - (2 * this.parameters.frameThickness + this.parameters.mirrorThickness + this.parameters.plateThickness);
    };
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        this.parameters.hangerMargin = 90;
        var doorColor = attributes["system-color"] ? attributes["system-color"] : "system-hamak-black";
        var doorColorParams = doorColor.split("-");
        this.parameters.system = doorColorParams[doorColorParams.length - 2];
        this.parameters.color = doorColorParams[doorColorParams.length - 1];
        this.materialDefinitions.metal.color = (0,Materials/* getRGBFromRAL */.Jj)(this.parameters.color);
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var Frame = this.buildFrameGeometry();
        var Body = this.buildBodyGeometry();
        var Mirror = this.buildMirrorGeometry();
        var Hanger = this.buildHangerGeometry();
        Frame.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        if (Body) {
            this.group.add(new three_module/* Mesh */.Kj0(Body, this.materials.wood));
        }
        if (Mirror) {
            this.group.add(new three_module/* Mesh */.Kj0(Mirror, this.materials.mirror));
        }
        Hanger.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(geometry, _this.materials.metal));
        });
        this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -this.parameters.frameWidth - 28;
    };
    _proto.buildFrameGeometry = function buildFrameGeometry() {
        var geometries = [];
        /* create the base geometries */ var leftStile = helpers/* CreateUFrame */.c5(this.parameters.height, this.parameters.frameWidth, false, this.parameters.hangerMargin);
        var rightStile = helpers/* MirrorObjectX */.up(leftStile, true);
        var topRail = helpers/* CreateUFrame */.c5(this.parameters.width, this.parameters.frameWidth, this.parameters.system === "hamak" ? true : false, this.parameters.hangerMargin);
        var bottomRail = helpers/* CreateUFrame */.c5(this.parameters.width, this.parameters.frameWidth, false, this.parameters.hangerMargin);
        /* position the geometries */ leftStile.translate(0, this.parameters.frameWidth, 0);
        rightStile.translate(this.parameters.width, this.parameters.frameWidth, 0);
        helpers/* RotateObject */.JJ(topRail, null, 90, "Y");
        topRail.translate(0, this.parameters.frameWidth, this.parameters.height);
        helpers/* RotateObject */.JJ(bottomRail, null, -90, "Y");
        bottomRail.translate(this.parameters.width, this.parameters.frameWidth, 0);
        /* push the geometries into the array */ geometries.push(leftStile);
        geometries.push(rightStile);
        geometries.push(topRail);
        geometries.push(bottomRail);
        return geometries;
    };
    _proto.buildBodyGeometry = function buildBodyGeometry() {
        // const geometries = [];
        /* Create the base objects */ var plate = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(this.parameters.margin, 2 * this.parameters.mirrorThickness, this.parameters.margin), new three_module/* Vector3 */.Pa4(this.parameters.width - this.parameters.margin, this.parameters.plateThickness + 2 * this.parameters.mirrorThickness, this.parameters.height - this.parameters.margin));
        // geometries.push(plate);
        return plate;
    };
    _proto.buildMirrorGeometry = function buildMirrorGeometry() {
        // const geometries = [];
        /* Create the base objects */ var plate = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(this.parameters.margin, this.parameters.delta / 2 + this.parameters.frameThickness + 2 * this.parameters.mirrorThickness, this.parameters.margin), new three_module/* Vector3 */.Pa4(this.parameters.width - this.parameters.margin, this.parameters.delta / 2 + this.parameters.frameThickness + 1 * this.parameters.mirrorThickness, this.parameters.height - this.parameters.margin));
        // geometries.push(plate);
        return plate;
    };
    _proto.buildHangerGeometry = function buildHangerGeometry() {
        var _this = this;
        var geometries = [];
        var hangerOffset = 4;
        var hangerObj = this.resourceManager.getObject("slimSystem");
        if (!hangerObj) {
            return [];
        }
        hangerObj.children.forEach(function(z) {
            var geom = z.geometry.clone();
            helpers/* RotateObject */.JJ(geom, null, 90, "X");
            geom.translate(_this.parameters.hangerMargin, hangerOffset, _this.parameters.height);
            var geom2 = geom.clone();
            geom2.translate(_this.parameters.width - 2 * _this.parameters.hangerMargin, 0, 0);
            if (_this.parameters.system === "hamak") {
                geometries.push(geom);
                geometries.push(geom2);
            }
        });
        hangerObj.traverse(function(node) {
            _this.disposeObject(node);
        }); // Clean geometries to avoid memory leak
        return geometries;
    };
    return LaraDoor;
}(Object3D/* Object3D */.T);

;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Lara/index.ts


;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Minimalist/Base.ts
/* eslint-disable */ 






var MinimalistDoor = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0,_inherits/* default */.Z)(MinimalistDoor, Object3D);
    var _super = (0,_create_super/* default */.Z)(MinimalistDoor);
    function MinimalistDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, MinimalistDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _this.materials = {
            handle: new three_module/* MeshStandardMaterial */.Wid(),
            metal: new three_module/* MeshStandardMaterial */.Wid(),
            wood: new three_module/* MeshStandardMaterial */.Wid()
        };
        _this.parameters.hangerMargin = 100;
        _this.parameters.sideBarWidth = 40;
        _this.parameters.doorThickness = 30;
        return _this;
    }
    var _proto = MinimalistDoor.prototype;
    _proto.calculateModelParameters = function calculateModelParameters() {
        this.parameters.panelHeights = helpers/* DecomposeMinimalistHeight */.XG(this.parameters.height);
        this.parameters.sideBarHeights = [
            this.parameters.panelHeights[0] + this.parameters.panelHeights[1] / 2,
            this.parameters.panelHeights[1] / 2 + this.parameters.panelHeights[2] + this.parameters.panelHeights[3] / 2,
            this.parameters.panelHeights[3] / 2 + this.parameters.panelHeights[4], 
        ];
    };
    _proto.buildSideBarGeometry = function buildSideBarGeometry() {
        var sideBars = [];
        var sideHeight = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.parameters.sideBarHeights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sideBarHeight = _step.value;
                var sideBarLeft = helpers/* CreateHalfRoundedRectangle */.ZI(0, 0, this.parameters.sideBarWidth, this.parameters.doorThickness, 10, sideBarHeight);
                var sideBarRight = helpers/* MirrorObjectX */.up(sideBarLeft, true);
                sideBarLeft.translate(this.parameters.sideBarWidth / 2, 0, sideHeight + sideBarHeight / 2);
                sideBarRight.translate(this.parameters.width - this.parameters.sideBarWidth / 2, 0, sideHeight + sideBarHeight / 2);
                sideBars.push(sideBarLeft);
                sideBars.push(sideBarRight);
                sideHeight += sideBarHeight;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return sideBars;
    };
    _proto.buildBodyGeometry = function buildBodyGeometry() {
        var panels = [];
        var sumHeight = 0;
        for(var i = 0; i < this.parameters.panelHeights.length; i++){
            var thickness = this.parameters.doorThickness;
            var width = this.parameters.width - 2 * this.parameters.sideBarWidth;
            var height = this.parameters.panelHeights[i];
            var handleMargin = void 0;
            var panel = helpers/* Box2Points */.IH(new three_module/* Vector3 */.Pa4(0, -thickness / 2, 0), new three_module/* Vector3 */.Pa4(width, +thickness / 2, height));
            if (i === 2) {
                var handleHole = void 0;
                if (this.parameters.style === "halfmoon") {
                    handleHole = helpers/* CreateHalfMoon */.C0(0, 0, 130, 357, 2 * thickness);
                } else {
                    // handleHole = Helpers.CreateRoundedRectangle(0,0,200 + 60,200 + 60 ,100 + 30,2 * thickness,true);
                    handleHole = new three_module/* CylinderGeometry */.fHI(130, 130, 2 * thickness, 32);
                    helpers/* RotateObject */.JJ(handleHole, null, 90, "X");
                }
                handleMargin = this.parameters.style === "halfmoon" ? 95 : 150;
                helpers/* RotateObject */.JJ(handleHole, null, 90, "X");
                handleHole.translate(handleMargin, 0, height / 2);
                panel = helpers/* BooleanDifference */.i1(panel, handleHole);
            }
            panel.translate(this.parameters.sideBarWidth, 0, sumHeight);
            panels.push(panel);
            sumHeight += this.parameters.panelHeights[i];
        }
        return panels;
    };
    _proto.buildHandleGeometry = function buildHandleGeometry() {
        var geometries = [];
        var handleMargin;
        var handleOffset = 19;
        var hangerObj = this.parameters.style === "halfmoon" ? helpers/* CreateHalfMoon */.C0(0, 0, 80, 280, 24) : helpers/* CreateRoundedRectangle */.QJ(0, 0, 200, 200, 100, 24, false);
        if (!hangerObj) {
            return [];
        }
        var geom = hangerObj.clone();
        helpers/* RotateObject */.JJ(geom, null, 90, "X");
        handleMargin = this.parameters.style === "halfmoon" ? 95 + this.parameters.sideBarWidth : 150 + this.parameters.sideBarWidth;
        geom.translate(handleMargin, -handleOffset, this.parameters.height / 2);
        var geomClone = helpers/* MirrorObjectY */.bs(geom, true);
        geometries.push(geom);
        geometries.push(geomClone);
        hangerObj.dispose(); // Clean geometries to avoid memory leak
        return geometries;
    };
    _proto.buildPlateGeometry = function buildPlateGeometry() {
        var geometries = [];
        var handleMargin;
        var handleOffset = 7;
        var handleObj = this.parameters.style === "halfmoon" ? helpers/* CreateHalfMoon */.C0(0, 0, 130, 357, 1) : helpers/* CreateRoundedRectangle */.QJ(0, 0, 200 + 60, 200 + 60, 100 + 30, 1, false);
        if (!handleObj) {
            return [];
        }
        var geom = handleObj.clone();
        helpers/* RotateObject */.JJ(geom, null, 90, "X");
        handleMargin = this.parameters.style === "halfmoon" ? 95 + this.parameters.sideBarWidth : 150 + this.parameters.sideBarWidth;
        geom.translate(handleMargin, -handleOffset, this.parameters.height / 2);
        var geomClone = helpers/* MirrorObjectY */.bs(geom, true);
        geometries.push(geom);
        geometries.push(geomClone);
        handleObj.dispose(); // Clean geometries to avoid memory leak
        return geometries;
    };
    _proto.buildHangerGeometry = function buildHangerGeometry() {
        var _this = this;
        var geometries = [];
        var hangerOffset = 20;
        var hangerDimension = 120;
        var heightOffset = 100;
        var hangerObj = this.resourceManager.getObject("hiddenSystem");
        if (!hangerObj) {
            return [];
        }
        hangerObj.children.forEach(function(z) {
            var geom = z.geometry.clone();
            helpers/* RotateObject */.JJ(geom, null, 90, "X");
            geom.translate(hangerDimension + _this.parameters.hangerMargin, hangerOffset, _this.parameters.height - heightOffset);
            var geom2 = geom.clone();
            geom2.translate(_this.parameters.width - _this.parameters.hangerMargin - 2 * hangerDimension, 0, 0);
            geometries.push(geom);
            geometries.push(geom2);
        });
        hangerObj.traverse(function(node) {
            _this.disposeObject(node);
        }); // Clean geometries to avoid memory leak
        return geometries;
    };
    return MinimalistDoor;
}(Object3D/* Object3D */.T);

;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Minimalist/Foresso.ts
/* eslint-disable */ 







var Foresso_mediaBucketUrl = "https://images.renodoors.eu/";
var ForessoDoor = /*#__PURE__*/ function(MinimalistDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(ForessoDoor, MinimalistDoor);
    var _super = (0,_create_super/* default */.Z)(ForessoDoor);
    function ForessoDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ForessoDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "hiddenSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            handle: (0,_object_spread/* default */.Z)({}, Materials/* foressoMat */.ZP),
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            wood: (0,_object_spread/* default */.Z)({}, Materials/* ashwoodMat */.RV)
        };
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = ForessoDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        // Set the parameters
        this.parameters.style = attributes["door-style"] ? attributes["door-style"] : "round";
        // Set the new door color
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-ash"] ? attributes["door-color-ash"] : "ashwood_natural";
        // Set the handle color
        var handleColor = attributes["handle-color"] ? attributes["handle-color"] : "light_ral9005";
        var handleParams = handleColor.split("_");
        var texture = handleParams[0];
        var color = (0,Materials/* getRGBFromRAL */.Jj)(handleParams[1]);
        this.materialDefinitions.wood.map = "".concat(Foresso_mediaBucketUrl, "textures/").concat(doorColor, ".jpg");
        // this.materialDefinitions.wood.color = 0x0000FF;
        this.materialDefinitions.metal.color = color;
        this.materialDefinitions.handle.map = "".concat(Foresso_mediaBucketUrl, "textures/foresso_").concat(texture, ".jpg");
        // Update the material
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
        this.updateMaterial(this.materials.handle, this.materialDefinitions.handle);
        this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var SideBar = this.buildSideBarGeometry();
        var Body = this.buildBodyGeometry();
        var Handle = this.buildHandleGeometry();
        var Plate = this.buildPlateGeometry();
        // const Hanger = this.buildHangerGeometry();
        SideBar.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry, 90), _this.materials.wood));
        });
        Body.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry, 0, 2048, 1), _this.materials.wood));
        });
        Handle.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry), _this.materials.handle));
        });
        Plate.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry), _this.materials.metal));
        });
        /* Hanger.forEach((geometry) => {
      this.group.add(
        new Mesh(
          geometry,
          this.materials.metal
        )
      );
    });*/ this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -35;
    };
    return ForessoDoor;
}(MinimalistDoor);

;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Minimalist/RedDot.ts
/* eslint-disable */ 







var RedDot_mediaBucketUrl = "https://images.renodoors.eu/";
var RedDotDoor = /*#__PURE__*/ function(MinimalistDoor) {
    "use strict";
    (0,_inherits/* default */.Z)(RedDotDoor, MinimalistDoor);
    var _super = (0,_create_super/* default */.Z)(RedDotDoor);
    function RedDotDoor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, RedDotDoor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        var attributes = args[0];
        // load the key resources
        _this.resourceManager.loadResources([
            "hiddenSystem"
        ], function() {
            _this.update(attributes);
            _this.renderFunc();
        });
        // Define the materials
        _this.materialDefinitions = {
            handle: (0,_object_spread/* default */.Z)({}, Materials/* ashwoodMat */.RV),
            metal: (0,_object_spread/* default */.Z)({}, Materials/* metalMat */.hP),
            wood: (0,_object_spread/* default */.Z)({}, Materials/* ashwoodMat */.RV)
        };
        _this.initMaterials();
        _this.update(attributes);
        return _this;
    }
    var _proto = RedDotDoor.prototype;
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        // Set the parameters
        this.parameters.style = attributes["door-style"] ? attributes["door-style"] : "round";
        // Set the new door color
        var doorColor = attributes["door-color"] ? attributes["door-color"] : attributes["door-color-ash"] ? attributes["door-color-ash"] : "ashwood_natural";
        // Set the handle color
        var handleColor = attributes["handle-color"] ? attributes["handle-color"] : "light_ral9005";
        var handleParams = handleColor.split("_");
        var color = (0,Materials/* getRGBFromRAL */.Jj)(handleParams[1]);
        this.materialDefinitions.wood.map = "".concat(RedDot_mediaBucketUrl, "textures/").concat(doorColor, ".jpg");
        // this.materialDefinitions.wood.color = 0x0000FF;
        this.materialDefinitions.metal.color = color;
        this.materialDefinitions.handle.color = color;
        // this.materialDefinitions.handle.map = `${mediaBucketUrl}textures/${doorColor}.jpg`;
        // Update the material
        this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
        this.updateMaterial(this.materials.handle, this.materialDefinitions.handle);
        this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
    };
    _proto.buildModel = function buildModel() {
        var _this = this;
        var SideBar = this.buildSideBarGeometry();
        var Body = this.buildBodyGeometry();
        var Handle = this.buildHandleGeometry();
        var Plate = this.buildPlateGeometry();
        // const Hanger = this.buildHangerGeometry();
        SideBar.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry, 90), _this.materials.wood));
        });
        Body.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry, 0, 2048, 1), _this.materials.wood));
        });
        Handle.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry), _this.materials.handle));
        });
        Plate.forEach(function(geometry) {
            _this.group.add(new three_module/* Mesh */.Kj0(_this.updateGeometry(geometry), _this.materials.metal));
        });
        /* Hanger.forEach((geometry) => {
      this.group.add(
        new Mesh(
          geometry,
          this.materials.metal
        )
      );
    });*/ this.group.children.forEach(function(z) {
            z.castShadow = true;
            z.receiveShadow = true;
        });
        this.group.position.y = -35;
    };
    return RedDotDoor;
}(MinimalistDoor);

;// CONCATENATED MODULE: ./src/@lib/Configurator3D/Minimalist/index.ts



;// CONCATENATED MODULE: ./src/@lib/Configurator3D/ModelFactory.ts
/* eslint-disable */ 




var ModelFactory = function(type, attributes, render, maxAnisotropy, resourceManager) {
    var types = {
        "atelier-style": AtelierDoor,
        "barndoor-style-1": NewRusticDoor,
        "barndoor-style-2": NewRusticDoor,
        "industrial-style": VerriereDoor,
        "loft-style": LoftDoor,
        "minimalist-style": ForessoDoor,
        "dot-style": RedDotDoor,
        // 'minimalist-style': RedDotDoor,
        // 'minimalist-style-2': ForessoDoor,
        "modern-style": ModernDoor,
        "gladern-style": GladernDoor,
        "rattan-style": RattanDoor,
        // 'modern-style': RattanOilDoor,
        // 'rattan-style-1': ModernDoor,
        "rustic-style-1": NewRusticDoor,
        "rustic-style-2": NewRusticDoor,
        "wardrobe-style": LaraDoor,
        "mirror-style": LaraDoor,
        "elegance-style": NewRusticDoor
    };
    var DoorModel = types[type];
    return DoorModel ? new DoorModel(attributes, render, maxAnisotropy, resourceManager) : new NewRusticDoor(attributes, render, maxAnisotropy, resourceManager);
};
var isMinimalist = function(type) {
    var types = [
        "minimalist-style",
        "dot-style",
        "bamboo-style"
    ];
    return types.includes(type);
};
var isSystemHidden = function(type) {
    var types = [
        "hidden",
        "system-hidden-black",
        "system-hidden-white"
    ];
    return types.includes(type);
};
var isSystemTop = function(type) {
    var types = [
        "top",
        "system-top-black",
        "system-top-white"
    ];
    return types.includes(type);
};
var isDot = function(type) {
    var types = [
        "dot-style"
    ];
    return types.includes(type);
};


/***/ }),

/***/ 67880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Object3D; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99477);
/* harmony import */ var three_examples_jsm_renderers_CSS2DRenderer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81764);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54622);
/* eslint-disable */ 




var Object3D = /*#__PURE__*/ function() {
    "use strict";
    function Object3D() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Object3D);
        this.group = new three__WEBPACK_IMPORTED_MODULE_2__/* .Group */ .ZAu();
        this.group.castShadow = true;
        this.group.receiveShadow = true;
        this.materialDefinitions = {};
        this.materials = {};
        this.attributes = {};
        this.parameters = {};
        this.renderFunc = args[1];
        this.maxAnisotropy = args[2];
        this.resourceManager = args[3];
        this.index = 0;
        this.indexShift = Math.round(Math.random() * 100);
        this.symmetrical = false;
    }
    var _proto = Object3D.prototype;
    _proto.update = function update(attributes) {
        this.index = this.indexShift;
        for(var i = this.group.children.length - 1; i >= 0; i--){
            this.disposeObject(this.group.children[i]);
            this.group.remove(this.group.children[i]);
        }
        this.updateModelAttributes(attributes);
        this.updateModelParameters(attributes);
        this.calculateModelParameters();
        if (!attributes.hidden) {
            this.buildModel();
            this.renderFunc();
        }
    };
    _proto.buildModel = function buildModel() {
        throw new Error("Each model need a buildModel function!");
    };
    _proto.updateModelAttributes = function updateModelAttributes(attributes) {
        /* assign the attributes */ this.attributes = attributes;
        /* update the standard parameters */ this.parameters.width = +(attributes.width || this.parameters.width);
        this.parameters.height = +(attributes.height || this.parameters.height);
        this.parameters.track = +(attributes.track || this.parameters.track);
        this.parameters.double = attributes.configuration === "configuration-double" ? true : false;
        this.parameters.orientation = attributes.orientation === "orientation-right" ? "right" : "left";
        this.symmetrical = this.parameters.orientation === "right";
    };
    _proto.updateModelParameters = function updateModelParameters(attributes) {
        throw new Error("Each model need a updateModelParamters function!");
    };
    _proto.calculateModelParameters = function calculateModelParameters() {
        throw new Error("Each model need a calculateModelParameters function!");
    };
    _proto.initMaterials = function initMaterials() {
        var _this = this;
        Object.keys(this.materials).forEach(function(key) {
            _this.setMaterial(_this.materials[key], _this.materialDefinitions[key]);
        });
    };
    _proto.setMaterial = function setMaterial(material, mtlDefinition) {
        var _this = this;
        if (material && mtlDefinition) {
            // Name
            if (mtlDefinition.name) {
                material.name = mtlDefinition.name;
            }
            // Side
            if (mtlDefinition.side) {
                material.side = mtlDefinition.side;
            }
            // Color
            if (mtlDefinition.color) {
                material.color.set(mtlDefinition.color);
            // material.color.setHex(mtlDefinition.color).convertSRGBToLinear();
            } else {
                material.color.set(null);
            }
            // Albedo
            if (mtlDefinition.map) {
                this.resourceManager.getTexture(mtlDefinition.map, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    if (mtlDefinition.colorSpace) {
                        texture.colorSpace = mtlDefinition.colorSpace;
                    }
                    texture.needsUpdate = true;
                    material.map = texture;
                });
            } else {
                material.map = null;
            }
            // Normal
            if (mtlDefinition.normalMap) {
                this.resourceManager.getTexture(mtlDefinition.normalMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    //if (mtlDefinition.wrap === MirroredRepeatWrapping) {
                    //  texture.wrapS = MirroredRepeatWrapping;
                    //  texture.wrapT = MirroredRepeatWrapping;
                    //} else {
                    texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    //}
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.normalMap = texture;
                    if (mtlDefinition.normalScale) {
                        material.normalScale = new three__WEBPACK_IMPORTED_MODULE_2__/* .Vector2 */ .FM8(mtlDefinition.normalScale.x, mtlDefinition.normalScale.y);
                    }
                });
            } else {
                material.normalMap = null;
            }
            // Bump
            if (mtlDefinition.bumpMap) {
                this.resourceManager.getTexture(mtlDefinition.bumpMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.bumpMap = texture;
                });
            } else {
                material.bumpMap = null;
            }
            if (mtlDefinition.bumpScale) {
                material.bumpScale = mtlDefinition.bumpScale;
            }
            // Displacement
            if (mtlDefinition.displacementMap) {
                this.resourceManager.getTexture(mtlDefinition.displacementMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.displacementMap = texture;
                    if (mtlDefinition.displacementScale) {
                        material.displacementScale = mtlDefinition.displacementScale;
                    }
                    if (mtlDefinition.displacementBias) {
                        material.displacementBias = mtlDefinition.displacementBias;
                    }
                });
            } else {
                material.displacementMap = null;
            }
            // Roughness
            if (mtlDefinition.roughnessMap) {
                this.resourceManager.getTexture(mtlDefinition.roughnessMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.roughnessMap = texture;
                });
            } else {
                material.roughnessMap = null;
            }
            if (mtlDefinition.roughness) {
                material.roughness = mtlDefinition.roughness;
            }
            // Metalness
            if (mtlDefinition.metalnessMap === "") {
                this.resourceManager.getTexture(mtlDefinition.metalnessMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.metalnessMap = texture;
                });
            } else {
                material.metalnessMap = null;
            }
            if (mtlDefinition.metalness) {
                material.metalness = mtlDefinition.metalness;
            }
            // Alpha
            if (mtlDefinition.alphaMap) {
                this.resourceManager.getTexture(mtlDefinition.alphaMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.alphaMap = texture;
                });
            } else {
                material.alphaMap = null;
            }
            if (mtlDefinition.opacity) {
                material.opacity = mtlDefinition.opacity;
            }
            // AO
            if (mtlDefinition.aoMap) {
                this.resourceManager.getTexture(mtlDefinition.aoMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    //if (mtlDefinition.wrap === MirroredRepeatWrapping) {
                    //  texture.wrapS = MirroredRepeatWrapping;
                    //  texture.wrapT = MirroredRepeatWrapping;
                    //} else {
                    texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    //}
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.aoMap = texture;
                });
            } else {
                material.aoMap = null;
            }
            if (mtlDefinition.aoMapIntensity) {
                material.aoMapIntensity = mtlDefinition.aoMapIntensity;
            }
            // Emissive
            if (mtlDefinition.emissiveMap) {
                this.resourceManager.getTexture(mtlDefinition.emissiveMap, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .LinearMipMapLinearFilter */ .FDw;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    if (mtlDefinition.colorSpace) {
                        texture.colorSpace = mtlDefinition.colorSpace;
                    }
                    texture.needsUpdate = true;
                    material.emissiveMap = texture;
                    if (mtlDefinition.emissiveIntensity) {
                        material.emissiveIntensity = mtlDefinition.emissiveIntensity;
                    }
                });
                material.emissiveMap = null;
            } else {
                material.emissiveMap = null;
            }
            if (mtlDefinition.emissive) {
                material.emissive.set(mtlDefinition.emissive);
            // material.emissive.setHex(mtlDefinition.emissive).convertSRGBToLinear();
            }
            // Env
            if (mtlDefinition.envMapIntensity) {
                material.envMapIntensity = mtlDefinition.envMapIntensity;
            }
            if (mtlDefinition.wireframe) {
                material.wireframe = mtlDefinition.wireframe;
            }
            if (mtlDefinition.transparent) {
                material.transparent = mtlDefinition.transparent;
            }
            // PBR
            if (mtlDefinition.transmission) {
                material.transmission = mtlDefinition.transmission;
            }
            if (mtlDefinition.thickness) {
                material.thickness = mtlDefinition.thickness;
            }
            if (mtlDefinition.clearcoat) {
                material.clearcoat = mtlDefinition.clearcoat;
            }
            if (mtlDefinition.clearcoatRoughness) {
                material.clearcoatRoughness = mtlDefinition.clearcoatRoughness;
            }
            // MeshPhongMaterial
            if (mtlDefinition.reflectivity) {
                material.reflectivity = mtlDefinition.reflectivity;
            }
            material.needsUpdate = true;
            this.renderFunc();
        }
    };
    _proto.updateMaterial = function updateMaterial(material, mtlDefinition) {
        var _this = this;
        if (material && mtlDefinition) {
            // Color
            if (mtlDefinition.color) {
                material.color.set(mtlDefinition.color);
            // material.color.setHex(mtlDefinition.color).convertSRGBToLinear();
            } else {
                material.color.set(null);
            }
            // Albedo
            if (mtlDefinition.map) {
                this.resourceManager.getTexture(mtlDefinition.map, function(texture) {
                    if (mtlDefinition.uvScale) {
                        texture.repeat.set(mtlDefinition.uvScale.u, mtlDefinition.uvScale.v);
                    }
                    if (mtlDefinition.wrap === three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA) {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .MirroredRepeatWrapping */ .OoA;
                    } else {
                        texture.wrapS = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                        texture.wrapT = three__WEBPACK_IMPORTED_MODULE_2__/* .RepeatWrapping */ .rpg;
                    }
                    texture.anisotropy = _this.maxAnisotropy;
                    texture.minFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestMipMapLinearFilter */ .vZf;
                    texture.magFilter = three__WEBPACK_IMPORTED_MODULE_2__/* .NearestFilter */ .TyD;
                    texture.needsUpdate = true;
                    material.map = texture;
                    if (mtlDefinition.colorSpace) {
                        material.map.colorSpace = mtlDefinition.colorSpace;
                    }
                });
            } else {
                material.map = null;
            }
            // Emissive
            if (mtlDefinition.emissive) {
                material.emissive.set(mtlDefinition.emissive);
            // material.emissive.setHex(mtlDefinition.emissive).convertSRGBToLinear();
            }
            material.needsUpdate = true;
            this.renderFunc();
        }
    };
    _proto.applyMaterial = function applyMaterial(obj, material) {
        var dispose = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (!this.isRenderItem(obj)) {
            return;
        }
        if (dispose && obj.material) {
            this.disposeMaterial(obj);
        }
        obj.material = material;
    };
    _proto.updatePosition = function updatePosition(cameraPosition) {
        var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        /* determine the position of the camera ie front or back of the door */ var pos = cameraPosition.clone();
        var zoom = Math.abs(pos.y) < 2 ? 1 : 0;
        pos.normalize;
        var shift = 0;
        var slide = shift ? shift : open ? zoom : 1;
        // const flip = shift ? shift : zoom;
        var overlap = 50;
        /* set the default position of the object */ this.group.position.z = -this.parameters.height / 2 - 100;
        if (this.parameters.double) {
            this.group.position.x = this.parameters.orientation === "right" ? -(this.parameters.width - overlap) * (1 - slide) + -this.parameters.width : (this.parameters.width - overlap) * (1 - slide);
        } else {
            this.group.position.x = this.parameters.orientation === "right" ? -this.parameters.width * (1 - slide) - overlap * slide : -(this.parameters.width - overlap) * slide;
        }
    };
    _proto.updateGeometry = function updateGeometry(geometry) {
        var angle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1024, vScale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        this.index++;
        if (this.symmetrical) {
            geometry = _helpers__WEBPACK_IMPORTED_MODULE_0__/* .MirrorObjectX */ .up(geometry, false);
            geometry.translate(this.parameters.width, 0, 0);
        }
        _helpers__WEBPACK_IMPORTED_MODULE_0__/* .updateUVs */ .Vf(geometry, this.symmetrical ? -angle : angle, this.index, size, vScale);
        return geometry;
    };
    _proto.isRenderItem = function isRenderItem(obj) {
        return "geometry" in obj && "material" in obj;
    };
    _proto.disposeMaterial = function disposeMaterial(obj) {
        if (!this.isRenderItem(obj)) {
            return;
        }
        var materials = [].concat(obj.material);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = materials[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var material = _step.value;
                material.dispose();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.disposeObject = function disposeObject(obj) {
        // Handle CSS2DObject specifically
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(obj, three_examples_jsm_renderers_CSS2DRenderer_js__WEBPACK_IMPORTED_MODULE_4__/* .CSS2DObject */ .j)) {
            if (obj.element && obj.element.parentNode) {
                obj.element.parentNode.removeChild(obj.element);
            }
            obj = null;
            return;
        }
        // Recursively dispose children
        while(obj.children.length > 0){
            this.disposeObject(obj.children[0]);
            obj.remove(obj.children[0]);
        }
        // Dispose geometry and material
        if (obj.geometry) {
            obj.geometry.dispose();
        }
        if (obj.material) {
            this.disposeMaterial(obj.material);
        }
    // Remove from parent
    //if (obj.parent) {
    //    obj.parent.remove(obj);
    //}
    // Clear references
    //obj = null;
    };
    return Object3D;
}();


/***/ }),

/***/ 54622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AD": function() { return /* binding */ createArrow; },
/* harmony export */   "C0": function() { return /* binding */ CreateHalfMoon; },
/* harmony export */   "G3": function() { return /* binding */ CreateTopRail; },
/* harmony export */   "Gs": function() { return /* binding */ createCSSLabel; },
/* harmony export */   "IH": function() { return /* binding */ Box2Points; },
/* harmony export */   "JJ": function() { return /* binding */ RotateObject; },
/* harmony export */   "PR": function() { return /* binding */ CreateLeftStyle; },
/* harmony export */   "QJ": function() { return /* binding */ CreateRoundedRectangle; },
/* harmony export */   "Qu": function() { return /* binding */ CreateMiddleRail; },
/* harmony export */   "Us": function() { return /* binding */ CreateRightStyle; },
/* harmony export */   "Vf": function() { return /* binding */ updateUVs; },
/* harmony export */   "XG": function() { return /* binding */ DecomposeMinimalistHeight; },
/* harmony export */   "ZI": function() { return /* binding */ CreateHalfRoundedRectangle; },
/* harmony export */   "bS": function() { return /* binding */ CreateBrace; },
/* harmony export */   "bs": function() { return /* binding */ MirrorObjectY; },
/* harmony export */   "c5": function() { return /* binding */ CreateUFrame; },
/* harmony export */   "e0": function() { return /* binding */ CreateTrack; },
/* harmony export */   "i1": function() { return /* binding */ BooleanDifference; },
/* harmony export */   "mp": function() { return /* binding */ CreateSlats; },
/* harmony export */   "qN": function() { return /* binding */ CreateBottomRail; },
/* harmony export */   "ri": function() { return /* binding */ MirrorObjectZ; },
/* harmony export */   "s1": function() { return /* binding */ CreateHandleInnerHole; },
/* harmony export */   "up": function() { return /* binding */ MirrorObjectX; },
/* harmony export */   "yy": function() { return /* binding */ CreateOFrame; }
/* harmony export */ });
/* unused harmony exports BooleanUnion, BooleanIntersection, flipBufferGeometryNormals, CreateSlat */
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99477);
/* harmony import */ var three_examples_jsm_renderers_CSS2DRenderer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81764);
/* harmony import */ var three_examples_jsm_utils_BufferGeometryUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40140);
/* harmony import */ var three_csg_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85609);
/* eslint-disable */ 


/*
import {
  ADDITION,
  SUBTRACTION,
  INTERSECTION,
  Brush,
  Evaluator,
} from 'three-bvh-csg';*/ 
var Offsets = GenerateOffsets(200);
/* Texture offset Helper functions */ function GenerateOffsets(number) {
    var arr = [
        {
            x: 0,
            y: 0
        }
    ];
    for(var i = 0; i < number; i++){
        arr.push({
            x: Math.random() / 2,
            y: Math.random() / 2
        });
    }
    return arr;
}
/* Generic object manipulation Helper functions */ function GeometryToMesh(geo) {
    return new three__WEBPACK_IMPORTED_MODULE_1__/* .Mesh */ .Kj0(geo);
}
function MeshToGeometry(mesh) {
    return mesh.geometry;
}
function BooleanUnion(geo) {
    for(var _len = arguments.length, geos = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        geos[_key - 1] = arguments[_key];
    }
    var mesh = GeometryToMesh(geo);
    geos.forEach(function(g) {
        return mesh = three_csg_ts__WEBPACK_IMPORTED_MODULE_0__/* .CSG.union */ .y.union(mesh, GeometryToMesh(g));
    });
    return MeshToGeometry(mesh);
}
function BooleanDifference(geo1, geo2) {
    var csg1 = GeometryToMesh(geo1);
    var csg2 = GeometryToMesh(geo2);
    return MeshToGeometry(three_csg_ts__WEBPACK_IMPORTED_MODULE_0__/* .CSG.subtract */ .y.subtract(csg1, csg2));
}
function BooleanIntersection(geo1, geo2) {
    var csg1 = GeometryToMesh(geo1);
    var csg2 = GeometryToMesh(geo2);
    return MeshToGeometry(three_csg_ts__WEBPACK_IMPORTED_MODULE_0__/* .CSG.intersect */ .y.intersect(csg1, csg2));
}
/*
export function BooleanUnion(geo, ...geos) {
  const csgEvaluator = new Evaluator();
  let finalBrush = new Brush(geo);
  geos.forEach((g) => {
    const brush = new Brush(g);
    finalBrush = csgEvaluator.evaluate(finalBrush, brush, ADDITION);
  });

  return finalBrush.geometry;
}
*/ /*
export function BooleanDifference(geo1, geo2) {
  const csgEvaluator = new Evaluator();
  const brush1 = new Brush(geo1);
  const brush2 = new Brush(geo2);

  const result = csgEvaluator.evaluate(brush1, brush2, SUBTRACTION);

  return result.geometry;
}*/ /*
function BooleanIntersectionBHV(geo1, geo2) {
  const csgEvaluator = new Evaluator();
  const brush1 = new Brush(geo1);
  const brush2 = new Brush(geo2);

  const result = csgEvaluator.evaluate(brush1, brush2, INTERSECTION);

  return result.geometry;
}*/ function RotateObject(obj, point, angle) {
    var axis = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "X";
    // let tempPosition = new Vector3();
    // tempPosition.copy(obj.position);
    // obj.position.set(point);
    if (axis == "X") {
        obj.rotateX(angle * Math.PI / 180);
    }
    if (axis == "Y") {
        obj.rotateY(angle * Math.PI / 180);
    }
    if (axis == "Z") {
        obj.rotateZ(angle * Math.PI / 180);
    }
// obj.position.set(tempPosition);
}
function flipBufferGeometryNormals(geometry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var tempXYZ = [
        0,
        0,
        0
    ];
    if (geometry.index) geometry = geometry;
    // flip normals
    for(var i = 0; i < (geometry === null || geometry === void 0 ? void 0 : (ref = geometry.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.normal) === null || ref1 === void 0 ? void 0 : ref1.array.length) / 9; i++){
        // cache a coordinates
        tempXYZ[0] = geometry.attributes.normal.array[i * 9];
        tempXYZ[1] = geometry.attributes.normal.array[i * 9 + 1];
        tempXYZ[2] = geometry.attributes.normal.array[i * 9 + 2];
        // overwrite a with c
        geometry.attributes.normal.array[i * 9] = geometry.attributes.normal.array[i * 9 + 6];
        geometry.attributes.normal.array[i * 9 + 1] = geometry.attributes.normal.array[i * 9 + 7];
        geometry.attributes.normal.array[i * 9 + 2] = geometry.attributes.normal.array[i * 9 + 8];
        // overwrite c with stored a values
        geometry.attributes.normal.array[i * 9 + 6] = tempXYZ[0];
        geometry.attributes.normal.array[i * 9 + 7] = tempXYZ[1];
        geometry.attributes.normal.array[i * 9 + 8] = tempXYZ[2];
    }
    // change face winding order
    for(var i1 = 0; i1 < (geometry === null || geometry === void 0 ? void 0 : (ref2 = geometry.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.array.length) / 9; i1++){
        // cache a coordinates
        tempXYZ[0] = geometry.attributes.position.array[i1 * 9];
        tempXYZ[1] = geometry.attributes.position.array[i1 * 9 + 1];
        tempXYZ[2] = geometry.attributes.position.array[i1 * 9 + 2];
        // overwrite a with c
        geometry.attributes.position.array[i1 * 9] = geometry.attributes.position.array[i1 * 9 + 6];
        geometry.attributes.position.array[i1 * 9 + 1] = geometry.attributes.position.array[i1 * 9 + 7];
        geometry.attributes.position.array[i1 * 9 + 2] = geometry.attributes.position.array[i1 * 9 + 8];
        // overwrite c with stored a values
        geometry.attributes.position.array[i1 * 9 + 6] = tempXYZ[0];
        geometry.attributes.position.array[i1 * 9 + 7] = tempXYZ[1];
        geometry.attributes.position.array[i1 * 9 + 8] = tempXYZ[2];
    }
    // flip UV coordinates
    for(var i2 = 0; i2 < (geometry === null || geometry === void 0 ? void 0 : (ref4 = geometry.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.uv) === null || ref5 === void 0 ? void 0 : ref5.array.length) / 6; i2++){
        // cache a coordinates
        tempXYZ[0] = geometry.attributes.uv.array[i2 * 6];
        tempXYZ[1] = geometry.attributes.uv.array[i2 * 6 + 1];
        // overwrite a with c
        geometry.attributes.uv.array[i2 * 6] = geometry.attributes.uv.array[i2 * 6 + 4];
        geometry.attributes.uv.array[i2 * 6 + 1] = geometry.attributes.uv.array[i2 * 6 + 5];
        // overwrite c with stored a values
        geometry.attributes.uv.array[i2 * 6 + 4] = tempXYZ[0];
        geometry.attributes.uv.array[i2 * 6 + 5] = tempXYZ[1];
    }
    if (geometry === null || geometry === void 0 ? void 0 : (ref6 = geometry.attributes) === null || ref6 === void 0 ? void 0 : ref6.normal) {
        geometry.attributes.normal.needsUpdate = true;
    }
    if (geometry === null || geometry === void 0 ? void 0 : (ref7 = geometry.attributes) === null || ref7 === void 0 ? void 0 : ref7.position) {
        geometry.attributes.position.needsUpdate = true;
    }
    if (geometry === null || geometry === void 0 ? void 0 : (ref8 = geometry.attributes) === null || ref8 === void 0 ? void 0 : ref8.uv) {
        geometry.attributes.uv.needsUpdate = true;
    }
}
function MirrorObjectX(obj) {
    var copy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var obj2 = obj;
    if (copy) {
        obj2 = obj.clone();
    }
    obj2.applyMatrix4(new three__WEBPACK_IMPORTED_MODULE_1__/* .Matrix4 */ .yGw().makeScale(-1, 1, 1));
    flipBufferGeometryNormals(obj2);
    return obj2;
}
function MirrorObjectY(obj) {
    var copy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var obj2 = obj;
    if (copy) {
        obj2 = obj.clone();
    }
    obj2.applyMatrix4(new three__WEBPACK_IMPORTED_MODULE_1__/* .Matrix4 */ .yGw().makeScale(1, -1, 1));
    flipBufferGeometryNormals(obj2);
    return obj2;
}
function MirrorObjectZ(obj) {
    var copy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var obj2 = obj;
    if (copy) {
        obj2 = obj.clone();
    }
    obj2.applyMatrix4(new three__WEBPACK_IMPORTED_MODULE_1__/* .Matrix4 */ .yGw().makeScale(1, 1, -1));
    flipBufferGeometryNormals(obj2);
    return obj2;
}
function updateUVs(geometry, angle, index) {
    var size = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1024, vScale = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    if (geometry) {
        var ref, ref1, ref2, ref3;
        if (geometry.index) {
            geometry = geometry;
        }
        if (geometry === null || geometry === void 0 ? void 0 : (ref = geometry.attributes) === null || ref === void 0 ? void 0 : ref.normal) {
            geometry.attributes.normal.needsUpdate = true;
        }
        if (geometry === null || geometry === void 0 ? void 0 : (ref1 = geometry.attributes) === null || ref1 === void 0 ? void 0 : ref1.position) {
            geometry.attributes.position.needsUpdate = true;
        }
        if (geometry === null || geometry === void 0 ? void 0 : (ref2 = geometry.attributes) === null || ref2 === void 0 ? void 0 : ref2.uv) {
            geometry.attributes.uv.needsUpdate = true;
        }
        if (geometry === null || geometry === void 0 ? void 0 : (ref3 = geometry.attributes) === null || ref3 === void 0 ? void 0 : ref3.color) {
            geometry.deleteAttribute("color");
        }
        if (!geometry.boundingBox) geometry.computeBoundingBox();
        var _boundingBox = geometry.boundingBox, min = _boundingBox.min, max = _boundingBox.max;
        var range = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(max.x - min.x, max.y - min.y, max.z - min.z);
        // const min = {x:0, y:0, z:0}
        var offsetX = Offsets[index].x;
        var offsetY = Offsets[index].y;
        for(var i = 0; i < geometry.attributes.position.count; i = i + 3){
            var faceUVs = [
                new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8(),
                new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8(),
                new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8()
            ];
            var va = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(geometry.attributes.position.array[3 * i], geometry.attributes.position.array[3 * i + 1], geometry.attributes.position.array[3 * i + 2]);
            var vb = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(geometry.attributes.position.array[3 * i + 3], geometry.attributes.position.array[3 * i + 4], geometry.attributes.position.array[3 * i + 5]);
            var vc = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(geometry.attributes.position.array[3 * i + 6], geometry.attributes.position.array[3 * i + 7], geometry.attributes.position.array[3 * i + 8]);
            var vab = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4().copy(vb).sub(va);
            var vac = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4().copy(vc).sub(va);
            var vcross = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4().copy(vab).cross(vac);
            vcross.set(Math.abs(vcross.x), Math.abs(vcross.y), Math.abs(vcross.z));
            var majorAxis = vcross.x > vcross.y ? vcross.x > vcross.z ? "x" : vcross.y > vcross.z ? "y" : vcross.y > vcross.z : vcross.y > vcross.z ? "y" : "z";
            var uAxis = majorAxis == "x" ? "y" : majorAxis == "y" ? "x" : "x";
            var vAxis = majorAxis == "x" ? "z" : majorAxis == "y" ? "z" : "y";
            // let min = va;
            faceUVs[0].set((va[uAxis] - min[uAxis]) / size + offsetX, (va[vAxis] - min[vAxis]) / size + offsetY);
            faceUVs[1].set((vb[uAxis] - min[uAxis]) / size + offsetX, (vb[vAxis] - min[vAxis]) / size + offsetY);
            faceUVs[2].set((vc[uAxis] - min[uAxis]) / size + offsetX, (vc[vAxis] - min[vAxis]) / size + offsetY);
            /*
      faceUVs[0].set(
        (va[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (va[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );
      faceUVs[1].set(
        (vb[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (vb[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );
      faceUVs[2].set(
        (vc[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (vc[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );*/ if (angle) {
                faceUVs[0].rotateAround(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8(0, 0), -angle * Math.PI / 180);
                faceUVs[1].rotateAround(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8(0, 0), -angle * Math.PI / 180);
                faceUVs[2].rotateAround(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector2 */ .FM8(0, 0), -angle * Math.PI / 180);
            }
            faceUVs[0].y = faceUVs[0].y * vScale;
            faceUVs[1].y = faceUVs[1].y * vScale;
            faceUVs[2].y = faceUVs[2].y * vScale;
            // faceUVs[0].y = faceUVs[0].y;
            // faceUVs[1].y = faceUVs[1].y;
            // faceUVs[2].y = faceUVs[2].y;
            geometry.attributes.uv.array[2 * i] = faceUVs[0].x;
            geometry.attributes.uv.array[2 * i + 1] = faceUVs[0].y;
            geometry.attributes.uv.array[2 * i + 2] = faceUVs[1].x;
            geometry.attributes.uv.array[2 * i + 3] = faceUVs[1].y;
            geometry.attributes.uv.array[2 * i + 4] = faceUVs[2].x;
            geometry.attributes.uv.array[2 * i + 5] = faceUVs[2].y;
        }
        geometry.elementsNeedUpdate = geometry.verticesNeedUpdate = true;
    // geometry.computeBoundingSphere();
    // geometry.computeVertexNormals();
    }
}
/* Generic Object Helper functions */ function Box2Points(p1, p2) {
    var geometry = new three__WEBPACK_IMPORTED_MODULE_1__/* .BoxGeometry */ .DvJ(Math.abs(p1.x - p2.x), Math.abs(p1.y - p2.y), Math.abs(p1.z - p2.z));
    geometry.translate(Math.min(p1.x, p2.x) + Math.abs(p1.x - p2.x) / 2, Math.min(p1.y, p2.y) + Math.abs(p1.y - p2.y) / 2, Math.min(p1.z, p2.z) + Math.abs(p1.z - p2.z) / 2);
    return geometry.toNonIndexed();
}
function AddCylinderY(x, z, y1, y2, radius) {
    var obj = new three__WEBPACK_IMPORTED_MODULE_1__/* .CylinderGeometry */ .fHI(radius, radius, Math.abs(y1 - y2), 32);
    obj.translate(x, (y1 + y2) / 2, z);
    return obj;
}
function AddCylinderZ(x, y, z1, z2, radius) {
    var obj = new three__WEBPACK_IMPORTED_MODULE_1__/* .CylinderGeometry */ .fHI(radius, radius, Math.abs(z1 - z2), 16);
    obj.translate(x, y, (z1 + z2) / 2);
    RotateObject(obj, null, 90, "X");
    return obj;
}
function AddCylinderZ2(x, y, z1, z2, radius) {
    var obj = new CylinderGeometry(radius, radius, Math.abs(z1 - z2), 16);
    // obj.translate(x,y,(z1+z2)/2);
    RotateObject(obj, null, 90, "X");
    obj.translate(x, y, (z1 + z2) / 2);
    return obj;
}
//TO REFACTOR
function CreateRoundedRectangleZ(width, height, depth, r) {
    var box1 = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, r), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, depth, height - r));
    var box2 = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(r, 0, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width - r, depth, height));
    var cyl1 = AddCylinderY(r, r, 0, depth, r);
    var cyl2 = AddCylinderY(width - r, r, 0, depth, r);
    var cyl3 = AddCylinderY(width - r, height - r, 0, depth, r);
    var cyl4 = AddCylinderY(r, height - r, 0, depth, r);
    return BooleanUnion(box1, box2, cyl1, cyl2, cyl3, cyl4);
}
//function CreateRoundedRectangle(x: number, y: number, width: number, height: number, radius: number, thickness: number, quadraticCorners = false) {
function CreateRoundedRectangle(x, y, width, height, radius, thickness) {
    var quadraticCorners = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    var roundedRectShape = new three__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .bnF();
    var geom;
    if (quadraticCorners) {
        // Quadratic corners (can look better, more bubbly)
        roundedRectShape.moveTo(x, y + radius);
        roundedRectShape.lineTo(x, y + height - radius);
        roundedRectShape.quadraticCurveTo(x, y + height, x + radius, y + height);
        roundedRectShape.lineTo(x + width - radius, y + height);
        roundedRectShape.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
        roundedRectShape.lineTo(x + width, y + radius);
        roundedRectShape.quadraticCurveTo(x + width, y, x + width - radius, y);
        roundedRectShape.lineTo(x + radius, y);
        roundedRectShape.quadraticCurveTo(x, y, x, y + radius);
    } else {
        // Circular corners (matches DOM's rounded borders)
        roundedRectShape.absarc(x + width - radius, y + radius, radius, -Math.PI / 2, 0, false);
        roundedRectShape.absarc(x + width - radius, y + height - radius, radius, 0, Math.PI / 2, false);
        roundedRectShape.absarc(x + radius, y + height - radius, radius, Math.PI / 2, Math.PI, false);
        roundedRectShape.absarc(x + radius, y + radius, radius, Math.PI, Math.PI + Math.PI / 2, false);
        roundedRectShape.lineTo(x + width - radius, y); // complete the loop
    }
    if (thickness > 0) {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ExtrudeGeometry */ .O7d(roundedRectShape, {
            bevelEnabled: true,
            steps: 1,
            bevelSegments: 1,
            bevelSize: 0,
            bevelThickness: 0,
            depth: thickness
        });
    } else {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ShapeGeometry */ .oa8(roundedRectShape);
    }
    return geom.translate(-width / 2, -height / 2, -thickness / 2);
}
function CreateHalfRoundedRectangle(x, y, width, height, radius, thickness) {
    var roundedRectShape = new three__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .bnF();
    var geom;
    // Quadratic corners (can look better, more bubbly)
    roundedRectShape.moveTo(x, y + radius);
    roundedRectShape.lineTo(x, y + height - radius);
    roundedRectShape.quadraticCurveTo(x, y + height, x + radius, y + height);
    roundedRectShape.lineTo(x + width, y + height);
    roundedRectShape.lineTo(x + width, y);
    roundedRectShape.lineTo(x + radius, y);
    roundedRectShape.quadraticCurveTo(x, y, x, y + radius);
    if (thickness > 0) {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ExtrudeGeometry */ .O7d(roundedRectShape, {
            bevelEnabled: true,
            steps: 1,
            bevelSegments: 1,
            bevelSize: 0,
            bevelThickness: 0,
            depth: thickness
        }).toNonIndexed();
    } else {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ShapeGeometry */ .oa8(roundedRectShape).toNonIndexed();
    }
    return geom.translate(-width / 2, -height / 2, -thickness / 2);
}
function CreateHalfMoon(x, y, width, height, thickness) {
    var shape = new three__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .bnF();
    var geom;
    var radius = (width * width + height * height / 4) / (2 * width);
    var startAngle = Math.asin(height / (2 * radius));
    // Quadratic corners
    shape.moveTo(x, y);
    shape.arc(width - radius, 0, radius, startAngle, -startAngle, true);
    shape.lineTo(x, y);
    if (thickness > 0) {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ExtrudeGeometry */ .O7d(shape, {
            bevelEnabled: true,
            steps: 1,
            bevelSegments: 1,
            bevelSize: 0,
            bevelThickness: 0,
            depth: thickness
        }).toNonIndexed();
    } else {
        geom = new three__WEBPACK_IMPORTED_MODULE_1__/* .ShapeGeometry */ .oa8(shape).toNonIndexed();
    }
    return geom.translate(-width / 2, 0, -thickness / 2);
}
/* Track Helper functions */ function CreateTrack() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 800, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    var object = new three__WEBPACK_IMPORTED_MODULE_1__/* .BoxGeometry */ .DvJ(length, thickness, width).toNonIndexed();
    object.translate(length / 2, thickness / 2, 0);
    return object;
}
/* Hanger Helper functions */ function CreateLoftHanger() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 40, heigth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 80, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6, radius = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5.05;
    var con1 = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(-width / 2, 0, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width / 2, heigth, thickness));
    var con2 = AddCylinderZ(0, thickness / 2, 0, thickness, width / 2);
    con2.translate(0, heigth, 0);
    var object = BooleanUnion(con1, con2);
    var con3 = AddCylinderZ(0, thickness / 2, -thickness, 2 * thickness, radius);
    con3.translate(0, heigth, 0);
    object = BooleanDifference(object, con3);
    RotateObject(object, (0, 0), 90, "Y");
    RotateObject(object, (0, 0), 90, "Z");
    return object;
}
/* Lara Helper functions */ function CreateUFrame() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 28, hanger = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, hanger_margin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 90;
    var object = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, width, length));
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(-1, 0, 0);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width + 1, width + 1, 2 * width);
    var box1 = Box2Points(pt0, pt1);
    var box2 = box1.clone();
    RotateObject(box1, (0, 0), -45, "X");
    RotateObject(box2, (0, length - width), 45, "X");
    box2.translate(0, 0, length - width);
    box2.translate(0, width, 0);
    object = BooleanDifference(object, box1);
    object = BooleanDifference(object, box2);
    RotateObject(object, null, -90, "Z");
    if (hanger) {
        var h1 = CreateLoftHanger();
        h1.translate(0, -40 + 6 * 2, 0);
        var h2 = h1.clone();
        h1.translate(0, 0.01, length - hanger_margin);
        h2.translate(0, 0.01, hanger_margin);
        object = BooleanUnion(object, h1, h2);
    }
    return object;
}
/* Industrial Helper functions */ function CreateOFrame() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 900, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 40, thickness = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2, mitter = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, hanger = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, hanger_margin = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 90;
    var object = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, depth, length));
    //const obj2 = Box2Points(
    //  new Vector3(thickness, thickness, 0),
    //  new Vector3(width - thickness, depth - thickness, length)
    //);
    //let object = BooleanDifference(obj1, obj2);
    if (mitter) {
        var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0);
        var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(Math.max(width, depth), Math.max(width, depth), 2 * Math.max(width, depth));
        var box1 = Box2Points(pt0, pt1);
        var box2 = box1.clone();
        RotateObject(box1, (0, 0), 45, "Y");
        RotateObject(box2, (0, 0), -45, "Y");
        box2.translate(Math.max(width, depth), 0, length - Math.max(width, depth));
        object = BooleanDifference(object, box1);
        object = BooleanDifference(object, box2);
    }
    if (hanger) {
        var h1 = CreateLoftHanger();
        var h2 = CreateLoftHanger();
        h1.translate(0, 0.01, length - hanger_margin);
        h2.translate(0, 0.01, hanger_margin);
        object = BooleanUnion(object, h1, h2);
    }
    return object;
}
/* Elegance Helper functions */ function CreateLeftStyle() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 120, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2100, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 40, gw = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, gd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 20, bg = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 6;
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - gw) / 2, 0);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width - gd, (thickness - gw) / 2 + gw, length);
    var box1 = Box2Points(pt0, pt1);
    var pt2 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0);
    var pt3 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, (thickness - gw) / 2, length);
    var box2 = Box2Points(pt2, pt3);
    var box3 = box2.clone();
    box3.translate(0, (thickness - gw) / 2 + gw, 0);
    var pt4 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - bg) / 2, 0);
    var pt5 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, (thickness - bg) / 2 + bg, bg);
    var box4 = Box2Points(pt4, pt5);
    var object = BooleanUnion(box1, box2, box3);
    object = BooleanDifference(object, box4);
    object.translate(-width / 2, -thickness / 2, 0);
    return object;
}
function CreateRightStyle() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 120, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2100, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 40, gw = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, gd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 20, bg = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 6;
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd, (thickness - gw) / 2, 0);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, (thickness - gw) / 2 + gw, length);
    var box1 = Box2Points(pt0, pt1);
    var pt2 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0);
    var pt3 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, (thickness - gw) / 2, length);
    var box2 = Box2Points(pt2, pt3);
    var box3 = box2.clone();
    box3.translate(0, (thickness - gw) / 2 + gw, 0);
    var pt4 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - bg) / 2, 0);
    var pt5 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(width, (thickness - bg) / 2 + bg, bg);
    var box4 = Box2Points(pt4, pt5);
    var object = BooleanUnion(box1, box2, box3);
    object = BooleanDifference(object, box4);
    object.translate(-width / 2, -thickness / 2, 0);
    return object;
}
function CreateTopRail() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 120, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 560, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 40, gw = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, gd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 20;
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - gw) / 2, gd);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(2 * gd + length, (thickness - gw) / 2 + gw, width);
    var box1 = Box2Points(pt0, pt1);
    var pt2 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd, 0, 0);
    var pt3 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd + length, (thickness - gw) / 2, width);
    var box2 = Box2Points(pt2, pt3);
    var box3 = box2.clone();
    box3.translate(0, (thickness - gw) / 2 + gw, 0);
    var object = BooleanUnion(box1, box2, box3);
    object.translate(-length / 2, -thickness / 2, 0);
    return object;
}
function CreateBottomRail() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 120, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 560, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 40, gw = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, gd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 20, bg = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 6;
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - gw) / 2, 0);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(2 * gd + length, (thickness - gw) / 2 + gw, width - gd);
    var box1 = Box2Points(pt0, pt1);
    var pt2 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd, 0, 0);
    var pt3 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd + length, (thickness - gw) / 2, width);
    var box2 = Box2Points(pt2, pt3);
    var box3 = box2.clone();
    box3.translate(0, (thickness - gw) / 2 + gw, 0);
    var object = BooleanUnion(box1, box2, box3);
    object.translate(-length / 2, -thickness / 2, 0);
    return object;
}
function CreateMiddleRail() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 120, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 560, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 36, gw = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, gd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 20;
    var pt0 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, (thickness - gw) / 2, gd);
    var pt1 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(2 * gd + length, (thickness - gw) / 2 + gw, width - gd);
    var box1 = Box2Points(pt0, pt1);
    var pt2 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd, 0, 0);
    var pt3 = new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(gd + length, (thickness - gw) / 2, width);
    var box2 = Box2Points(pt2, pt3);
    var box3 = box2.clone();
    box3.translate(0, (thickness - gw) / 2 + gw, 0);
    var object = BooleanUnion(box2, box3);
    object.translate(-length / 2, -thickness / 2, 0);
    return object;
}
function CreateBrace() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 700, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2100, brace_width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 120, thickness = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 10, style = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "/", th = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    var list = [];
    var b = width / (height - brace_width);
    var alpha1 = -b + Math.sqrt(b * b + (height + brace_width) / (height - brace_width));
    var alpha2 = -b - Math.sqrt(b * b + (height + brace_width) / (height - brace_width));
    var theta = 90 - 2 * Math.atan(alpha1) * 180 / Math.PI;
    var box = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(brace_width, thickness, height * 2));
    RotateObject(box, new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), theta, "Y");
    var cut1 = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, height - 1), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(2 * width, thickness, 2 * height - 1));
    var cut2 = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 1), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(2 * width, thickness, -height + 1));
    var object1 = BooleanDifference(box, cut1);
    object1 = BooleanDifference(object1, cut2);
    if (style == "/") {
        list.push(object1);
    }
    if (style == "L") {
        object1 = MirrorObjectZ(object1, false);
        object1.translate(0, 0, height);
        list.push(object1);
    }
    if (style != "/" && style != "L") {
        // style x
        object1 = MirrorObjectZ(object1, false);
        var object2 = MirrorObjectZ(object1, true);
        object1.translate(0, 0, height);
        var object3 = BooleanIntersection(object1, object2);
        object3.center();
        object3.scale(1.1, 1, 1.1);
        object3.translate(width / 2, 0, height / 2);
        list.push(object1);
        list.push(BooleanDifference(object2, object3));
    }
    return {
        list: list,
        theta: theta
    };
}
function CreateCurveByPoints(points, depth) {
    var shape = new three__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .bnF();
    shape.moveTo(points[0][0], points[0][1]);
    points.forEach(function(z, index) {
        if (index == 0) return;
        shape.lineTo(z[0], z[1]);
    });
    var extrudeSettings = {
        bevelEnabled: false,
        depth: depth
    };
    var geometry = new three__WEBPACK_IMPORTED_MODULE_1__/* .ExtrudeGeometry */ .O7d(shape, extrudeSettings);
    return geometry;
}
function CreateSlat() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2100, thickness = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18, chamfer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5;
    var points = [
        [
            chamfer,
            0
        ],
        [
            width - chamfer,
            0
        ],
        [
            width,
            chamfer
        ],
        [
            width,
            thickness - chamfer
        ],
        [
            width - chamfer,
            thickness
        ],
        [
            chamfer,
            thickness
        ],
        [
            0,
            thickness - chamfer
        ],
        [
            0,
            chamfer
        ], 
    ];
    var geometry = CreateCurveByPoints(points, length);
    geometry.translate(0, -thickness / 2, 0);
    return geometry;
}
function CreateSlats() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 700, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2100, slat_size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100, thickness = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 18, style = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "vertical";
    var internal_width;
    var internal_length;
    if (style == "horizontal") {
        internal_width = length;
        length = width;
        width = internal_width;
    }
    if (style == "oblic") {
        internal_width = width;
        internal_length = length;
        length = width = length + width;
    }
    var full_slats_count = Math.trunc(width / slat_size);
    var slat_ends_width = (width - full_slats_count * slat_size) / 2;
    if (slat_ends_width < thickness / 3) {
        full_slats_count -= 2;
        slat_ends_width = slat_size;
    }
    var slat_length = length;
    var slats = [];
    slats.push(CreateSlat(slat_ends_width, slat_length, thickness));
    for(var i = 0; i < full_slats_count; i++){
        slats.push(CreateSlat(slat_size, slat_length, thickness));
    }
    slats.push(CreateSlat(slat_ends_width, slat_length, thickness));
    for(var i1 = 0; i1 < full_slats_count + 1; i1++){
        slats[i1 + 1].translate(slat_ends_width + i1 * slat_size, 0, 0);
    }
    var bufferSlats = three_examples_jsm_utils_BufferGeometryUtils__WEBPACK_IMPORTED_MODULE_2__/* .mergeGeometries */ .n4(slats);
    if (style == "horizontal") {
        RotateObject(bufferSlats, new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), 90, "Y");
        bufferSlats.translate(0, 0, internal_width);
        return [
            bufferSlats
        ];
    }
    if (style == "oblic") {
        var oblic_cube = Box2Points(new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, -10, 0), new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(internal_width, 10, internal_length));
        RotateObject(bufferSlats, new three__WEBPACK_IMPORTED_MODULE_1__/* .Vector3 */ .Pa4(0, 0, 0), -45, "Y");
        bufferSlats.translate(internal_width / Math.sqrt(2), 0, -internal_width / Math.sqrt(2));
        return [
            BooleanIntersection(bufferSlats, oblic_cube)
        ];
    // return [BooleanIntersectionBHV(bufferSlats, oblic_cube)];
    }
    return [
        bufferSlats
    ];
}
function CreateHandleInnerHole() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 40, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 160, radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 12;
    var object = CreateRoundedRectangleZ(width, height, radius, depth);
    object.translate(-width / 2, -depth / 2, -height / 2);
    return object;
}
/* Minimalist Helper functions */ function DecomposeMinimalistHeight(height) {
    var switcher = {
        2000: [
            400,
            400,
            400,
            400,
            400
        ],
        2100: [
            400,
            400,
            500,
            400,
            400
        ],
        2200: [
            400,
            450,
            500,
            450,
            400
        ],
        2300: [
            450,
            450,
            500,
            450,
            450
        ],
        2400: [
            450,
            500,
            500,
            500,
            450
        ],
        2500: [
            500,
            500,
            500,
            500,
            500
        ]
    };
    return switcher[height] ? switcher[height] : [
        450,
        450,
        500,
        450,
        450
    ];
}
/* Function to create a CSS text label */ function createCSSLabel(text, position) {
    var div = document.createElement("div");
    // div.style.width = '100px';
    // div.style.height = '30px';
    div.style.opacity = 0.6;
    div.style.background = "white";
    div.style.border = "1px solid grey";
    div.style.color = "grey";
    // div.style.boxShadow = '0 0 10px rgba(0,0,0,0.5)';
    div.innerHTML = text;
    div.style.textAlign = "center";
    div.style.fontSize = "0.8em";
    // div.style.lineHeight = '30px';
    div.style.padding = "5px";
    div.style.borderRadius = "5px";
    var label = new three_examples_jsm_renderers_CSS2DRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* .CSS2DObject */ .j(div);
    label.position.copy(position);
    return label;
}
/* Function to create arrows */ function createArrow(from, to, color) {
    var arrowGroup = new three__WEBPACK_IMPORTED_MODULE_1__/* .Group */ .ZAu();
    var direction = from.clone().sub(to);
    var length = direction.length();
    arrowGroup.add(new three__WEBPACK_IMPORTED_MODULE_1__/* .ArrowHelper */ .tGC(direction.normalize(), from, length, "grey", 50, 20));
    direction.negate();
    arrowGroup.add(new three__WEBPACK_IMPORTED_MODULE_1__/* .ArrowHelper */ .tGC(direction.normalize(), from, length, "grey", 50, 20));
    return arrowGroup;
}


/***/ }),

/***/ 77427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion_Accordion; },
  "Q": function() { return /* reexport */ AccordionItem_AccordionItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/Context.ts
/* eslint-disable @typescript-eslint/no-empty-function */ 
var initialContext = {
    keys: [],
    setKeys: function() {},
    handleToggle: function() {},
    expanded: [],
    disabled: []
};
var AccordionContext = react.createContext(initialContext);
/* harmony default export */ var Context = (AccordionContext);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 83vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.disabled > button {\n    color: ",
        ";\n    cursor: default;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 20px;\n      right: 9px;\n      margin-top: -10px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 12px;\n      right: 5px;\n      margin-top: -6px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 20px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  transition: color 0.8s;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.1em;\n  display: block;\n  padding: ",
        ";\n  position: relative;\n  width: 100%;\n  text-align: left;\n\n  &:before,\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: ",
        ";\n    transition: background-color 0.6s, opacity 0.4s, transform 0.4s;\n  }\n  &:before {\n    width: 2px;\n    height: 24px;\n    top: 50%;\n    margin-top: -12px;\n    right: 11px;\n    ",
        "\n    ",
        "\n  }\n  &:after {\n    height: 2px;\n    width: 24px;\n    top: 50%;\n    margin-top: -1px;\n    right: 0;\n    ",
        "\n    ",
        "\n  }\n  * {\n    font: inherit;\n    line-height: inherit;\n    color: inherit;\n  }\n  &:hover {\n    color: ",
        ";\n    ",
        "\n  }\n  &.expanded {\n    color: ",
        ";\n    &:after {\n      background-color: ",
        ";\n    }\n    &:before {\n      transform: rotate(90deg);\n      opacity: 0;\n      background-color: $red;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  transition: max-height 0.8s;\n  will-change: max-height;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.6em;\n  &.collapsed {\n    overflow: hidden;\n    max-height: 0;\n    transition: all 0.5s cubic-bezier(0, 1, 0.3, 1) -100ms;\n  }\n  &.expanded {\n    max-height: 2000px;\n    transition: all 0.5s cubic-bezier(1, 0.15, 1, 1);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Accordion = globalStyles/* styled.div */.zo.div(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()));
var AccordionItem = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.colors.disabled;
});
var Header = globalStyles/* styled.button */.zo.button(_templateObject8(), function(props) {
    return props.theme.colors.baseFontColorOpacityLight;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " ").concat(spacing.spacer, " ").concat(spacing.spacer, " 0");
}, function(props) {
    return props.theme.colors.blueLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()), function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7(), function(props) {
    return props.theme.colors.baseFontColorOpacityLight;
}), function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
});
var Body = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/Accordion.tsx






var Accordion_Accordion = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _expanded;
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState((_expanded = props.expanded) !== null && _expanded !== void 0 ? _expanded : []), 2), expanded = _$ref[0], setExpanded = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), keys = _$ref1[0], setKeys = _$ref1[1];
    var handleAllState = function(state) {
        if (state) {
            var items = [];
            keys.forEach(function(key) {
                return !(props.disabled && props.disabled.includes(key)) && items.push(key);
            });
            setExpanded(items);
        } else {
            setExpanded([]);
        }
    };
    var handleState = function(state, uniqueKey) {
        var index = expanded.indexOf(uniqueKey);
        var newKeys = (0,_to_consumable_array/* default */.Z)(expanded);
        if (index > -1 && !state) {
            newKeys.splice(index, 1);
        }
        if (index < 0 && state) {
            newKeys.push(uniqueKey);
        }
        setExpanded(newKeys);
    };
    var handleToggle = function(uniqueKey) {
        var _$ref;
        if (!((_$ref = props.disabled) === null || _$ref === void 0 ? void 0 : _$ref.includes(uniqueKey))) {
            var index = expanded.indexOf(uniqueKey);
            if (props.multi) {
                var newKeys = (0,_to_consumable_array/* default */.Z)(expanded);
                if (index > -1) {
                    newKeys.splice(index, 1);
                } else {
                    newKeys.push(uniqueKey);
                }
                setExpanded(newKeys);
            } else if (index > -1) {
                setExpanded([]);
            } else {
                setExpanded([
                    uniqueKey
                ]);
            }
        }
    };
    react.useImperativeHandle(ref, function() {
        return {
            openAll: function openAll() {
                handleAllState(true);
            },
            closeAll: function closeAll() {
                handleAllState(false);
            },
            open: function open(uniqueKey) {
                handleState(true, uniqueKey);
            },
            close: function close(uniqueKey) {
                handleState(false, uniqueKey);
            },
            toggle: function toggle(uniqueKey) {
                handleToggle(uniqueKey);
            }
        };
    }, [
        expanded,
        keys,
        props.disabled
    ]);
    var _disabled;
    var ProviderValue = (0,react.useMemo)(function() {
        return {
            expanded: expanded,
            setKeys: setKeys,
            keys: keys,
            handleToggle: handleToggle,
            disabled: (_disabled = props.disabled) !== null && _disabled !== void 0 ? _disabled : []
        };
    }, [
        expanded,
        setKeys,
        keys,
        handleToggle,
        props.disabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: ProviderValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
            className: props.className,
            children: props.children
        })
    });
});
Accordion_Accordion.displayName = "Accordion";

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/AccordionItem.tsx





var AccordionItem_AccordionItem = function(param) {
    var title = param.title, uniqueKey = param.uniqueKey, children = param.children;
    var ref = (0,react.useContext)(Context), expanded = ref.expanded, disabled = ref.disabled, handleToggle = ref.handleToggle, keys = ref.keys, setKeys = ref.setKeys;
    (0,react.useEffect)(function() {
        setKeys((0,_to_consumable_array/* default */.Z)(keys).concat([
            uniqueKey
        ]));
    }, []);
    var state = {
        expanded: expanded.includes(uniqueKey),
        disabled: disabled.includes(uniqueKey)
    };
    var cssStyle = [];
    cssStyle.push(state.expanded ? "expanded" : "collapsed");
    cssStyle.push(state.disabled ? "disabled" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem, {
        className: cssStyle.join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                type: "button",
                onClick: function() {
                    return handleToggle(uniqueKey);
                },
                className: cssStyle.join(" "),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                className: state.expanded ? "expanded" : "collapsed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-body",
                    children: children
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/index.ts




/***/ }),

/***/ 36336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ VideoPlayer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react-player/youtube.js
var youtube = __webpack_require__(15655);
var youtube_default = /*#__PURE__*/__webpack_require__.n(youtube);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/VideoPlayer.tsx




var VideoPlayer = function(param) {
    var image = param.image, video = param.video;
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Wrapper, {
        className: (0,clsx/* clsx */.W)("video", {
            landscaped: (image === null || image === void 0 ? void 0 : (ref = image.dimensions) === null || ref === void 0 ? void 0 : ref.width) >= (image === null || image === void 0 ? void 0 : (ref1 = image.dimensions) === null || ref1 === void 0 ? void 0 : ref1.height),
            portrait: (image === null || image === void 0 ? void 0 : (ref2 = image.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width) < (image === null || image === void 0 ? void 0 : (ref3 = image.dimensions) === null || ref3 === void 0 ? void 0 : ref3.height)
        }),
        children: video && /*#__PURE__*/ (0,jsx_runtime.jsx)((youtube_default()), {
            className: "react-player",
            url: video === null || video === void 0 ? void 0 : video.embed_url,
            width: "100%",
            height: "100%"
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/index.ts



/***/ }),

/***/ 66376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/@prismicio/richtext/dist/asText.js
var asText = __webpack_require__(98268);
// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/index.ts
var CardHeader = __webpack_require__(27080);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/overlays/Message/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // margin-top: 140px;\n    margin-top: 40px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 40rem;\n  max-width: 100vw;\n  min-height: 45vh;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

// import { css } from 'styled-components';
var Modal = globalStyles/* styled.div */.zo.div(_templateObject2(), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject()), globalStyles/* media.smallestScreen */.BC.smallestScreen(_templateObject1()));
var Text = globalStyles/* styled.p */.zo.p(_templateObject3(), function(param) {
    var spacing = param.theme.spacing;
    return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject4(), function(param) {
    var spacing = param.theme.spacing;
    return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});

;// CONCATENATED MODULE: ./src/@next/components/overlays/Message/Message.tsx





var Message = function(param) {
    var title = param.title, image = param.image, text = param.text, content = param.content;
    var modal = (0,esm/* useModal */.dd)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                    divider: true,
                    formImage: image,
                    onHide: modal.remove,
                    children: title
                }),
                text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    className: "popup-message__text",
                    children: text
                }),
                content && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    className: "popup-message__content",
                    children: content
                })
            ]
        })
    });
};
/* harmony default export */ var Message_Message = (esm/* default.create */.ZP.create(Message));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Message/index.tsx


// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
// EXTERNAL MODULE: ./src/@prismic/context.tsx
var context = __webpack_require__(47233);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(26509);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
;// CONCATENATED MODULE: ./src/core/SEO/Product/structuredData.tsx




var getReviewsStructuredData = function(reviews) {
    var ref;
    return reviews === null || reviews === void 0 ? void 0 : (ref = reviews.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var node = param.node;
        return {
            "@type": "Review",
            reviewRating: {
                "@type": "Rating",
                ratingValue: node.rating
            },
            author: {
                "@type": "Person",
                name: node.fullName
            }
        };
    });
};
var getAggregateReviewsStructuredData = function(reviews) {
    return {
        "@type": "AggregateRating",
        ratingValue: reviews && reviews.length ? reviews.reduce(function(acc, r) {
            return r.rating + acc;
        }, 0) / reviews.length : 5,
        reviewCount: reviews.length || 1
    };
};
/*
const getVariantsStructuredData = (variants): any[] => {
  const inStock = 'https://schema.org/InStock';
  const outOfStock = 'https://schema.org/OutOfStock';
  return variants.map((variant) => ({
    '@type': 'Offer',
    availability: variant.isAvailable ? inStock : outOfStock,
    itemCondition: 'https://schema.org/NewCondition',
    price: variant.pricing.price.gross.amount.toFixed(2),
    priceCurrency: variant.pricing.price.gross.currency,
    sku: variant.sku,
  }));
};
*/ var getOffersStructuredData = function(product) {
    return {
        "@type": "AggregateOffer",
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        lowPrice: product.pricing.priceRange.start.gross.amount.toFixed(2),
        highPrice: product.pricing.priceRange.stop.gross.amount.toFixed(2),
        offerCount: product.variants.length,
        priceCurrency: product.pricing.priceRange.start.gross.currency,
        shippingDetails: {
            "@type": "OfferShippingDetails",
            shippingRate: {
                "@type": "MonetaryAmount",
                value: "0",
                currency: product.pricing.priceRange.start.gross.currency
            },
            deliveryTime: {
                "@type": "ShippingDeliveryTime",
                handlingTime: {
                    "@type": "QuantitativeValue",
                    minValue: product.productType.shippingMin,
                    maxValue: product.productType.shippingMax
                }
            }
        }
    };
};
var structuredData = function(product) {
    var images = product.images.map(function(image) {
        return new URL(image.url);
    });
    var reviews = product.reviews;
    return JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "Product",
        brand: "Reno",
        description: !product.seoDescription ? "".concat(product.name) : "".concat(product.seoDescription),
        image: images,
        manufacturer: "Reno sp zoo",
        name: !product.seoTitle ? "".concat(product.name) : "".concat(product.seoTitle),
        // offers: getVariantsStructuredData(variants),
        offers: getOffersStructuredData(product),
        productID: product.slug,
        sku: product.slug,
        url: (0,url_join/* default */.Z)("https://www.renoportes.fr" || 0, (0,core/* generatePath */.Gn)(paths/* paths.product */.H.product, {
            slug: (0,core/* slugify */.lV)((0,translations/* translate */.I)(product, "name")),
            id: (0,core/* decodeKey */.Tn)(product.id, "Product")
        })),
        aggregateRating: getAggregateReviewsStructuredData(reviews),
        review: getReviewsStructuredData(reviews)
    });
};
var structuredDataReview = function(reviews) {
    return JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "Reviews",
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: reviews && reviews.length ? reviews.reduce(function(acc, r) {
                return r.rating + acc;
            }, 0) / reviews.length : 5,
            reviewCount: reviews.length || 1
        },
        review: reviews && reviews.length ? reviews.map(function(e, _, arr) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var images = (ref = e.product) === null || ref === void 0 ? void 0 : ref.images.map(function(image) {
                return new URL(image.url);
            });
            return {
                "@type": "Review",
                itemReviewed: {
                    "@type": "Product",
                    brand: "Reno",
                    image: images,
                    manufacturer: "Reno sp zoo",
                    name: ((ref1 = e.product) === null || ref1 === void 0 ? void 0 : ref1.name) ? (ref2 = e.product) === null || ref2 === void 0 ? void 0 : ref2.name : "sliding doors",
                    productID: ((ref3 = e.product) === null || ref3 === void 0 ? void 0 : ref3.slug) ? (ref4 = e.product) === null || ref4 === void 0 ? void 0 : ref4.slug : "sliding-doors",
                    sku: ((ref5 = e.product) === null || ref5 === void 0 ? void 0 : ref5.slug) ? (ref6 = e.product) === null || ref6 === void 0 ? void 0 : ref6.slug : "sliding-doors"
                },
                author: {
                    "@type": "Person",
                    name: e.fullName
                },
                datePublished: e.createdAt,
                name: e.title,
                reviewBody: e.description,
                reviewRating: {
                    "@type": "Rating",
                    bestRating: arr.reduce(function(max, val) {
                        var sum = max;
                        if (val.rating > sum) {
                            sum = val.rating;
                        }
                        return sum;
                    }, 5),
                    ratingValue: e.rating,
                    worstRating: arr.reduce(function(min, val) {
                        var sum = min;
                        if (val.rating < sum) {
                            sum = val.rating;
                        }
                        return sum;
                    }, 5)
                }
            };
        }) : null
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(35937);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
// EXTERNAL MODULE: ./src/@next/hooks/index.ts + 10 modules
var hooks = __webpack_require__(40918);
// EXTERNAL MODULE: ./src/@next/hooks/useQueryState/index.ts + 3 modules
var useQueryState = __webpack_require__(86534);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@next/components/molecules/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(36336);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@prismic/gqlTypes/prismicHooks.tsx
var prismicHooks = __webpack_require__(41490);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./src/@next/components/atoms/Icon/index.ts + 2 modules
var Icon = __webpack_require__(31484);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductGallery/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-rows: 1fr 50px;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  height: 100%;\n  // grid-template-areas: 'sidebar preview';\n  // grid-template-columns: 76px 1fr;\n  grid-template-rows: 1fr 60px;\n  // grid-row-gap: 10px;\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40px;\n    height: 40px;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50px;\n  height: 50px;\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  flex-gap: 10px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 10px;\n  border-color: ",
        ";\n\n  text-align: center;\n  justify-content: center;\n\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    object-fit: contain;\n  }\n  svg {\n    height: 60%;\n    width: 60%;\n    object-fit: contain;\n  }\n\n  margin: 0.5em 0.25em;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 20px;\n  position: absolute;\n  z-index: 10;\n  background-color: rgba(50, 50, 50, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0%;\n\n  transform: rotate(180deg);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: 0%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100%;\n  overflow-y: hidden;\n  overflow-x: scroll;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    height: 0px;\n  }\n  ul {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    min-width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n  li:first-child {\n    padding-left: 10px;\n  }\n  li:last-child {\n    padding-right: 10px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // grid-area: preview;\n  width: auto;\n  max-height: 100%;\n  overflow: hidden;\n\n  background-color: ",
        ";\n\n  img {\n    width: 100%;\n    height: 100%;\n    max-height: 100vh;\n    object-fit: contain;\n  }\n\n  canvas {\n    outline: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject()));
var Thumbnail = globalStyles/* styled.div */.zo.div(styles_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject2()), function(props) {
    return props.activeThumbnail === true ? props.theme.colors.red : "transparent";
});
var styles_Button = globalStyles/* styled.div */.zo.div(styles_templateObject4());
var TopButton = (0,globalStyles/* styled */.zo)(styles_Button)(_templateObject5());
var BottomButton = (0,globalStyles/* styled */.zo)(styles_Button)(_templateObject6());
var ThumbnailsContainer = globalStyles/* styled.div */.zo.div(_templateObject7());
var ThumbnailList = globalStyles/* styled.div */.zo.div(_templateObject8());
var Preview = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.colors.light;
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductGallery/ThumbnailsView.tsx







var MINIMAL_NUMBER_OF_IMAGES_FOR_BUTTONS = 4;
var ThumbnailsView = function(param, ref) {
    var images = param.images, imageIndex = param.imageIndex, setImageIndex = param.setImageIndex;
    var displayButtons = images.length > MINIMAL_NUMBER_OF_IMAGES_FOR_BUTTONS;
    var bottomImageRef = react.useRef(null);
    var topImageRef = react.useRef(null);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer/* useInView */.YD)({
        threshold: 0.5
    }), 2), topImageIntersectionObserver = ref1[0], topImageInView = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer/* useInView */.YD)({
        threshold: 0.5
    }), 2), bottomImageIntersectionObserver = ref2[0], bottomImageInView = ref2[1];
    var setBottomRef = react.useCallback(function(node) {
        bottomImageRef.current = node;
        bottomImageIntersectionObserver(node);
    }, [
        bottomImageIntersectionObserver
    ]);
    var setTopRef = react.useCallback(function(node) {
        topImageRef.current = node;
        topImageIntersectionObserver(node);
    }, [
        topImageIntersectionObserver
    ]);
    var setIntersectionObserver = function(index, lengthOfArray) {
        if (lengthOfArray > MINIMAL_NUMBER_OF_IMAGES_FOR_BUTTONS) {
            if (index === 0) {
                return setTopRef;
            }
            if (index === lengthOfArray - 1) {
                return setBottomRef;
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThumbnailsContainer, {
        children: [
            !topImageInView && displayButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopButton, {
                onClick: function() {
                    if (topImageRef.current) {
                        topImageRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest"
                        });
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "select_arrow",
                    size: 10
                })
            }),
            !bottomImageInView && displayButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomButton, {
                onClick: function() {
                    if (bottomImageRef.current) {
                        bottomImageRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest"
                        });
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "select_arrow",
                    size: 10
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailList, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: images && images.length > 0 && images.map(function(image, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, {
                                ref: setIntersectionObserver(index, images.length),
                                onClick: function() {
                                    setImageIndex(index);
                                },
                                activeThumbnail: Boolean(index === imageIndex),
                                children: (image === null || image === void 0 ? void 0 : image.video) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image.video.thumbnail_url,
                                    width: 65,
                                    height: 65,
                                    alt: ""
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                    field: image.image,
                                    height: 65
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductGallery/ProductGallery.tsx









var ProductGallery = function(param) {
    var productSlug = param.productSlug;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), imageIndex = ref2[0], setImageIndex = ref2[1];
    var data = (0,prismicHooks/* usePrismicProductPageQuery */.p7S)({
        variables: {
            productUid: productSlug
        }
    }).data;
    var ref3 = data || {}, prismicProduct = ref3.product;
    var images = (prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.media) || [];
    react.useEffect(function() {
        if (imageIndex >= images.length) {
            setImageIndex(0);
        }
    }, [
        images
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                children: images && images.length > 0 && imageIndex < images.length && ((ref = images[imageIndex]) === null || ref === void 0 ? void 0 : ref.video) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* VideoPlayer */.Y, (0,_object_spread/* default */.Z)({}, images[imageIndex])) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                    field: (ref1 = images[imageIndex]) === null || ref1 === void 0 ? void 0 : ref1.image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailsView, {
                images: images || [],
                imageIndex: imageIndex,
                setImageIndex: setImageIndex
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductGallery/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/CachedImage/index.ts + 1 modules
var CachedImage = __webpack_require__(3820);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductImage/styles.ts

function ProductImage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-height: 90%;\n  height: 100%;\n  background-color: ",
        ";\n  img {\n    height: 455px;\n    mix-blend-mode: darken;\n  }\n"
    ]);
    ProductImage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styles_Preview = globalStyles/* styled.div */.zo.div(ProductImage_styles_templateObject(), function(props) {
    return props.theme.colors.light;
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductImage/ProductImage.tsx




var ProductImage = function(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Preview, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CachedImage/* CachedImage */.j, {
                alt: image.alt,
                url: image.url
            }),
            !image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CachedImage/* CachedImage */.j, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductImage/index.ts


// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./src/core/utils.ts
var utils = __webpack_require__(10110);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(11700);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedTypes.tsx
var generatedTypes = __webpack_require__(52046);
// EXTERNAL MODULE: ./src/@next/components/organisms/Popover/index.ts + 5 modules
var Popover = __webpack_require__(93290);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/styles.ts

function AttributeFieldTypes_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 0;\n    "
    ]);
    AttributeFieldTypes_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AttributeFieldTypes_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  input[type='radio'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  label {\n    cursor: pointer;\n    margin-top: 10px;\n    ",
        "\n    &:not(:last-child) {\n      margin-right: 6px;\n    }\n  }\n"
    ]);
    AttributeFieldTypes_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AttributeFieldTypes_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    AttributeFieldTypes_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AttributeFieldTypes_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n  "
    ]);
    AttributeFieldTypes_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AttributeFieldTypes_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n  "
    ]);
    AttributeFieldTypes_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 36px;\n        height: 36px;\n      "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 24px;\n        height: 24px;\n      "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-bottom: 6px;\n      "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n  flex-direction: column;\n  ",
        "\n  ",
        "\n  ",
        "\n  label {\n    transition: ",
        ";\n    color: #839098;\n    > div {\n      border-radius: 50%;\n      width: 56px;\n      height: 56px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-transform: capitalize;\n      background-color: #ffffff;\n      font-size: ",
        ";\n      ",
        "\n      ",
        "\n    }\n\n    &:not(:last-child) {\n      position: relative;\n      margin-right: 0;\n      ",
        "\n    }\n\n    &:hover {\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);\n    }\n  }\n\n  input:checked + div {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        line-height: 13px;\n      "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        line-height: 16px;\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  div {\n    img {\n      width: 100%;\n    }\n    border-radius: 6px;\n    border: 1px solid #faf8f8;\n    background-color: #faf8f8;\n    transition: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-transform: capitalize;\n    overflow: hidden;\n    span,\n    & + span {\n      transition: opacity 0.3s;\n      opacity: 0.5;\n      line-height: 16px;\n      font-family: ",
        ";\n      font-size: ",
        ";\n      font-weight: 500;\n      user-select: none;\n      text-transform: capitalize;\n      ",
        "\n      ",
        "\n    }\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n  input:checked + div {\n    background-color: #ffffff;\n    border-color: ",
        ";\n    span,\n    & + span {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  label {\n    > div {\n      min-width: 90px;\n      height: 25px;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 42px;\n        height: 42px;\n      "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 30px;\n        height: 30px;\n      "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 64px;\n        height: 64px;\n      "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 48px;\n        height: 48px;\n      "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 36px;\n        height: 36px;\n      "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 42px;\n          height: 42px;\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 30px;\n          height: 30px;\n        "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 64px;\n          height: 64px;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 48px;\n          height: 48px;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 36px;\n          height: 36px;\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 20px;\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  label {\n    text-align: center;\n    > div {\n      width: 46px;\n      height: 46px;\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      > div {\n        width: 46px;\n        height: 46px;\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n      }\n    }\n    span {\n      margin-top: 6px;\n      display: block;\n    }\n  }\n  label:not(:last-child) {\n    margin-right: 20px;\n    ",
        "\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 13px;\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 16px;\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 90px;\n  height: 25px;\n  // margin-top: 10px;\n  border: 1px solid;\n  border-radius: 6px;\n  border-color: ",
        ";\n  background-color: ",
        ";\n  transition: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: capitalize;\n  overflow: hidden;\n\n  &:not(:last-child) {\n    margin-right: 6px;\n  }\n\n  & > span {\n    color: ",
        ";\n    transition: opacity 0.3s;\n    opacity: ",
        ";\n    line-height: 16px;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-weight: 500;\n    user-select: none;\n    text-transform: capitalize;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 65px;\n    width: 100%;\n    margin: 10px 10px 0px 10px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: auto;\n    align-items: flex-start;\n    margin: 10px 10px 0px 10px;\n  "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 0 0;\n  display: flex;\n  align-items: center;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 20vw;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 320px;\n  position: relative;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -20px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: 500;\n  line-height: 160%;\n  opacity: ",
        ";\n  &.max {\n    right: 0px;\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 30px;\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n  "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: grid;\n  grid-gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(80px, max-content));\n  justify-content: center;\n  flex: 1;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 18px;\n    height: 18px;\n  "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 32px;\n    height: 32px;\n  "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-position: center;\n  background-size: 60px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.3s;\n  border: 4px solid transparent;\n  ",
        "\n  ",
        "\n  ",
        " {\n    display: none;\n  }\n  &:hover {\n    border-color: rgba(255, 255, 255, 0.3);\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-start;\n    margin: 0;\n  "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-left: 0;\n      "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 0;\n      margin-right: 6px;\n    "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            transform: scale(0.5);\n          "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin: 0 -10px;\n  ",
        "\n  label {\n    margin: 3px 5px 3px;\n    &:not(:first-child) {\n      ",
        "\n    }\n    ",
        "\n  }\n\n  input:checked + div {\n    border-color: rgba(255, 255, 255, 0.3);\n    ",
        " {\n      display: block;\n      div {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        svg {\n          transform: scale(0.8);\n          ",
        "\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}



var AttributeField = globalStyles/* styled.div */.zo.div(AttributeFieldTypes_styles_templateObject1(), globalStyles/* media.largeScreen */.BC.largeScreen(AttributeFieldTypes_styles_templateObject()));
var Configurator = (0,globalStyles/* styled */.zo)(AttributeField)(styles_templateObject8(), globalStyles/* media.largeScreen */.BC.largeScreen(AttributeFieldTypes_styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(AttributeFieldTypes_styles_templateObject3()), globalStyles/* media.smallestScreen */.BC.smallestScreen(AttributeFieldTypes_styles_templateObject4()), function(param) {
    var button = param.theme.button;
    return button.animation.transition;
}, function(props) {
    return props.theme.typography.labelFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject6()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject7()), function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
});
var pillStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), function(param) {
    var button = param.theme.button;
    return button.animation.transition;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.labelFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject9()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject10()), function(param) {
    var colors = param.theme.colors;
    return colors.red;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
});
var Pill = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject12(), pillStyle);
var Dropdown = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject24(), pillStyle, globalStyles/* media.xLargeScreen */.BC.xLargeScreen(_templateObject13()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject14()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject16()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject17()), globalStyles/* media.xLargeScreen */.BC.xLargeScreen(_templateObject18()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject19()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject20()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject21()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject22()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject23()));
var Track = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject25());
var PillButton = globalStyles/* styled.button */.zo.button(_templateObject28(), function(param) {
    var active = param.active, colors = param.theme.colors;
    return active ? colors.red : "#faf8f8";
}, function(param) {
    var active = param.active;
    return active ? "#ffffff" : "#faf8f8";
}, function(param) {
    var button = param.theme.button;
    return button.animation.transition;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(param) {
    var active = param.active;
    return active ? 1 : 0.5;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.labelFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject26()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject27()));
var Slider = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject31(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject29()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject30()));
var SliderColumn = globalStyles/* styled.div */.zo.div(_templateObject34(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject32()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject33()));
var SliderRow = globalStyles/* styled.div */.zo.div(_templateObject35());
var SliderEdgeValue = globalStyles/* styled.div */.zo.div(_templateObject36(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.labelFontSize;
}, function(param) {
    var active = param.active, colors = param.theme.colors;
    return active ? colors.blueLight : colors.graySemi;
}, function(param) {
    var active = param.active;
    return active ? 1 : 0.5;
});
var SliderInfoButton = globalStyles/* styled.img */.zo.img(_templateObject38(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject37()));
var SquareSwatch = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject40(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject39()));
var CircleSwatchIcon = (0,globalStyles/* styled */.zo)(react_svg_esm/* ReactSVG */.Q)(_templateObject41());
var CircleSwatchItem = globalStyles/* styled.div */.zo.div(_templateObject44(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject42()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject43()), CircleSwatchIcon);
var CircleSwatch = (0,globalStyles/* styled */.zo)(AttributeField)(_templateObject49(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject45()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject46()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject47()), CircleSwatchIcon, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject48()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldDropdown.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 








var AttributeFieldDropdown = function(param) {
    var attribute = param.attribute;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
        children: attribute.values.map(function(value) {
            return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "radio",
                        name: attribute.attribute.slug,
                        value: value.slug
                    }, register(attribute.attribute.slug))),
                    isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: value.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: value.image.url,
                            alt: (0,translations/* translate */.I)(value, "name")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover */.J, {
                        triggers: [
                            "hint"
                        ],
                        placement: "top",
                        overlay: (0,translations/* translate */.I)(value, "name"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: value.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: value.image.url,
                                alt: (0,translations/* translate */.I)(value, "name")
                            })
                        })
                    })
                ]
            }, value.id));
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/@next/utils/colorsDictionary.ts
var colorsDictionary = __webpack_require__(61675);
// EXTERNAL MODULE: ./src/images/check.svg
var check = __webpack_require__(45809);
// EXTERNAL MODULE: ./src/images/cross.svg
var cross = __webpack_require__(45747);
;// CONCATENATED MODULE: ./src/@next/components/atoms/SquareColorCheckbox/styles.ts

function SquareColorCheckbox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  position: relative;\n"
    ]);
    SquareColorCheckbox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40px;\n  "
    ]);
    SquareColorCheckbox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 60px;\n  "
    ]);
    SquareColorCheckbox_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 60px;\n        height: 60px;\n      "
    ]);
    SquareColorCheckbox_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 40px;\n        height: 40px;\n      "
    ]);
    SquareColorCheckbox_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 60px;\n    "
    ]);
    SquareColorCheckbox_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 40px;\n    "
    ]);
    SquareColorCheckbox_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  ",
        ";\n  ",
        ";\n  display: flex;\n  flex-direction: column;\n  cursor: ",
        ";\n  justify-content: flex-start;\n  align-items: center;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      border-radius: 6px;\n      width: 80px;\n      height: 80px;\n      ",
        ";\n      ",
        ";\n      background-position: center;\n      border: 1px solid transparent;\n      position: relative;\n      .color-checkbox__icon {\n        &-check,\n        &-cross {\n          position: absolute;\n          top: 6px;\n          right: 6px;\n          width: 20px;\n          height: 20px;\n          border-radius: 50%;\n          background-color: #ca9c66;\n          justify-content: center;\n          align-items: center;\n          display: none;\n          svg {\n            transform: scale(0.5);\n          }\n        }\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  ",
        "\n\n  span {\n    ",
        ";\n    ",
        ";\n    max-width: 80px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n\n  input:checked + div {\n    span {\n      border: 1px solid #c34c3e;\n      .color-checkbox__icon {\n        &-check {\n          display: flex;\n        }\n      }\n    }\n    &:hover {\n      span {\n        .color-checkbox__icon {\n          &-check {\n            display: none;\n          }\n          &-cross {\n            display: flex;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    SquareColorCheckbox_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SquareColorCheckbox_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1rem;\n  text-align: center;\n  opacity: ",
        ";\n"
    ]);
    SquareColorCheckbox_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var ColorCheckbox = globalStyles/* styled.div */.zo.div(SquareColorCheckbox_styles_templateObject());
var Label = globalStyles/* styled.label */.zo.label(SquareColorCheckbox_styles_templateObject7(), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(SquareColorCheckbox_styles_templateObject1()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(SquareColorCheckbox_styles_templateObject2()), function(props) {
    return props.disabled ? "not-allowed" : "pointer";
}, globalStyles/* media.smMediumScreen */.BC.smMediumScreen(SquareColorCheckbox_styles_templateObject3()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(SquareColorCheckbox_styles_templateObject4()), function(props) {
    return props.disabled ? "" : "&:hover {\n          div {\n            opacity: 1;\n            span {\n              .color-checkbox__icon-check {\n                display: flex;\n                background: #d0d3d8;\n                opacity: 0.5;\n                border: 1.5px solid #839098;\n                svg {\n                  display: none;\n                }\n              }\n            }\n          }\n        }";
}, globalStyles/* media.smMediumScreen */.BC.smMediumScreen(SquareColorCheckbox_styles_templateObject5()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(SquareColorCheckbox_styles_templateObject6()), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.baseLineHeight;
});
var Name = globalStyles/* styled.div */.zo.div(SquareColorCheckbox_styles_templateObject8(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.checked && !props.disabled ? 1 : 0.3;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/SquareColorCheckbox/SquareColorCheckbox.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 












var ENTER_KEY = 13;
var SPACE_KEY = 32;
var SquareColorCheckbox = function(_param) {
    var name = _param.name, checked = _param.checked, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, onMouseEnter = _param.onMouseEnter, onMouseLeave = _param.onMouseLeave, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "value",
        "onChange",
        "onMouseEnter",
        "onMouseLeave",
        "disabled"
    ]);
    var ref = react.useRef(null);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        style: {
            backgroundColor: value.color || colorsDictionary/* colorsDictionary */.X[value.slug],
            backgroundImage: "url(".concat((0,utils/* getTextureThumbnailUrl */.g)(value.slug), ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: check,
                className: "color-checkbox__icon-check"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: cross,
                className: "color-checkbox__icon-cross"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorCheckbox, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: ref,
        onClick: function(evt) {
            if (disabled) {
                return;
            }
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    tabIndex: -1,
                    type: "checkbox",
                    name: name,
                    checked: checked,
                    readOnly: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref,
                    tabIndex: 0,
                    onKeyDown: function(evt) {
                        if (disabled) {
                            return;
                        }
                        if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                            evt.preventDefault();
                            onChange(evt);
                        }
                    },
                    children: content
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                    disabled: disabled,
                    checked: checked,
                    children: upperFirst_default()((0,translations/* translate */.I)(value, "name")).replace("_", " ")
                })
            ]
        })
    });
};
SquareColorCheckbox.displayName = "ColorSquareCheckbox";

;// CONCATENATED MODULE: ./src/@next/components/atoms/SquareColorCheckbox/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldSwatch.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 
















var CircleSwatchTypeItem = function(param) {
    var attribute = param.attribute, i = param.i, value = param.value;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "radio",
                name: attribute.attribute.slug,
                value: value.slug
            }, register(attribute.attribute.slug))),
            isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatchItem, {
                style: {
                    backgroundColor: colorsDictionary/* colorsDictionary */.X[value.slug],
                    backgroundImage: "url(".concat((0,utils/* getTextureThumbnailUrl */.g)(value.slug), ")"),
                    backgroundPositionY: [
                        "top",
                        "center",
                        "bottom"
                    ][i % 3]
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatchIcon, {
                    src: check
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover */.J, {
                triggers: [
                    "hint"
                ],
                placement: "top",
                overlay: (0,translations/* translate */.I)(value, "name").replace("_", " ").replace("-", " "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatchItem, {
                    style: {
                        backgroundColor: colorsDictionary/* colorsDictionary */.X[value.slug],
                        backgroundImage: "url(".concat((0,utils/* getTextureThumbnailUrl */.g)(value.slug), ")"),
                        backgroundPositionY: [
                            "top",
                            "center",
                            "bottom"
                        ][i % 3]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatchIcon, {
                        src: check
                    })
                })
            })
        ]
    }, value.id);
};
var AttributeFieldCircleSwatch = function(param) {
    var attribute = param.attribute;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatch, {
        children: attribute.values.map(function(value, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSwatchTypeItem, {
                value: value,
                i: i,
                attribute: attribute
            }, value.id);
        })
    });
};
var AttributeFieldSquareSwatch = function(param) {
    var attribute = param.attribute, onOptionHover = param.onOptionHover;
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareSwatch, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            name: attribute.attribute.slug,
            control: control,
            render: function(param) {
                var _field = param.field, onChange = _field.onChange, value = _field.value;
                var maxSampleItemsReached = value.length === MAX_SAMPLE_ITEMS;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: attribute.values.map(function(option) {
                        var checked = value.includes(option.slug);
                        var disabled = !checked && maxSampleItemsReached;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareColorCheckbox, {
                            onMouseEnter: function() {
                                return onOptionHover(option);
                            },
                            onMouseLeave: function() {
                                return onOptionHover(null);
                            },
                            name: attribute.attribute.slug,
                            checked: checked,
                            onChange: function() {
                                var valueSet = new Set(value);
                                if (valueSet.has(option.slug)) {
                                    valueSet.delete(option.slug);
                                } else {
                                    valueSet.add(option.slug);
                                }
                                onChange((0,_to_consumable_array/* default */.Z)(valueSet));
                            },
                            value: option,
                            disabled: disabled
                        }, option.id);
                    })
                });
            }
        })
    });
};
var AttributeFieldSwatch = function(_param) {
    var squareOptions = _param.squareOptions, onOptionHover = _param.onOptionHover, props = (0,_object_without_properties/* default */.Z)(_param, [
        "squareOptions",
        "onOptionHover"
    ]);
    if (squareOptions) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeFieldSquareSwatch, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onOptionHover: onOptionHover
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeFieldCircleSwatch, (0,_object_spread/* default */.Z)({}, props));
};

// EXTERNAL MODULE: ./node_modules/react-slider/dist/es/prod/components/ReactSlider/ReactSlider.mjs
var ReactSlider = __webpack_require__(63649);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Slider/styles.ts

function Slider_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n"
    ]);
    Slider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Slider_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: -25px;\n  top: -5px;\n"
    ]);
    Slider_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Slider_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  position: relative;\n  outline: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n  position: absolute;\n  top: -2px;\n  left: ",
        ";\n"
    ]);
    Slider_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Slider_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  border-radius: 30px;\n  text-align: center;\n  padding: 2px;\n  cursor: grab;\n  width: 60px;\n  color: #4f6e7c;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  position: absolute;\n  top: 0px;\n"
    ]);
    Slider_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Slider_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 50%;\n  background: ",
        ";\n  height: 4px;\n"
    ]);
    Slider_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Slider_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 8px;\n  height: 8px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  cursor: pointer;\n  vertical-align: middle;\n  top: 4px;\n"
    ]);
    Slider_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styles_Slider = (0,globalStyles/* styled */.zo)(ReactSlider/* default */.Z)(Slider_styles_templateObject());
var ThumbWrapper = globalStyles/* styled.div */.zo.div(Slider_styles_templateObject1());
var ThumbButton = globalStyles/* styled.button */.zo.button(Slider_styles_templateObject2(), function(param) {
    var colors = param.theme.colors;
    return colors.red;
}, function(param) {
    var minus = param.minus;
    return minus ? "-30px" : "60px";
});
var ThumbLabel = globalStyles/* styled.div */.zo.div(Slider_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
});
var styles_Track = globalStyles/* styled.div */.zo.div(Slider_styles_templateObject4(), function(param) {
    var index = param.index, colors = param.theme.colors;
    return index === 0 ? colors.red : "#ddd";
});
var Mark = globalStyles/* styled.span */.zo.span(Slider_styles_templateObject5(), function(param) {
    var active = param.active, colors = param.theme.colors;
    return active ? colors.red : "#c5ced3";
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Slider/Slider.tsx




/**
 * Converts and sorts an array of product attribute value objects into an array of numbers.
 * Filters values to only include those divisible by 100 if the onlyDivisibleBy100 flag is true.
 * Specifically includes 450 and 550 if they are present in the original attributeValues.
 *
 * @param attributeValues - Array of product attribute value objects
 * @param onlyDivisibleBy100 - Optional flag to filter values to those divisible by 100
 * @returns Sorted array of numeric values extracted from the attributeValues array, conditionally including 450 and 550
 */ /**
 * Converts and sorts an array of product attribute value objects into an array of numbers.
 * Filters values to only include those divisible by 100 if the onlyDivisibleBy100 flag is true.
 * Specifically includes 450 and 550 if they are present in the original attributeValues.
 *
 * @param attributeValues - Array of product attribute value objects
 * @param onlyDivisibleBy100 - Optional flag to filter values to those divisible by 100
 * @returns Sorted array of numeric values extracted from the attributeValues array, conditionally including 450 and 550
 */ function convertAndSortValues(attributeValues) {
    var onlyDivisibleBy100 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sortedValues = attributeValues.filter(function(v) {
        return v;
    }) // Ensure the object exists
    .map(function(item) {
        return parseInt(item.value, 10);
    }) // Convert each 'value' property to an integer
    .filter(function(value) {
        return !onlyDivisibleBy100 || value % 100 === 0 || value === 450 || value === 550;
    }).sort(function(a, b) {
        return a - b;
    }); // Sort the array of integers in ascending order
    return sortedValues;
}
/**
 * Finds the slug value corresponding to the given target value.
 * Searches through the provided list of attribute values to find the object
 * where the 'value' property matches the targetValue.
 * Returns the 'slug' property of the matching object if found, otherwise undefined.
 */ function findSlugByValue(attributeValues, targetValue) {
    // Find the object where 'value' matches the given number
    var matchingObject = attributeValues.find(function(item) {
        return parseInt(item.value, 10) === targetValue;
    });
    // Return the 'slug' value if the object is found
    return matchingObject === null || matchingObject === void 0 ? void 0 : matchingObject.slug;
}
var Slider_Track = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Track, (0,_object_spread/* default */.Z)({}, props));
};
var Slider_Mark = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mark, (0,_object_spread/* default */.Z)({}, props));
};
var Slider_Slider = function(param) {
    var values = param.values, onChange = param.onChange, value = param.value, compactView = param.compactView;
    var valuesArray = convertAndSortValues(values, compactView);
    var sliderMin = 0;
    var sliderMax = valuesArray.length - 1;
    var sliderIndex = valuesArray.indexOf(parseInt(value, 10));
    var onChangeHandler = function(newValue) {
        var newSlug = valuesArray[newValue];
        onChange(findSlugByValue(values, newSlug));
    };
    // Function to generate marks
    var generateMarks = function(min, max, interval) {
        var numberOfMarks = Math.floor((max - min) / interval) + 1;
        return Array.from({
            length: numberOfMarks
        }, function(_, i) {
            return min + i * interval;
        });
    };
    var marks = generateMarks(sliderMin, sliderMax, 10);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Slider, {
        min: sliderMin,
        max: sliderMax,
        onChange: onChangeHandler,
        value: sliderIndex,
        marks: sliderMax < 15 || marks,
        renderMark: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Mark, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                active: props.key <= sliderIndex
            }));
        },
        renderTrack: function(props, state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Track, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                index: state.index
            }));
        },
        renderThumb: function(props, state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbLabel, {
                        children: "".concat(valuesArray[state.valueNow] / 10, "cm")
                    })
                })
            }));
        }
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Slider/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldSlider.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 




var AttributeFieldSlider = function(param) {
    var attribute = param.attribute;
    var edgeValues = (0,react.useMemo)(function() {
        var sorted = attribute.values.slice().sort(function(a, b) {
            return parseInt(a.slug, 10) - parseInt(b.slug, 10);
        });
        var max = parseInt(sorted[sorted.length - 1].slug, 10) / 10;
        var min = parseInt(sorted[0].slug, 10) / 10;
        return {
            max: max,
            min: min
        };
    }, [
        attribute
    ]);
    var ref = (0,index_esm/* useFormContext */.Gc)(), control = ref.control, getValues = ref.getValues;
    var containsTop = function(obj) {
        return Object.values(obj).some(function(value) {
            return typeof value === "string" && value.includes("top");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            name: attribute.attribute.slug,
            control: control,
            render: function(param) {
                var _field = param.field, onChange = _field.onChange, value = _field.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderColumn, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderEdgeValue, {
                                className: "min",
                                active: edgeValues.min === value / 10,
                                children: [
                                    edgeValues.min,
                                    " cm"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderEdgeValue, {
                                className: "max",
                                active: edgeValues.max === value / 10,
                                children: [
                                    edgeValues.max,
                                    " cm"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Slider, {
                                values: attribute.values,
                                onChange: onChange,
                                value: value,
                                compactView: !containsTop(getValues())
                            })
                        ]
                    })
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldPill.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 




var extractDisplayName = function(name) {
    return name.split("-").pop();
};
var AttributeFieldPill = function(param) {
    var attribute = param.attribute;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
        children: attribute.values.map(function(value) {
            return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "radio",
                        name: attribute.attribute.slug,
                        value: value.slug
                    }, register(attribute.attribute.slug))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: extractDisplayName((0,translations/* translate */.I)(value, "name"))
                        })
                    })
                ]
            }, value.id));
        })
    });
};

// EXTERNAL MODULE: ./src/@next/hooks/usePrevious.ts
var usePrevious = __webpack_require__(87134);
;// CONCATENATED MODULE: ./src/@next/components/overlays/CustomTrack/styles.ts

function CustomTrack_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // margin-top: 140px;\n    margin-top: 40px;\n  "
    ]);
    CustomTrack_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    CustomTrack_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-width: 120px;\n      height: 42px;\n      font-size: 13px;\n      line-height: 13px;\n    "
    ]);
    CustomTrack_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0;\n    "
    ]);
    CustomTrack_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  ",
        "\n  ",
        "\n  .button {\n    padding: 0;\n    height: 50px;\n    min-width: 170px;\n    font-size: 14px;\n    line-height: 14px;\n    letter-spacing: 3px;\n\n    ",
        "\n  }\n\n  .cancel {\n    margin-right: 20px;\n    ",
        "\n  }\n"
    ]);
    CustomTrack_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 50px 38px;\n  "
    ]);
    CustomTrack_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100vw;\n    padding: 40px;\n  "
    ]);
    CustomTrack_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 80px 50px 35px;\n  ",
        "\n  ",
        "\n"
    ]);
    CustomTrack_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: initial;\n    width: 100%;\n  "
    ]);
    CustomTrack_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CustomTrack_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 650px;\n  ",
        "\n"
    ]);
    CustomTrack_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      justify-content: flex-end;\n    "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    display: flex;\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 20px;\n  position: relative;\n  width: 100%;\n  ",
        "\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    top: -5px;\n    white-space: nowrap;\n  "
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        left: -10px;\n      "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -20px;\n      ",
        "\n    "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: -10px;\n      "
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -35px;\n      ",
        "\n    "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      opacity: 1;\n    "
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -21px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: 500;\n  line-height: 160%;\n  opacity: 0.5;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 25px;\n  "
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 0;\n    margin-top: 25px;\n  "
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 25px;\n  font-size: ",
        ";\n  line-height: 160%;\n  text-align: center;\n  text-decoration-line: underline;\n  color: ",
        ";\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  text-align: center;\n  color: ",
        ";\n  white-space: nowrap;\n  display: block;\n  padding-bottom: 25px;\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}


var styles_Modal = globalStyles/* styled.div */.zo.div(CustomTrack_styles_templateObject4(), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(CustomTrack_styles_templateObject()), globalStyles/* media.smallestScreen */.BC.smallestScreen(CustomTrack_styles_templateObject1()), globalStyles/* media.largeScreen */.BC.largeScreen(CustomTrack_styles_templateObject2()), globalStyles/* media.mediumScreen */.BC.mediumScreen(CustomTrack_styles_templateObject3()));
var styles_Content = globalStyles/* styled.div */.zo.div(CustomTrack_styles_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(CustomTrack_styles_templateObject5()), globalStyles/* media.mediumScreen */.BC.mediumScreen(CustomTrack_styles_templateObject6()));
var styles_Wrapper = globalStyles/* styled.div */.zo.div(CustomTrack_styles_templateObject9(), globalStyles/* media.mediumScreen */.BC.mediumScreen(CustomTrack_styles_templateObject8()));
var Row = globalStyles/* styled.div */.zo.div(styles_templateObject13(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject10()), function(param) {
    var buttons = param.buttons;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject12(), buttons && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject11()));
});
var CustomTrack_styles_Slider = globalStyles/* styled.div */.zo.div(styles_templateObject15(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject14()));
var EdgeValues = globalStyles/* styled.div */.zo.div(styles_templateObject23(), function(param) {
    var theme = param.theme;
    return theme.typography.extraFontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.typography.labelFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.colors.graySemi;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject16()), function(param) {
    var theme = param.theme, type = param.type, active = param.active;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject22(), type === "min" && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject18(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject17())), type === "max" && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject20(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject19())), active && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject21(), theme.colors.blueLight));
});
var ResetButton = globalStyles/* styled.button */.zo.button(styles_templateObject26(), function(param) {
    var theme = param.theme;
    return theme.typography.labelFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject24()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject25()));
var styles_Message = globalStyles/* styled.span */.zo.span(styles_templateObject27(), function(param) {
    var theme = param.theme;
    return theme.typography.extraFontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.typography.labelFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.colors.graySemi;
});

;// CONCATENATED MODULE: ./src/@next/components/overlays/CustomTrack/CustomTrack.tsx









var CustomTrack = function(param) {
    var show = param.show, hide = param.hide, target = param.target, attribute = param.attribute, onChange = param.onChange, value = param.value, defaultValue = param.defaultValue, minValue = param.minValue, maxValue = param.maxValue;
    var intl = (0,useIntl/* default */.Z)();
    var filteredAttributeValues = (0,react.useMemo)(function() {
        return attribute.values.filter(function(_value) {
            return Number(_value.slug) >= Number(minValue) && Number(_value.slug) <= Number(maxValue);
        });
    }, [
        attribute,
        minValue,
        maxValue
    ]);
    var ref = (0,react.useState)(value), innerValue = ref[0], setInnerValue = ref[1];
    var handleChange = function(newValue) {
        setInnerValue(newValue);
    };
    var handleReset = function() {
        setInnerValue(defaultValue);
    };
    (0,react.useEffect)(function() {
        setInnerValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: show,
        hide: hide,
        target: target,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                    divider: true,
                    onHide: hide,
                    children: intl.formatMessage({
                        defaultMessage: "Select custom rail size",
                        id: "r7m0tp"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTrack_styles_Slider, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EdgeValues, {
                                                type: "min",
                                                active: minValue === innerValue,
                                                children: [
                                                    parseInt(minValue, 10) / 10,
                                                    " cm"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Slider, {
                                                values: filteredAttributeValues,
                                                onChange: handleChange,
                                                value: innerValue
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EdgeValues, {
                                                type: "max",
                                                active: maxValue === innerValue,
                                                children: [
                                                    parseInt(maxValue, 10) / 10,
                                                    " cm"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetButton, {
                                        type: "button",
                                        onClick: handleReset,
                                        children: intl.formatMessage({
                                            defaultMessage: "reset to default",
                                            id: "D3Xqos"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Message, {
                                children: attribute.getMessage && attribute.getMessage(value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                buttons: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        appearance: "ghost",
                                        size: "sm",
                                        className: "button cancel",
                                        onClick: hide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: intl.formatMessage(src_intl/* commonMessages.cancel */.i4.cancel)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        size: "sm",
                                        className: "button",
                                        onClick: function() {
                                            onChange(String(innerValue));
                                            hide();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: intl.formatMessage(src_intl/* commonMessages.save */.i4.save)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/overlays/CustomTrack/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/utils.ts
var getTrackValues = function(width, configuration) {
    var multiplier = configuration === "configuration-single" ? 1 : 2;
    return {
        defaultValue: String(Number(width) * 2 * multiplier),
        maxValue: String(Number(width) * 3 * multiplier),
        minValue: String(Number(width) * 1.5 * multiplier)
    };
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldTrack.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 







var AttributeFieldTrack = function(param) {
    var attribute = param.attribute;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), control = ref1.control, setValue = ref1.setValue; // retrieve all hook methods
    // TODO: handle double configuration
    // watching door width to get default value for track field
    var ref2 = (0,index_esm/* useWatch */.qo)({
    }), width = ref2.width, configuration = ref2.configuration;
    var ref3 = getTrackValues(width, configuration), defaultValue = ref3.defaultValue, maxValue = ref3.maxValue, minValue = ref3.minValue;
    var previousWidth = (0,usePrevious/* usePrevious */.D)(width);
    var previousConfiguration = (0,usePrevious/* usePrevious */.D)(configuration);
    (0,react.useEffect)(function() {
        var widthChanged = previousWidth !== width;
        var configurationChanged = previousConfiguration !== configuration;
        if (widthChanged || configurationChanged) {
            // reset custom-track width to the new defaultValue
            setValue(attribute.attribute.slug, defaultValue);
        }
    }, [
        attribute.attribute.slug,
        defaultValue,
        previousWidth,
        setValue,
        width,
        configuration,
        previousConfiguration, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: attribute.attribute.slug,
        control: control,
        render: function(param) {
            var _field = param.field, onChange = _field.onChange, value = _field.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Track, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTrack, {
                        hide: function() {
                            return setShow(false);
                        },
                        show: show,
                        attribute: attribute,
                        defaultValue: defaultValue,
                        minValue: minValue,
                        maxValue: maxValue,
                        value: value,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PillButton, {
                        active: value === defaultValue,
                        type: "button",
                        onClick: function() {
                            return onChange(defaultValue);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: intl.formatMessage({
                                defaultMessage: "Standard",
                                id: "cb2kY6"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PillButton, {
                        active: value !== defaultValue,
                        type: "button",
                        onClick: function() {
                            return setShow(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: intl.formatMessage({
                                defaultMessage: "Custom",
                                id: "Sjo1P4"
                            })
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/AttributeFieldTypes.tsx
/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */ 






var _obj;
var AttributeFieldTypesDictionary = (_obj = {}, (0,_define_property/* default */.Z)(_obj, generatedTypes/* AttributeChoiceTypeEnum.DROPDOWN */.O$.DROPDOWN, AttributeFieldDropdown), (0,_define_property/* default */.Z)(_obj, generatedTypes/* AttributeChoiceTypeEnum.SWATCH */.O$.SWATCH, AttributeFieldSwatch), (0,_define_property/* default */.Z)(_obj, generatedTypes/* AttributeChoiceTypeEnum.SLIDER */.O$.SLIDER, AttributeFieldSlider), (0,_define_property/* default */.Z)(_obj, generatedTypes/* AttributeChoiceTypeEnum.TOGGLE */.O$.TOGGLE, AttributeFieldPill), (0,_define_property/* default */.Z)(_obj, generatedTypes/* AttributeChoiceTypeEnum.MULTISELECT */.O$.MULTISELECT, AttributeFieldTrack), _obj);
var getAttributeChoiceTypeFieldComponent = function(choiceType) {
    var ChoiceTypeFieldComponent = AttributeFieldTypesDictionary[choiceType];
    if (!ChoiceTypeFieldComponent) {
        console.error("ChoiceTypeFieldComponent for type ".concat(choiceType, " not found"));
        return AttributeFieldDropdown;
    }
    return ChoiceTypeFieldComponent;
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeFieldTypes/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/styles.ts
var styles = __webpack_require__(71013);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceColorSample/index.ts + 2 modules
var SliceColorSample = __webpack_require__(6986);
// EXTERNAL MODULE: ./src/images/x.svg
var x = __webpack_require__(63232);
;// CONCATENATED MODULE: ./src/@next/components/overlays/ColorSamples/styles.ts

function ColorSamples_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 65vh;\n"
    ]);
    ColorSamples_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorSamples_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 80px 120px;\n  "
    ]);
    ColorSamples_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ColorSamples_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 111px 92px;\n  "
    ]);
    ColorSamples_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ColorSamples_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 84px 24px;\n  "
    ]);
    ColorSamples_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ColorSamples_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 100%;\n    "
    ]);
    ColorSamples_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ColorSamples_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 100px 136px;\n  ",
        "\n  ",
        "\n  ",
        "\n  .color-sample {\n    max-width: 688px;\n    padding:0;\n    ",
        "\n"
    ]);
    ColorSamples_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

// import { css } from 'styled-components';
var ColorSamples_styles_Modal = globalStyles/* styled.div */.zo.div(ColorSamples_styles_templateObject());
var ColorSamples_styles_Content = globalStyles/* styled.div */.zo.div(ColorSamples_styles_templateObject5(), globalStyles/* media.xLargeScreen */.BC.xLargeScreen(ColorSamples_styles_templateObject1()), globalStyles/* media.largeScreen */.BC.largeScreen(ColorSamples_styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(ColorSamples_styles_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ColorSamples_styles_templateObject4()));

;// CONCATENATED MODULE: ./src/@next/components/overlays/ColorSamples/ColorSamples.tsx







var ColorSamples = function(param) {
    var show = param.show, hide = param.hide, target = param.target, isMinimalist = param.isMinimalist, colorSample = param.colorSample;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: show,
        hide: hide,
        target: target,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColorSamples_styles_Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Header */.h4, {
                    divider: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CloseImg */.Fl, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: x,
                            onClick: hide
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSamples_styles_Content, {
                    children: colorSample.map(function(z, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceColorSample/* SliceColorSample */.x, {
                            slice: z,
                            context: {
                                isMinimalist: isMinimalist
                            }
                        }, "colorSample_".concat(i));
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/overlays/ColorSamples/index.tsx


;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorSamplesButton/styles.ts

function ColorSamplesButton_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -9px;\n  "
    ]);
    ColorSamplesButton_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -6px;\n  "
    ]);
    ColorSamplesButton_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n  "
    ]);
    ColorSamplesButton_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n  "
    ]);
    ColorSamplesButton_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: -10px;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ColorSamplesButton_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    ColorSamplesButton_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 33px;\n  background: ",
        ";\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  ",
        "\n"
    ]);
    ColorSamplesButton_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  line-height: 100%;\n  color: ",
        ";\n  opacity: 0.5;\n"
    ]);
    ColorSamplesButton_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 10px;\n    height: 10px;\n  "
    ]);
    ColorSamplesButton_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 14px;\n    height: 14px;\n  "
    ]);
    ColorSamplesButton_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ColorSamplesButton_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 5px;\n  width: 12px;\n  height: 12px;\n  ",
        "\n  ",
        "\n"
    ]);
    ColorSamplesButton_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var ColorSamplesButton_styles_Wrapper = globalStyles/* styled.div */.zo.div(ColorSamplesButton_styles_templateObject4(), globalStyles/* media.xLargeScreen */.BC.xLargeScreen(ColorSamplesButton_styles_templateObject()), globalStyles/* media.largeScreen */.BC.largeScreen(ColorSamplesButton_styles_templateObject1()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ColorSamplesButton_styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(ColorSamplesButton_styles_templateObject3()));
var ColorSamplesButton_styles_Button = globalStyles/* styled.button */.zo.button(ColorSamplesButton_styles_templateObject6(), function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ColorSamplesButton_styles_templateObject5()));
var styles_Text = globalStyles/* styled.span */.zo.span(ColorSamplesButton_styles_templateObject7(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
});
var styles_Icon = globalStyles/* styled.img */.zo.img(ColorSamplesButton_styles_templateObject10(), globalStyles/* media.largeScreen */.BC.largeScreen(ColorSamplesButton_styles_templateObject8()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ColorSamplesButton_styles_templateObject9()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorSamplesButton/ColorSamplesButton.tsx





var ColorSamplesButton = function(param) {
    var colorSample = param.colorSample;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    if (colorSample && colorSample.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColorSamplesButton_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSamples, {
                    hide: function() {
                        return setShow(false);
                    },
                    show: show,
                    colorSample: colorSample
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSamplesButton_styles_Button, {
                    type: "button",
                    onClick: function() {
                        return setShow(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                        children: intl.formatMessage({
                            defaultMessage: "Order color samples",
                            id: "YAW0Qz"
                        })
                    })
                })
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorSamplesButton/index.ts



// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
;// CONCATENATED MODULE: ./src/images/arrow-icon.svg
var arrow_icon_namespaceObject = __webpack_require__.p + "static/images/arrow-icon.svg";
;// CONCATENATED MODULE: ./src/@next/components/atoms/Tabs/styles.ts
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */ 
function Tabs_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n"
    ]);
    Tabs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tabs_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    // margin-bottom: -1px;\n    text-align: center;\n    position: relative;\n    text-transform: uppercase;\n    &.active a::before {\n      display: block;\n    }\n    a {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n      display: flex;\n      align-items: center;\n      position: relative;\n      text-decoration: none;\n\n      &::before {\n        display: none;\n        position: absolute;\n        content: '';\n        width: 100%;\n        border-radius: 3px;\n        bottom: -2px;\n        left: 0;\n        background-color: ",
        ";\n        height: 2px;\n      }\n    }\n\n    &.active {\n      a {\n        color: ",
        ";\n      }\n    }\n    &.disabled {\n      & > * {\n        opacity: 0.5;\n      }\n      cursor: default;\n      pointer-events: none;\n      a {\n        cursor: default;\n        pointer-events: none;\n      }\n    }\n  "
    ]);
    Tabs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tabs_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Tabs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Tabs_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    list-style-type: none;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    ",
        "\n    ",
        "\n  "
    ]);
    Tabs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Tabs_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Tabs_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Tabs_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  -ms-flex: 1 1 auto;\n  overflow: auto;\n  background-color: ",
        ";\n  padding: 2em;\n"
    ]);
    Tabs_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var TabsWrapper = globalStyles/* styled.div */.zo.div(Tabs_styles_templateObject());
var Tab = globalStyles/* styled.li */.zo.li(Tabs_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(Tabs_styles_templateObject1(), function(param) {
        var spacing = param.theme.spacing;
        return spacing.gutter;
    }, function(param) {
        var spacing = param.theme.spacing;
        return spacing.gutter;
    }, theme.colors.red, theme.colors.red);
});
var Tabs = globalStyles/* styled.ul */.zo.ul(Tabs_styles_templateObject4(), function(param) {
    var theme = param.theme, fullWidth = param.fullWidth;
    return (0,styled_components_browser_esm/* css */.iv)(Tabs_styles_templateObject3(), fullWidth && "justify-content: space-around;", !fullWidth && "justify-content: center;");
});
var Tabs_styles_Content = globalStyles/* styled.div */.zo.div(Tabs_styles_templateObject5(), function(props) {
    return props.theme.colors.light;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Tabs/Tabs.tsx
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */ 





var Tabs_Tab = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_styles_Content, {
        className: "tab-content",
        children: props.children
    });
};
var Tabs_Tabs = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), tabs = ref[0], setTabs = ref[1];
    var _activeIndex;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState((_activeIndex = props.activeIndex) !== null && _activeIndex !== void 0 ? _activeIndex : 0), 2), active = ref1[0], setActive = ref1[1];
    var selectTab = function(index) {
        if (typeof props.onSelect === "function") {
            props.onSelect(index);
        }
        setActive(index);
    };
    react.useEffect(function() {
        if (props.activeIndex) {
            setActive(props.activeIndex);
        }
    }, [
        props.activeIndex
    ]);
    react.useEffect(function() {
        var children = [];
        react.Children.forEach(props.children, function(child) {
            // @ts-ignore
            if (child.props.title) {
                // @ts-ignore
                children.push((0,_object_spread/* default */.Z)({}, child.props));
            }
        });
        setTabs(children);
    }, [
        props.children
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
        className: props.className,
        style: props.style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                className: "tabs",
                fullWidth: props.fullWidth,
                children: tabs.map(function(tab, index) {
                    var cssClass = [
                        "tab"
                    ];
                    if (index === active) {
                        cssClass.push("active");
                    }
                    if (tab.disabled) {
                        cssClass.push("disabled");
                    }
                    if (tab.className) {
                        var _cssClass;
                        (_cssClass = cssClass).push.apply(_cssClass, (0,_to_consumable_array/* default */.Z)(tab.className.split(" ")));
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                        style: tab.style,
                        className: cssClass.join(" "),
                        onClick: function() {
                            return !tab.disabled && selectTab(index);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: tab.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tab.title
                            })
                        })
                    }, index);
                })
            }),
            react.Children.map(props.children, function(child, i) {
                // @ts-ignore
                if (i === active && child.props.children) {
                    return child;
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/@next/components/atoms/Tabs/index.ts


;// CONCATENATED MODULE: ./src/@next/components/overlays/AttributeMessage/styles.ts

function AttributeMessage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:100%;\n    max-width: 100vw;\n  "
    ]);
    AttributeMessage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 65vw;\n  ",
        "\n"
    ]);
    AttributeMessage_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AttributeMessage_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1em;\n"
    ]);
    AttributeMessage_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(1, 1fr);\n  "
    ]);
    AttributeMessage_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  ",
        "\n"
    ]);
    AttributeMessage_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 1em;\n"
    ]);
    AttributeMessage_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    AttributeMessage_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    AttributeMessage_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n\n  b {\n    font-weight: 600;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n\n  & em {\n    color: ",
        ";\n  }\n"
    ]);
    AttributeMessage_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function AttributeMessage_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n  }\n\n  b {\n    font-family: ",
        ";\n  }\n\n  strong {\n    font-family: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n"
    ]);
    AttributeMessage_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

// import { css } from 'styled-components';
var AttributeMessage_styles_Modal = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(AttributeMessage_styles_templateObject()));
var AttributeMessage_styles_Wrapper = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject2());
var Header = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject3());
var Container = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject5(), function(param) {
    var columns = param.columns;
    return "repeat(".concat(columns < 3 ? columns : 3, ", 1fr)");
}, globalStyles/* media.smallScreen */.BC.smallScreen(AttributeMessage_styles_templateObject4()));
var Card = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject6());
var Image = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject7());
var styles_Name = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject8());
var AttributeMessage_styles_Content = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject9(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.baseFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
});
var Footer = globalStyles/* styled.div */.zo.div(AttributeMessage_styles_templateObject10(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.baseFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.typography.boldFontFamily;
}, function(props) {
    return props.theme.typography.boldFontFamily;
});

;// CONCATENATED MODULE: ./src/images/width.svg
var width_namespaceObject = __webpack_require__.p + "static/images/width.svg";
;// CONCATENATED MODULE: ./src/images/height.svg
var height_namespaceObject = __webpack_require__.p + "static/images/height.svg";
;// CONCATENATED MODULE: ./src/images/spaceabove.svg
var spaceabove_namespaceObject = __webpack_require__.p + "static/images/spaceabove.svg";
;// CONCATENATED MODULE: ./src/images/warning.svg
var warning_namespaceObject = __webpack_require__.p + "static/images/warning.svg";
;// CONCATENATED MODULE: ./src/@next/components/overlays/AttributeMessage/icon.tsx






var getIcon = function(iconName) {
    switch(iconName){
        case "width":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: width_namespaceObject
            });
        case "height":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: height_namespaceObject
            });
        case "spaceabove":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: spaceabove_namespaceObject
            });
        case "warning":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: warning_namespaceObject
            });
        default:
            return iconName;
    }
};

;// CONCATENATED MODULE: ./src/@next/components/overlays/AttributeMessage/AttributeMessage.tsx









var AttributeMessage = function(param) {
    var show = param.show, hide = param.hide, target = param.target, attribute = param.attribute;
    var tabs = (attribute === null || attribute === void 0 ? void 0 : attribute.body) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: show,
        hide: hide,
        target: target,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeMessage_styles_Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                    onHide: hide,
                    children: (attribute === null || attribute === void 0 ? void 0 : attribute.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: asText/* asText */.S(attribute.header)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeMessage_styles_Wrapper, {
                    children: tabs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                        children: tabs.map(function(tab, i) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Tabs_Tab, {
                                title: asText/* asText */.S(tab.primary.tab_title),
                                children: [
                                    (tab === null || tab === void 0 ? void 0 : (ref = tab.primary) === null || ref === void 0 ? void 0 : ref.tab_message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                        children: [
                                            getIcon("warning"),
                                            asText/* asText */.S(tab.primary.tab_message)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                                        columns: (tab === null || tab === void 0 ? void 0 : tab.fields.length) || 0,
                                        children: (tab === null || tab === void 0 ? void 0 : tab.fields) && tab.fields.map(function(item, i) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Card, {
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : item.tab_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                                            field: item.tab_image,
                                                            style: {
                                                                maxWidth: "100%",
                                                                height: "100%"
                                                            }
                                                        })
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.tab_name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Name, {
                                                        children: [
                                                            (item === null || item === void 0 ? void 0 : item.tab_icon) && getIcon(item === null || item === void 0 ? void 0 : item.tab_icon),
                                                            asText/* asText */.S(item.tab_name)
                                                        ]
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.tab_content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeMessage_styles_Content, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                            field: item.tab_content
                                                        })
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.tab_footer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                            field: item.tab_footer
                                                        })
                                                    })
                                                ]
                                            }, "".concat(asText/* asText */.S(tab.primary.tab_title), "-").concat(i));
                                        })
                                    })
                                ]
                            }, asText/* asText */.S(tab.primary.tab_title));
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/overlays/AttributeMessage/index.tsx


;// CONCATENATED MODULE: ./src/@next/components/molecules/ProductAttributeButton/styles.ts

function ProductAttributeButton_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -9px;\n  "
    ]);
    ProductAttributeButton_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -6px;\n  "
    ]);
    ProductAttributeButton_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0px;\n    margin-bottom: 10px;\n  "
    ]);
    ProductAttributeButton_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n  "
    ]);
    ProductAttributeButton_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: -10px;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ProductAttributeButton_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    ProductAttributeButton_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 30px;\n  background: ",
        ";\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  ",
        "\n\n  .arrow-icon {\n    position: relative;\n    top: -1px;\n    -webkit-transition: -webkit-transform 0.3s ease;\n    transition: -webkit-transform 0.3s ease;\n    transition: transform 0.3s ease;\n    transition: transform 0.3s ease, -webkit-transform 0.3s ease;\n    vertical-align: middle;\n    g {\n      stroke: ",
        ";\n    }\n  }\n\n  .arrow-icon--circle {\n    transition: stroke-dashoffset 0.3s ease;\n    stroke-dasharray: 95;\n    stroke-dashoffset: 95;\n  }\n\n  &:hover {\n    .arrow-icon {\n      transform: translate3d(5px, 0, 0);\n    }\n\n    .arrow-icon--circle {\n      stroke-dashoffset: 0;\n    }\n  }\n"
    ]);
    ProductAttributeButton_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  opacity: 0.5;\n  p {\n    line-height: 100%;\n  }\n  strong {\n    color: ",
        ";\n  }\n  em {\n    color: ",
        ";\n  }\n"
    ]);
    ProductAttributeButton_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProductAttributeButton_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    ProductAttributeButton_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var ProductAttributeButton_styles_Wrapper = globalStyles/* styled.div */.zo.div(ProductAttributeButton_styles_templateObject4(), globalStyles/* media.xLargeScreen */.BC.xLargeScreen(ProductAttributeButton_styles_templateObject()), globalStyles/* media.largeScreen */.BC.largeScreen(ProductAttributeButton_styles_templateObject1()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ProductAttributeButton_styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductAttributeButton_styles_templateObject3()));
var ProductAttributeButton_styles_Button = globalStyles/* styled.button */.zo.button(ProductAttributeButton_styles_templateObject6(), function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductAttributeButton_styles_templateObject5()), function(param) {
    var colors = param.theme.colors;
    return colors.primary;
});
var ProductAttributeButton_styles_Text = globalStyles/* styled.span */.zo.span(ProductAttributeButton_styles_templateObject7(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(props) {
    return props.theme.colors.primary;
}, function(props) {
    return props.theme.colors.secondary;
});
var ProductAttributeButton_styles_Icon = globalStyles/* styled.div */.zo.div(ProductAttributeButton_styles_templateObject8(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.labelFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/ProductAttributeButton/ProductAttributeButton.tsx







var ProductAttributeButton = function(param) {
    var attribute = param.attribute;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductAttributeButton_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeMessage, {
                hide: function() {
                    return setShow(false);
                },
                show: show,
                attribute: attribute
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductAttributeButton_styles_Button, {
                type: "button",
                onClick: function() {
                    return setShow(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAttributeButton_styles_Text, {
                        children: (attribute === null || attribute === void 0 ? void 0 : attribute.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: attribute.message
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAttributeButton_styles_Icon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: arrow_icon_namespaceObject
                        })
                    })
                ]
            })
        ]
    });
};
ProductAttributeButton.displayName = "ProductAttributeButton";

;// CONCATENATED MODULE: ./src/@next/components/molecules/ProductAttributeButton/index.ts


;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductVariantPicker/utils.ts
var orderedAttributes = [
    "door-style",
    "glass-type",
    "system-style",
    "system-color",
    "system-type",
    "door-color",
    "door-color-paint",
    "door-color-oil",
    "door-color-ash",
    "door-color-rattan",
    "color-samples",
    "handle-color",
    "width",
    "height",
    "track",
    "configuration",
    "door-density",
    "orientation", 
];
var orderedMobileAttributes = [
    "width",
    "height",
    "door-color",
    "door-color-paint",
    "door-color-oil",
    "door-color-ash",
    "door-color-rattan",
    "door-style",
    "door-type",
    "glass-type",
    "system-style",
    "system-color",
    "system-type",
    "color-samples",
    "handle-color",
    "track",
    "configuration",
    "door-density",
    "orientation", 
];
var attributesSorter = function(a, b) {
    return orderedAttributes.indexOf(a.attribute.slug) - orderedAttributes.indexOf(b.attribute.slug);
};
var attributesMobileSorter = function(a, b) {
    return orderedMobileAttributes.indexOf(a.attribute.slug) - orderedMobileAttributes.indexOf(b.attribute.slug);
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductVariantPicker/styles.ts

function ProductVariantPicker_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ProductVariantPicker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #2c2c2c1a;\n    overflow-x: auto;\n    overflow: hidden;\n    scroll-behavior: smooth;\n\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);\n      background-color: #ffffff;\n    }\n    &::-webkit-scrollbar {\n      height: 2px;\n      background-color: rgba(44, 44, 44, 0.25);\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(44, 44, 44, 0.25);\n    }\n  "
    ]);
    ProductVariantPicker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 10px;\n  "
    ]);
    ProductVariantPicker_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        "\n  ",
        "\n"
    ]);
    ProductVariantPicker_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: relative;\n        &:after {\n          content: '';\n          position: absolute;\n          height: 2px;\n          left: 0;\n          right: 0;\n          bottom: -6px;\n          background-color: red;\n        }\n      "
    ]);
    ProductVariantPicker_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &:after {\n          bottom: -8px;\n        }\n      "
    ]);
    ProductVariantPicker_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    ProductVariantPicker_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    margin: 0 15px;\n    color: #000000;\n    outline: none;\n    opacity: ",
        ";\n    white-space: nowrap;\n    flex-shrink: 0;\n    &:first-of-type {\n      margin-left: 0;\n    }\n    &:last-of-type {\n      margin-right: 0;\n    }\n    ",
        ";\n  "
    ]);
    ProductVariantPicker_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ProductVariantPicker_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    ProductVariantPicker_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: ",
        ";\n    padding-top: 10px;\n    overflow-x: auto;\n  "
    ]);
    ProductVariantPicker_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 18px;\n    "
    ]);
    ProductVariantPicker_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 12px;\n    "
    ]);
    ProductVariantPicker_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 0;\n    "
    ]);
    ProductVariantPicker_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n  &:not(:last-child) {\n    margin-bottom: 20px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    ProductVariantPicker_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 20px;\n  "
    ]);
    ProductVariantPicker_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    ProductVariantPicker_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ProductVariantPicker_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.5;\n  white-space: nowrap;\n  margin-right: 30px;\n  font-size: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    ProductVariantPicker_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var ProductVariantPicker_styles_Wrapper = globalStyles/* styled.form */.zo.form(ProductVariantPicker_styles_templateObject());
var TabList = globalStyles/* styled.div */.zo.div(ProductVariantPicker_styles_templateObject3(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductVariantPicker_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductVariantPicker_styles_templateObject2()));
var styles_Tab = globalStyles/* styled.div */.zo.div(ProductVariantPicker_styles_templateObject8(), function(param) {
    var active = param.active, theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ProductVariantPicker_styles_templateObject7(), theme.typography.baseFontFamily, theme.typography.baseFontSize, theme.typography.baseFontSize, active ? 1 : 0.3, active && (0,styled_components_browser_esm/* css */.iv)(ProductVariantPicker_styles_templateObject6(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductVariantPicker_styles_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductVariantPicker_styles_templateObject5())));
});
var TabContent = globalStyles/* styled.div */.zo.div(ProductVariantPicker_styles_templateObject9());
var Item = globalStyles/* styled.div */.zo.div(ProductVariantPicker_styles_templateObject14(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductVariantPicker_styles_templateObject10(), function(param) {
    var hide = param.hide;
    return hide ? "none" : "flex";
}), globalStyles/* media.xLargeScreen */.BC.xLargeScreen(ProductVariantPicker_styles_templateObject11()), globalStyles/* media.largeScreen */.BC.largeScreen(ProductVariantPicker_styles_templateObject12()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductVariantPicker_styles_templateObject13()));
var ProductVariantPicker_styles_Name = globalStyles/* styled.div */.zo.div(ProductVariantPicker_styles_templateObject17(), function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.xLargeScreen */.BC.xLargeScreen(ProductVariantPicker_styles_templateObject15()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(ProductVariantPicker_styles_templateObject16()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductVariantPicker/ProductVariantPicker.tsx














var ProductVariantPicker = function(param) {
    var attributes = param.attributes, setActiveImage = param.setActiveImage, isSampleType = param.isSampleType, productType = param.productType;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smMediumScreen */.Hj, "px)")), 1), isSmallScreen = ref[0];
    var data = (0,prismicHooks/* usePrismicProductPageQuery */.p7S)({
        variables: {
            productUid: productType
        }
    }).data;
    var colorSample = (0,react.useMemo)(function() {
        var ref = data || {}, prismicProduct = ref.product;
        return (prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.body.filter(function(slice) {
            return slice.type === "color_sample";
        })) || [];
    }, [
        data
    ]);
    var productAttributes = (0,react.useMemo)(function() {
        var ref = data || {}, prismicProduct = ref.product;
        return (prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.attributes) || [];
    }, [
        data
    ]);
    // Ensure we scroll the tab container to expose all attributes
    var tabWrapper = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    (0,react.useEffect)(function() {
        if (tabWrapper) {
            var activeWrapper = tabWrapper.current.children[activeIndex];
            var activeWidth = activeWrapper.offsetWidth;
            var activeLeft = activeWrapper.offsetLeft;
            var scrollWidth = tabWrapper.current.offsetWidth;
            var scrollLeft = tabWrapper.current.offsetLeft;
            var scrollLeftPosition = activeLeft - scrollLeft - scrollWidth / 2 + activeWidth / 2;
            tabWrapper.current.scrollLeft = scrollLeftPosition;
        }
    }, [
        activeIndex
    ]);
    var sortedAttributes = (0,react.useMemo)(function() {
        return isSmallScreen ? attributes.sort(attributesMobileSorter) : attributes.sort(attributesSorter);
    }, [
        attributes,
        isSmallScreen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductVariantPicker_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList, {
                ref: tabWrapper,
                children: sortedAttributes.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Tab, {
                        active: activeIndex === i,
                        onClick: function() {
                            return setActiveIndex(i);
                        },
                        onKeyPress: function() {
                            return setActiveIndex(i);
                        },
                        role: "button",
                        tabIndex: 0,
                        children: !isSampleType && upperFirst_default()((0,translations/* translate */.I)(item.attribute, "name")).replace("-", " ")
                    }, "tab-".concat(item.attribute.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContent, {}),
            sortedAttributes.map(function(item, i) {
                var AttributeField = getAttributeChoiceTypeFieldComponent(item.attribute.choiceType);
                var productAttribute = productAttributes.find(function(pa) {
                    return pa.attribute_slug === item.attribute.slug;
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            hide: activeIndex !== i,
                            children: [
                                !isSampleType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductVariantPicker_styles_Name, {
                                    children: [
                                        upperFirst_default()((0,translations/* translate */.I)(item.attribute, "name")).replace("-", " "),
                                        ":"
                                    ]
                                }, "name-".concat(item.attribute.id)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeField, {
                                    attribute: item,
                                    squareOptions: isSampleType,
                                    onOptionHover: function(option) {
                                        var // texture as a fallback
                                        ref;
                                        setActiveImage((option === null || option === void 0 ? void 0 : (ref = option.image) === null || ref === void 0 ? void 0 : ref.url) || (0,utils/* getTextureThumbnailUrl */.g)(option === null || option === void 0 ? void 0 : option.slug));
                                    }
                                })
                            ]
                        }, "content-".concat(item.attribute.id)),
                        item.attribute.slug.includes("door-color") && colorSample.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            hide: activeIndex !== i,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSamplesButton, {
                                colorSample: colorSample
                            })
                        }, "content-color-samples-button"),
                        productAttribute && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            hide: activeIndex !== i,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAttributeButton, {
                                attribute: productAttribute.attribute_content
                            }, "content-".concat(productAttribute.attribute_slug, "-button"))
                        })
                    ]
                }, item.attribute.id);
            })
        ]
    });
};
ProductVariantPicker.displayName = "ProductVariantPicker";

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductVariantPicker/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/QuantityInput/index.tsx + 4 modules
var QuantityInput = __webpack_require__(39117);
// EXTERNAL MODULE: ./src/images/heart.svg
var heart = __webpack_require__(25280);
// EXTERNAL MODULE: ./src/@next/components/overlays/ShareProject/index.tsx + 12 modules
var ShareProject = __webpack_require__(30797);
// EXTERNAL MODULE: ./src/views/Product/utils/index.ts + 7 modules
var Product_utils = __webpack_require__(18222);
;// CONCATENATED MODULE: ./src/@next/components/molecules/SaveForLaterButton/SaveForLaterButton.tsx









var SaveForLaterButton = function(param) {
    var product = param.product, formAttributes = param.formAttributes, productAttributes = param.productAttributes, productId = param.productId, productName = param.productName, variantId = param.variantId;
    var showShareProject = function(initialState) {
        var productImage;
        var productUrl;
        try {
            // productImage = productViewRef.current?.getScreenshot();
            productImage = (0,Product_utils/* generateProductImageWithAttributes */.mv)(product, formAttributes);
            productUrl = (0,Product_utils/* generateProductUrlWithAttributes */.pT)(product, formAttributes);
        } catch (error) {
            console.error("error: ", error);
        }
        esm/* default.show */.ZP.show(ShareProject/* ShareProjectModal */.VO, {
            initialState: initialState,
            selectedProductAttributes: productAttributes,
            productCategory: (0,translations/* translate */.I)(product.category, "name"),
            productId: product.slug,
            productImage: productImage,
            productName: productName,
            productUrl: productUrl,
            variantId: variantId
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
        onClick: function() {
            showShareProject(ShareProject/* ShareState.initial */.ze.initial);
        },
        size: "sm",
        appearance: "outline",
        style: {
            width: "20%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
            src: heart
        })
    });
};
SaveForLaterButton.displayName = "SaveForLaterButton";

;// CONCATENATED MODULE: ./src/@next/components/molecules/SaveForLaterButton/index.tsx


// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/images/cart_white.svg
var cart_white = __webpack_require__(60566);
;// CONCATENATED MODULE: ./src/@next/components/molecules/AddToCartButton/AddToCartButton.tsx


function AddToCartButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 10px;\n  & > img {\n    height: 19px;\n  }\n"
    ]);
    AddToCartButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AddToCartButton_Wrapper = globalStyles/* styled.div */.zo.div(AddToCartButton_templateObject());
var AddToCartButton = function(param) {
    var onSubmit = param.onSubmit, disabled = param.disabled, price = param.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
        fullWidth: true,
        onClick: onSubmit,
        size: "sm",
        color: "primary",
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddToCartButton_Wrapper, {
            children: [
                price,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.addToCart */.i4.addToCart)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: cart_white,
                    alt: "cart icon"
                })
            ]
        })
    });
};
AddToCartButton.displayName = "AddToCartButton";

;// CONCATENATED MODULE: ./src/@next/components/molecules/AddToCartButton/index.tsx


// EXTERNAL MODULE: ./src/@next/components/molecules/EstimatedShipping/index.ts + 1 modules
var EstimatedShipping = __webpack_require__(99793);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./src/@next/components/containers/TaxedMoney/index.ts + 1 modules
var TaxedMoney = __webpack_require__(31740);
;// CONCATENATED MODULE: ./src/@next/components/organisms/AddToCartSection/styles.ts

function AddToCartSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 20px 40px;\n    // height: auto;\n  "
    ]);
    AddToCartSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 5px 10px;\n    // height: auto;\n  "
    ]);
    AddToCartSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 15px 15px 15px 0;\n  background: #ffffff;\n  border-radius: 10px;\n  overflow: hidden;\n  z-index: 1;\n  // max-height: 90%;\n  width: 100%;\n  ",
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px 40px;\n  "
    ]);
    AddToCartSection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px 20px 10px;\n  "
    ]);
    AddToCartSection_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 25px 48px 25px 48px;\n  overflow: auto;\n  ",
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n    margin-bottom: 10px;\n  "
    ]);
    AddToCartSection_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 6px;\n  "
    ]);
    AddToCartSection_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  ",
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 110%;\n  "
    ]);
    AddToCartSection_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 110%;\n  "
    ]);
    AddToCartSection_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 110%;\n  align-items: center;\n  text-transform: capitalize;\n  ",
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: ",
        ";\n  line-height: 110%;\n"
    ]);
    AddToCartSection_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  font-size: ",
        ";\n  span {\n    position: relative;\n  }\n  span:before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    background-color: ",
        ";\n    border-radius: 2px;\n    top: 50%;\n    left: 0;\n  }\n"
    ]);
    AddToCartSection_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 160%;\n  "
    ]);
    AddToCartSection_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n  "
    ]);
    AddToCartSection_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  text-align: right;\n  color: ",
        ";\n  margin-bottom: 10px;\n  ",
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AddToCartSection_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AddToCartSection_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    AddToCartSection_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    padding: 0px 18px 10px 18px;\n  "
    ]);
    AddToCartSection_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  border-top: 1px solid #e9e9e9;\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 10px;\n    display: none;\n"
    ]);
    AddToCartSection_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 10px;\n  "
    ]);
    AddToCartSection_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function AddToCartSection_styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  ",
        "\n"
    ]);
    AddToCartSection_styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}

var AddToCartSection = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject2(), globalStyles/* media.mediumScreen */.BC.mediumScreen(AddToCartSection_styles_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject1()));
var ContentContainer = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject5(), globalStyles/* media.largeScreen */.BC.largeScreen(AddToCartSection_styles_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(AddToCartSection_styles_templateObject4()));
var styles_Header = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject8(), globalStyles/* media.largeScreen */.BC.largeScreen(AddToCartSection_styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject7()));
var ProductNameHeader = globalStyles/* styled.h1 */.zo.h1(AddToCartSection_styles_templateObject11(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h5FontSize;
}, globalStyles/* media.xLargeScreen */.BC.xLargeScreen(AddToCartSection_styles_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject10()));
var ProductPricing = globalStyles/* styled.h4 */.zo.h4(AddToCartSection_styles_templateObject12(), function(param) {
    var typography = param.theme.typography;
    return typography.h5FontSize;
});
var UndiscountedPrice = globalStyles/* styled.span */.zo.span(AddToCartSection_styles_templateObject13(), function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(props) {
    return props.theme.colors.grayDark;
});
var styles_EstimatedShipping = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject16(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.labelFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, globalStyles/* media.xLargeScreen */.BC.xLargeScreen(AddToCartSection_styles_templateObject14()), globalStyles/* media.mediumScreen */.BC.mediumScreen(AddToCartSection_styles_templateObject15()));
var VariantPicker = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject17());
var styles_QuantityInput = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject18());
var ErrorMessage = globalStyles/* styled.p */.zo.p(AddToCartSection_styles_templateObject19(), function(props) {
    return props.theme.colors.error;
});
var ButtonContainer = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject21(), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject20()));
var QuantityContainer = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject23(), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject22()));
var ActionContainer = globalStyles/* styled.div */.zo.div(AddToCartSection_styles_templateObject25(), globalStyles/* media.smallScreen */.BC.smallScreen(AddToCartSection_styles_templateObject24()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/AddToCartSection/stockHelpers.tsx





var LOW_STOCK_QUANTITY = 5;
var MIN_SAMPLE_ITEMS = 1;
var MAX_SAMPLE_ITEMS = 5;
/**
 * Renders formatted price for chosen variant or product.
 * Price ranges and discounts are additionally formatted available.
 */ var getProductPrice = function(productPricingRange, variantPricing) {
    if (variantPricing) {
        if (isEqual_default()(variantPricing.priceUndiscounted, variantPricing.price)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                taxedMoney: variantPricing.price
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UndiscountedPrice, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                        taxedMoney: variantPricing.priceUndiscounted
                    })
                }),
                "\xa0\xa0\xa0\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                    taxedMoney: variantPricing.price
                })
            ]
        });
    }
    if (!productPricingRange.priceRange) {
        return null;
    }
    var _priceRange = productPricingRange.priceRange, start = _priceRange.start, stop = _priceRange.stop;
    if (isEqual_default()(start, stop)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
            taxedMoney: start
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                taxedMoney: start
            }),
            " - ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                taxedMoney: stop
            })
        ]
    });
};
var canAddToCart = function(items, isAvailableForPurchase, variantId, variantStock, quantity) {
    var cartItem = items === null || items === void 0 ? void 0 : items.find(function(item) {
        return item.variant.id === variantId;
    });
    var syncedQuantityWithCart = cartItem ? quantity + ((cartItem === null || cartItem === void 0 ? void 0 : cartItem.quantity) || 0) : quantity;
    return isAvailableForPurchase && quantity > 0 && !!variantId && variantStock >= syncedQuantityWithCart;
};
var canAddSampleToCart = function(selectedAttributes) {
    var selectedNumber = selectedAttributes[0].values.filter(Boolean).length;
    return selectedNumber >= MIN_SAMPLE_ITEMS;
};
/**
 * Returns how many items you can add to the cart. Takes in account quantity already in cart.
 */ var getAvailableQuantity = function(items, variantId, variantStock) {
    var cartItem = items === null || items === void 0 ? void 0 : items.find(function(item) {
        return item.variant.id === variantId;
    });
    var quantityInCart = (cartItem === null || cartItem === void 0 ? void 0 : cartItem.quantity) || 0;
    return variantStock - quantityInCart;
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/AddToCartSection/AddToCartSection.tsx
// import './scss/index.scss';











var AddToCartSection_AddToCartSection = function(param) {
    var items = param.items, attributes = param.attributes, formAttributes = param.formAttributes, productAttributes = param.productAttributes, onAddToCart = param.onAddToCart, isSampleType = param.isSampleType, setActiveImage = param.setActiveImage, product = param.product, productId = param.productId, productName = param.productName, productPricing = param.productPricing, variantId = param.variantId, variantPricing = param.variantPricing, variantStock = param.variantStock;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(1), quantity = ref[0], setQuantity = ref[1];
    var availableQuantity = getAvailableQuantity(items, variantId, variantStock);
    var isOutOfStock = !!variantId && variantStock === 0;
    var isAvailableForPurchase = product.isAvailableForPurchase, availableForPurchase = product.availableForPurchase;
    var noPurchaseAvailable = !isAvailableForPurchase && !availableForPurchase;
    var purchaseAvailableDate = !isAvailableForPurchase && availableForPurchase && Date.parse(availableForPurchase);
    var isNoItemsAvailable = !variantId || !!variantId && !isOutOfStock && !availableQuantity;
    var isLowStock = !!variantId && !isOutOfStock && !isNoItemsAvailable && availableQuantity < LOW_STOCK_QUANTITY;
    var disableButton = !isSampleType ? !canAddToCart(items, !!isAvailableForPurchase, variantId, variantStock, quantity) : !canAddSampleToCart(productAttributes);
    var renderErrorMessage = function(message, testingContextId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
            "data-test": "stockErrorMessage",
            "data-testId": testingContextId,
            children: message
        });
    };
    var renderSampleMessage = function(productAttributes) {
        var ref;
        var selectedNumber = ((ref = productAttributes[0]) === null || ref === void 0 ? void 0 : ref.values.filter(Boolean).length) || 0;
        var message = selectedNumber ? intl.formatMessage(src_intl/* commonMessages.itemsSelected */.i4.itemsSelected, {
            selectedNumber: selectedNumber || ""
        }) : intl.formatMessage(src_intl/* commonMessages.itemsMinMax */.i4.itemsMinMax, {
            maxItems: MAX_SAMPLE_ITEMS || "",
            minItems: MIN_SAMPLE_ITEMS || ""
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
            "data-test": "stockErrorMessage",
            "data-testId": "sampleCount",
            children: message
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddToCartSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNameHeader, {
                                children: productName
                            }),
                            isOutOfStock ? renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.outOfStock */.i4.outOfStock), "outOfStock") : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPricing, {
                                children: getProductPrice(productPricing, variantPricing)
                            })
                        ]
                    }),
                    noPurchaseAvailable ? renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.noPurchaseAvailable */.i4.noPurchaseAvailable), "notAvailable") : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_EstimatedShipping, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EstimatedShipping/* EstimatedShipping */.$, {
                            productType: product.productType,
                            type: "long"
                        })
                    }),
                    purchaseAvailableDate && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.purchaseAvailableOn */.i4.purchaseAvailableOn, {
                        date: new Intl.DateTimeFormat("default", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                        }).format(purchaseAvailableDate),
                        time: new Intl.DateTimeFormat("default", {
                            hour: "numeric",
                            minute: "numeric"
                        }).format(purchaseAvailableDate)
                    }), "timeRestrictedAvailability"),
                    isLowStock && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.lowStock */.i4.lowStock), "lowStockWarning"),
                    isNoItemsAvailable && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.noItemsAvailable */.i4.noItemsAvailable), "noItemsAvailable"),
                    isSampleType && renderSampleMessage(productAttributes),
                    (isSampleType || product.productType.hasVariants) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantPicker, {
                        attributes: attributes,
                        isSampleType: isSampleType,
                        setActiveImage: setActiveImage,
                        productType: product.productType.slug
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityInput/* QuantityInput */.F, {
                            quantity: quantity,
                            maxQuantity: availableQuantity,
                            disabled: isOutOfStock || isNoItemsAvailable,
                            onQuantityChange: setQuantity,
                            hideErrors: !variantId || isOutOfStock || isNoItemsAvailable
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveForLaterButton, {
                                product: product,
                                formAttributes: formAttributes,
                                productAttributes: productAttributes,
                                productId: productId,
                                productName: productName,
                                variantId: variantId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, {
                                onSubmit: function() {
                                    return onAddToCart(quantity);
                                },
                                disabled: disableButton,
                                price: getProductPrice(productPricing, variantPricing)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/AddToCartSection/index.tsx



// EXTERNAL MODULE: ./src/@next/components/containers/ErrorBoundary/index.ts + 1 modules
var ErrorBoundary = __webpack_require__(82229);
// EXTERNAL MODULE: ./src/@next/components/overlays/Cart/index.ts + 5 modules
var Cart = __webpack_require__(55646);
// EXTERNAL MODULE: ./src/@next/hooks/useDeepEffect.ts
var useDeepEffect = __webpack_require__(49813);
;// CONCATENATED MODULE: ./src/views/Product/hooks/useVariantId.ts




/**
 * Adjusts the pricing of a variant, maintaining any existing discounts.
 *
 * Takes a ProductVariantsPricing object and a price formula string
 * with variables, and returns a new ProductVariantsPricing object
 * with the price adjusted based on the formula evaluation.
 *
 * Calculates the current discount amount and applies it to the new price
 * to maintain the same effective discount.
 *
 * Also updates the onSale flag based on whether a discount exists or not.
 */ var adjustPrice = function(pricing, adjustedPrice) {
    // Calculate the difference between the current price and the undiscounted price
    var discountDifferenceGross = pricing.priceUndiscounted.gross.amount - pricing.price.gross.amount;
    var discountDifferenceNet = pricing.priceUndiscounted.net.amount - pricing.price.net.amount;
    // Apply the adjusted price, maintaining the discount difference
    pricing.price.gross.amount = adjustedPrice;
    pricing.price.net.amount = adjustedPrice;
    // Adjust the undiscounted price to maintain the same difference
    pricing.priceUndiscounted.gross.amount = adjustedPrice + discountDifferenceGross;
    pricing.priceUndiscounted.net.amount = adjustedPrice + discountDifferenceNet;
    // Update the onSale flag based on whether there is a discount or not
    pricing.onSale = pricing.price.gross.amount !== pricing.priceUndiscounted.gross.amount;
    return pricing;
};
/**
 * Evaluates a pricing formula based on product attributes.
 *
 * Takes a Record of attribute key/values and returns the calculated price.
 * Applies various price adjustments based on specific attribute values.
 */ var priceFormulaEvalFunction = function(attributes) {
    var price = attributes.price;
    if (attributes["glass-type"] === "double-mirror") {
        price += 165;
    }
    if (attributes["door-style"] === "verriere") {
        price += 245;
    }
    if (parseInt(attributes.height || "2100", 10) % 100 !== 0) {
        price += 100;
    }
    if (parseInt(attributes.height || "2100", 10) > 2300) {
        price += 100;
    }
    return price;
};
/**
 * Hook to determine the currently selected variant ID, stock level, and pricing
 * for a product based on selected attribute values.
 *
 * Tracks the selected variant and pricing as the attribute values change.
 */ var useVariantId = function(attributesFormData, product) {
    var ref = (0,react.useState)(null), variantId = ref[0], setVariantId = ref[1];
    var ref1 = (0,react.useState)(0), variantStock = ref1[0], setVariantStock = ref1[1];
    var ref2 = (0,react.useState)(null), variantPricing = ref2[0], setVariantPricing = ref2[1];
    // const dependency = Object.values(attributesFormData)
    // .filter((s) => s)
    //  .join('');
    (0,useDeepEffect/* useDeepEffect */.Hu)(function() {
        var updateVariant = function() {
            var selectedVariant = product.variants.find(function(productVariant) {
                return productVariant.attributes.every(function(productVariantAttribute) {
                    var ref;
                    var productVariantSlug = (ref = productVariantAttribute.values[0]) === null || ref === void 0 ? void 0 : ref.slug;
                    var attributesFormSlug = attributesFormData[productVariantAttribute.attribute.slug];
                    var isVariantAttributeSelected = productVariantSlug === attributesFormSlug;
                    return isVariantAttributeSelected;
                });
            });
            var adjustedPricing = structuredClone(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.pricing);
            var productType = product.productType;
            if (productType.isPriceFormula && productType.priceFormula) {
                var adjustedPrice = priceFormulaEvalFunction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributesFormData), {
                    price: adjustedPricing.price.gross.amount
                }));
                if (adjustedPrice) {
                    adjustedPricing = adjustPrice(adjustedPricing, adjustedPrice);
                }
            }
            setVariantId((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || null);
            setVariantPricing(adjustedPricing || null);
            setVariantStock((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantityAvailable) || 0);
        };
        updateVariant();
    }, [
        attributesFormData,
        product.variants,
        product.productType
    ]);
    return {
        variantId: variantId,
        variantStock: variantStock,
        variantPricing: variantPricing
    };
};

// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/SliceZone.js + 1 modules
var SliceZone = __webpack_require__(172);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/@lib/Configurator3D/ModelFactory.ts + 18 modules
var ModelFactory = __webpack_require__(72722);
// EXTERNAL MODULE: ./src/@next/components/organisms/ProductReviews/index.tsx + 10 modules
var ProductReviews = __webpack_require__(10273);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceInspiration/index.ts + 2 modules
var SliceInspiration = __webpack_require__(708);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceInstagramPosts/index.ts + 5 modules
var SliceInstagramPosts = __webpack_require__(84057);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLabeledIcons/styles.ts

function SliceLabeledIcons_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n\n  margin: 1em 0;\n"
    ]);
    SliceLabeledIcons_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n"
    ]);
    SliceLabeledIcons_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 0;\n    margin-bottom: 1em;\n  "
    ]);
    SliceLabeledIcons_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  &:last-child {\n    margin-right: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  ",
        "\n"
    ]);
    SliceLabeledIcons_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 50px;\n    width: 60px;\n  "
    ]);
    SliceLabeledIcons_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 12px;\n  "
    ]);
    SliceLabeledIcons_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 45px;\n    height: 34px;\n  "
    ]);
    SliceLabeledIcons_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceLabeledIcons_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  vertical-align: middle;\n  margin-right: 20px;\n  height: 60px;\n  width: 75px;\n  ",
        "\n  ",
        "\n  ",
        "\n  img {\n    width: auto;\n    height: 100%;\n    max-width: 100%;\n  }\n"
    ]);
    SliceLabeledIcons_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var SliceLabeledIcons_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceLabeledIcons_styles_templateObject(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
});
var List = globalStyles/* styled.ul */.zo.ul(SliceLabeledIcons_styles_templateObject1());
var styles_Item = globalStyles/* styled.li */.zo.li(SliceLabeledIcons_styles_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLabeledIcons_styles_templateObject2()));
var styles_Image = globalStyles/* styled.div */.zo.div(SliceLabeledIcons_styles_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceLabeledIcons_styles_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceLabeledIcons_styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLabeledIcons_styles_templateObject6()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLabeledIcons/SliceLabeledIcons.tsx



function SliceLabeledIcons(param) {
    var fields = param.slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceLabeledIcons_styles_Wrapper, {
        className: "labeled-icons",
        children: fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
            className: "labeled-icons__list",
            children: fields.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Item, {
                    className: (0,clsx/* clsx */.W)("labeled-icons__list-item", item.type || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Image, {
                            className: "labeled-icons__list-img",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.icon.url,
                                alt: "labeled-icons"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.label
                        })
                    ]
                }, i);
            })
        })
    });
}
SliceLabeledIcons.componentName = "labeled_icons";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLabeledIcons/index.ts


// EXTERNAL MODULE: ./src/@next/components/atoms/Accordion/index.ts + 4 modules
var Accordion = __webpack_require__(77427);
// EXTERNAL MODULE: ./node_modules/@prismicio/types/dist/value/richText.js
var richText = __webpack_require__(32716);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-player/youtube.js
var youtube = __webpack_require__(15655);
var youtube_default = /*#__PURE__*/__webpack_require__.n(youtube);
// EXTERNAL MODULE: ./src/@next/components/organisms/ImageGallery/index.ts + 2 modules
var ImageGallery = __webpack_require__(27078);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var templates_Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var globalStyles_utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductDetails/styles.ts

function SliceProductDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-size: cover !important;\n      width: 42px;\n      height: 42px;\n    "
    ]);
    SliceProductDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translate(0, -50%);\n    "
    ]);
    SliceProductDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 33px;\n      height: 33px;\n      transform: translate3d(0, 0, 0);\n    "
    ]);
    SliceProductDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    left: auto;\n    top: 50%;\n    border-radius: 50%;\n    width: 56px;\n    height: 56px;\n    color: transparent;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    z-index: 1;\n    transform: translate3d(0, 0, 0);\n    ",
        "\n    ",
        "\n    ",
        "\n    &:before {\n      content: none;\n    }\n  }\n"
    ]);
    SliceProductDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    left: 15px;\n    &:hover,\n    &:focus,\n    &:active {\n      background: url(",
        ") no-repeat center !important;\n    }\n    &.slick-disabled {\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    SliceProductDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    right: 15px;\n    &:hover,\n    &:focus,\n    &:active {\n      background: url(",
        ") no-repeat center !important;\n    }\n    &.slick-disabled {\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    SliceProductDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slider {\n    margin: 0 -16px;\n  }\n"
    ]);
    SliceProductDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    padding: 0 15px;\n  }\n"
    ]);
    SliceProductDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    SliceProductDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SliceProductDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    SliceProductDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    margin-bottom: 30px;\n  "
    ]);
    SliceProductDetails_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 90px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    SliceProductDetails_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n    "
    ]);
    SliceProductDetails_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n    "
    ]);
    SliceProductDetails_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n    "
    ]);
    SliceProductDetails_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 60vh;\n    "
    ]);
    SliceProductDetails_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function SliceProductDetails_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .list-content-container {\n    display: flex;\n    ",
        "\n  }\n\n  .list-content-col {\n    &.col-full-width {\n      width: 100%;\n    }\n    &:not(:last-child) {\n      margin-right: 40px;\n    }\n  }\n\n  .list-content-col--left {\n    width: 66.6%;\n    ",
        "\n  }\n\n  .list-content-col--right {\n    width: 33.4%;\n    ",
        "\n  }\n\n  .block-embed {\n    height: 100vh;\n    ",
        "\n  }\n\n  * {\n    line-height: inherit;\n  }\n  ",
        "\n"
    ]);
    SliceProductDetails_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var slickArrow = (0,styled_components_browser_esm/* css */.iv)(SliceProductDetails_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductDetails_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceProductDetails_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject2()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(SliceProductDetails_styles_templateObject4(), chevron_left, chevron_left);
var slickNext = (0,styled_components_browser_esm/* css */.iv)(SliceProductDetails_styles_templateObject5(), chevron_right, chevron_right);
var slickSlider = (0,styled_components_browser_esm/* css */.iv)(SliceProductDetails_styles_templateObject6());
var slickSlide = (0,styled_components_browser_esm/* css */.iv)(SliceProductDetails_styles_templateObject7());
var SliceProductDetails_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceProductDetails_styles_templateObject8(), slickArrow, slickPrev, slickNext, slickSlider, slickSlide);
var Padding = (0,globalStyles/* styled */.zo)(templates_Container/* Container */.W2)(SliceProductDetails_styles_templateObject9(), globalStyles_utils/* paddingLeft */.rv);
var Title = globalStyles/* styled.div */.zo.div(SliceProductDetails_styles_templateObject12(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductDetails_styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject11()), globalStyles_utils/* pageTitle */.tj);
var ContentWrapper = globalStyles/* styled.div */.zo.div(SliceProductDetails_styles_templateObject17(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject13()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductDetails_styles_templateObject16()), globalStyles_utils/* prismicRichText */.C7);

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductDetails/SliceAccordionContent.tsx













function SliceAccordionContent(param) {
    var item = param.item;
    var showGallery = function showGallery(gallery, index) {
        setImages(gallery);
        setImagesIndex(index);
        setShow(true);
    };
    var closeGallery = function closeGallery() {
        setShow(false);
    // setImages([]);
    };
    var ref, ref1;
    var ref2 = (0,react.useState)([]), images = ref2[0], setImages = ref2[1];
    var ref3 = (0,react.useState)(0), imagesIndex = ref3[0], setImagesIndex = ref3[1];
    var ref4 = (0,react.useState)(false), show = ref4[0], setShow = ref4[1];
    var slider = (0,react.useRef)(null);
    var sliderSettings = {
        // adaptiveHeight: true,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: constants/* smallScreen */.xC,
                settings: {
                    swipe: false
                }
            }, 
        ],
        slidesToScroll: 1,
        slidesToShow: 1
    };
    var propsWithUniqueKey = function(props, key) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props || {}), {
            key: key
        });
    };
    var htmlSerializer = function(type, element, contentHtml, childrenHtml, key) {
        var props = {};
        switch(type){
            // Don't wrap images in a <p> tag
            case richText/* RichTextNodeType.image */.M.image:
                {
                    props = {
                        alt: element.alt || "Img",
                        onClick: function() {
                            showGallery([
                                (0,_object_spread/* default */.Z)({}, element)
                            ], 0);
                        },
                        src: element.url
                    };
                    return /*#__PURE__*/ react.createElement("div", {
                        className: "block-img"
                    }, /*#__PURE__*/ react.createElement("img", propsWithUniqueKey(props, key)));
                }
            case richText/* RichTextNodeType.embed */.M.embed:
                {
                    var ref;
                    return /*#__PURE__*/ react.createElement("div", {
                        className: "block-embed"
                    }, /*#__PURE__*/ (0,jsx_runtime.jsx)((youtube_default()), {
                        className: "react-player",
                        url: element === null || element === void 0 ? void 0 : (ref = element.oembed) === null || ref === void 0 ? void 0 : ref.embed_url,
                        width: "100%",
                        height: "100%"
                    }));
                }
            default:
                return null;
        }
    };
    var hasRichTextContent = (item === null || item === void 0 ? void 0 : (ref = item.rich_text_2) === null || ref === void 0 ? void 0 : ref.some(function(z) {
        return z.type === "image" ? Boolean(z.url) : false;
    })) || false;
    var imagesByRichText = item === null || item === void 0 ? void 0 : (ref1 = item.rich_text_2) === null || ref1 === void 0 ? void 0 : ref1.filter(function(z) {
        return z.type === "image";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
        className: "list-content",
        children: [
            item.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                field: item.subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "list-content-container",
                children: [
                    item.rich_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* clsx */.W)("list-content-col list-content-col--left", {
                            "col-full-width": !hasRichTextContent
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: item.rich_text,
                            components: htmlSerializer
                        })
                    }),
                    hasRichTextContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-content-col list-content-col--right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                            ref: slider,
                            children: imagesByRichText.map(function(slide, slideIndex) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "content__slide",
                                    onClick: function() {
                                        return showGallery(imagesByRichText, slideIndex);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                        field: slide,
                                        width: 860,
                                        style: {
                                            width: "100%",
                                            height: "auto"
                                        },
                                        sizes: "(max-width: 1278px) 100vw, 33vw"
                                    })
                                }, "imgSlide-".concat(slideIndex));
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery/* ImageGallery */.h, {
                images: images,
                index: imagesIndex,
                show: show,
                hide: function() {
                    closeGallery();
                }
            })
        ]
    });
}
SliceAccordionContent.componentName = "product_details_accordion";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductDetails/SliceProductDetails.tsx







function SliceProductDetails(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    var accordionRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceProductDetails_styles_Wrapper, {
        className: "slice-product-details",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Padding, {
            children: [
                primary.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    className: "blue",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: primary.title
                    })
                }),
                fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
                    ref: accordionRef,
                    multi: true,
                    expanded: (0,_to_consumable_array/* default */.Z)(Array(fields.length).keys()),
                    children: fields.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionItem */.Q, {
                            title: item.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                field: item.title
                            }),
                            uniqueKey: i,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceAccordionContent, {
                                item: item
                            })
                        }, "slice-accordion-item-".concat(i));
                    })
                })
            ]
        })
    });
}
SliceProductDetails.componentName = "product_details";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductDetails/index.ts


;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductFeatures/styles.ts

function SliceProductFeatures_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .vimeo {\n    width: 100%;\n    height: 56.25%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */\n    min-height: 100%;\n    min-width: 177.77%; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    SliceProductFeatures_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SliceProductFeatures_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 24px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-bottom: 90px;\n  ",
        "\n  ",
        "\n"
    ]);
    SliceProductFeatures_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    SliceProductFeatures_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    SliceProductFeatures_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    SliceProductFeatures_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 32%;\n  background-color: ",
        ";\n  margin-bottom: 30px;\n"
    ]);
    SliceProductFeatures_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 20vw;\n  "
    ]);
    SliceProductFeatures_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 34vw;\n  "
    ]);
    SliceProductFeatures_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 70vw;\n  "
    ]);
    SliceProductFeatures_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 100%;\n  overflow: hidden;\n  position: relative;\n  ",
        "\n  ",
        "\n  ",
        "\n  img {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"
    ]);
    SliceProductFeatures_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 30px 20px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 15px 20px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 50px 35px;\n  ",
        "\n  ",
        "\n"
    ]);
    SliceProductFeatures_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 12px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 8px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 17px;\n  line-height: 1.1em;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n    color: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    SliceProductFeatures_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n  opacity: 0.8;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n    color: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    SliceProductFeatures_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 40px 40px 50px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 15px 40px;\n  "
    ]);
    SliceProductFeatures_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 90px 120px 100px;\n  ",
        "\n  ",
        "\n"
    ]);
    SliceProductFeatures_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    SliceProductFeatures_styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 38px;\n      margin-right: 15px;\n    "
    ]);
    SliceProductFeatures_styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function SliceProductFeatures_styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 26px;\n      margin-bottom: 14px;\n    "
    ]);
    SliceProductFeatures_styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  line-height: 1.1em;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  ",
        "\n  * {\n    font: inherit;\n    line-height: inherit;\n    color: inherit;\n  }\n  img {\n    width: 48px;\n    height: auto;\n    margin-right: 25px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}



var SliceProductFeatures_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject());
var styles_Padding = (0,globalStyles/* styled */.zo)(templates_Container/* Container */.W2)(SliceProductFeatures_styles_templateObject1(), globalStyles_utils/* paddingLeft */.rv);
var SliceProductFeatures_styles_Header = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject4(), globalStyles_utils/* pageTitle */.tj, globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject3()));
var styles_Footer = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject5(), function(props) {
    return props.theme.colors.light;
});
var styles_List = globalStyles/* styled.ul */.zo.ul(SliceProductFeatures_styles_templateObject7(), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceProductFeatures_styles_templateObject6()));
var SliceProductFeatures_styles_Item = globalStyles/* styled.li */.zo.li(SliceProductFeatures_styles_templateObject8(), function(props) {
    return props.theme.colors.light;
});
var ItemImage = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject12(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject9()), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceProductFeatures_styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject11()));
var ItemContent = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject15(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject13()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject14()));
var ItemTitle = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject18(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject16()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject17()));
var ItemDescription = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject21(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject19()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject20()));
var FooterWrapper = globalStyles/* styled.div */.zo.div(SliceProductFeatures_styles_templateObject24(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject22()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject23()));
var FooterTitle = globalStyles/* styled.div */.zo.div(styles_templateObject28(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject25()), globalStyles/* media.largeScreen */.BC.largeScreen(SliceProductFeatures_styles_templateObject26()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceProductFeatures_styles_templateObject27()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductFeatures/SliceProductFeatures.tsx





function SliceProductFeatures(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceProductFeatures_styles_Wrapper, {
        className: "product-features",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Padding, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceProductFeatures_styles_Header, {
                    children: primary.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: primary.title
                    })
                }),
                fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_List, {
                    className: "product-features__list",
                    children: fields.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliceProductFeatures_styles_Item, {
                            className: (0,clsx/* clsx */.W)("product-features__item", {
                                "product-features__item-rate": item.text
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemImage, {
                                    className: "product-features__item-image",
                                    children: [
                                        item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                            field: item.image,
                                            width: 320,
                                            height: 320,
                                            style: {
                                                maxWidth: "auto",
                                                height: "100%"
                                            },
                                            sizes: "(max-width: 1278px) 100vw, 33vw"
                                        }),
                                        item.video && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            className: "vimeo",
                                            src: "https://player.vimeo.com/video/".concat(item.video.video_id, "?autoplay=1&loop=1&muted=1&controls=0"),
                                            frameBorder: "0",
                                            allow: "autoplay",
                                            allowFullScreen: true,
                                            title: "video"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContent, {
                                    className: "product-features__item-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                                            className: "product-features__item-title",
                                            children: item.sub_title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                field: item.sub_title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                                            className: "product-features__item-descr",
                                            children: item.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                field: item.text
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Footer, {
                    className: "product-features-bottom",
                    children: primary.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        className: "product-features-bottom__wr",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTitle, {
                                className: "product-features-bottom__title",
                                children: [
                                    primary.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: primary.icon.url,
                                        alt: primary.icon.alt
                                    }),
                                    primary.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                        field: primary.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                                className: "product-features-bottom__descr",
                                children: primary.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                    field: primary.text
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
SliceProductFeatures.componentName = "product_features";
/* harmony default export */ var SliceProductFeatures_SliceProductFeatures = ((/* unused pure expression or super */ null && (SliceProductFeatures)));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceProductFeatures/index.ts


;// CONCATENATED MODULE: ./src/views/Product/Slices.ts
// import { SliceAccordion } from '@components/slices/SliceAccordion';
// import { SliceArchitectReviews } from '@components/slices/SliceArchitectReviews';
// import { SliceBenefits } from '@components/slices/SliceBenefits';
// import { SliceBenefitsProgram } from '@components/slices/SliceBenefitsProgram';
// import { SliceBlogContentPhotoPhoto } from '@components/slices/SliceBlogContentPhotoPhoto';
// import { SliceBlogContentTextPhoto } from '@components/slices/SliceBlogContentTextPhoto';
// import { SliceBlogContentTextText } from '@components/slices/SliceBlogContentTextText';
// import { SliceCollections } from '@components/slices/SliceCollections';

// import { SliceConsultToolbox } from '@components/slices/SliceConsultToolbox';
// import { SliceCta } from '@components/slices/SliceCta';
// import { SliceDownloadFiles } from '@components/slices/SliceDownloadFiles';
// import { SliceExerpt } from '@components/slices/SliceExerpt';
// import { SliceFormEmbded } from '@components/slices/SliceFormEmbded';
// import { SliceFranchiseContact } from '@components/slices/SliceFranchiseContact';
// import { SliceHeroImg } from '@components/slices/SliceHeroImg';
// import { SliceIconBanner } from '@components/slices/SliceIconBanner';
// import { SliceIconCta } from '@components/slices/SliceIconCta';



// import { SliceLinkButton } from '@components/slices/SliceLinkButton';
// import { SliceMediaSlider } from '@components/slices/SliceMediaSlider';
// import { SliceOurPartners } from '@components/slices/SliceOurPartners';


// import { SliceQuote } from '@components/slices/SliceQuote';
// import { SliceRelatedPagesSlider } from '@components/slices/SliceRelatedPagesSlider';
// import { SliceReviews } from '@components/slices/SliceReviews';
// import { SliceRichText } from '@components/slices/SliceRichText';
// import { SliceShowRoom } from '@components/slices/SliceShowRoom';
// import { SliceTagImage } from '@components/slices/SliceTagImage';
// import { SliceTrusted } from '@components/slices/SliceTrusted';
var components = {
    // accordion: SliceAccordion,
    // architectreviews: SliceArchitectReviews,
    // benefits: SliceBenefits,
    // benefitsprogram: SliceBenefitsProgram,
    // collections: SliceCollections,
    color_sample: SliceColorSample/* SliceColorSample */.x,
    // consulttoolbox: SliceConsultToolbox,
    // content_photo_photo_50: SliceBlogContentPhotoPhoto,
    // content_photo_text_30_60: SliceBlogContentTextPhoto,
    // content_text_photo_60_30: SliceBlogContentTextPhoto,
    // content_text_text_50: SliceBlogContentTextText,
    // cta: SliceCta,
    // downloadfiles: SliceDownloadFiles,
    // excerpt: SliceExerpt,
    // formembded: SliceFormEmbded,
    // franchisecontact: SliceFranchiseContact,
    // heroimg: SliceHeroImg,
    // iconbanner: SliceIconBanner,
    // iconcta: SliceIconCta,
    inspiration: SliceInspiration/* SliceInspiration */.L,
    instagram_posts: SliceInstagramPosts/* SliceInstagramPosts */.J,
    labeled_icons: SliceLabeledIcons,
    // linkbutton: SliceLinkButton,
    // mediaslider: SliceMediaSlider,
    // ourpartners: SliceOurPartners,
    product_details: SliceProductDetails,
    product_features: SliceProductFeatures
};

// EXTERNAL MODULE: ./src/@next/components/organisms/ProductList/index.ts + 6 modules
var ProductList = __webpack_require__(27453);
;// CONCATENATED MODULE: ./src/views/Product/styles.ts

function Product_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Product_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Product_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: wrap;\n    position: relative;\n    height: 100%;\n  "
    ]);
    Product_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Product_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // height: calc(100vh - 200px);\n  overflow-y: hidden;\n  display: flex;\n  background-color: #ece5e7;\n  // min-height: 816px;\n  ",
        "\n"
    ]);
    Product_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Product_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 52vh;\n  "
    ]);
    Product_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Product_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60vh;\n  "
    ]);
    Product_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Product_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60vh;\n  "
    ]);
    Product_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Product_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 90vh;\n  flex-grow: 1;\n  overflow: hidden;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Product_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Product_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40vw;\n  "
    ]);
    Product_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Product_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: static;\n    overflow: visible;\n  "
    ]);
    Product_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Product_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 750px;\n  display: flex;\n  align-items: flex-start;\n  overflow: visible;\n  background: #ece5e7;\n  ",
        "\n  ",
        "\n"
    ]);
    Product_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Product_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 120px 0;\n  "
    ]);
    Product_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Product_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 80px 0;\n  "
    ]);
    Product_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Product_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 200px 0;\n  ",
        "\n  ",
        "\n  //TODO and fix overflowing\n  overflow: hidden;\n"
    ]);
    Product_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Product_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Product_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Product_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    Product_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Product_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n  ",
        "\n  ",
        "\n"
    ]);
    Product_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Product_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    "
    ]);
    Product_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function Product_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    ",
        "\n  }\n"
    ]);
    Product_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var Product_styles_Wrapper = globalStyles/* styled.div */.zo.div(Product_styles_templateObject(), function(props) {
    return props.theme.colors.white;
});
var ProductDetails = globalStyles/* styled.div */.zo.div(Product_styles_templateObject2(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(Product_styles_templateObject1()));
var ProductViewWr = globalStyles/* styled.div */.zo.div(Product_styles_templateObject6(), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(Product_styles_templateObject3()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(Product_styles_templateObject4()), globalStyles/* media.smallestScreen */.BC.smallestScreen(Product_styles_templateObject5()));
var ProductControlsWr = globalStyles/* styled.div */.zo.div(Product_styles_templateObject9(), globalStyles/* media.mediumScreen */.BC.mediumScreen(Product_styles_templateObject7()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(Product_styles_templateObject8()));
var OtherProducts = globalStyles/* styled.div */.zo.div(Product_styles_templateObject12(), function(props) {
    return props.theme.colors.white;
}, globalStyles/* media.largeScreen */.BC.largeScreen(Product_styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(Product_styles_templateObject11()));
var OtherProductsWrapper = (0,globalStyles/* styled */.zo)(templates_Container/* Container */.W2)(Product_styles_templateObject13(), globalStyles_utils/* paddingLeft */.rv);
var OtherProductsTitle = globalStyles/* styled.div */.zo.div(Product_styles_templateObject15(), globalStyles/* media.smallScreen */.BC.smallScreen(Product_styles_templateObject14()), globalStyles_utils/* pageTitle */.tj);
var OtherProductsList = globalStyles/* styled.div */.zo.div(Product_styles_templateObject17(), globalStyles/* media.smallScreen */.BC.smallScreen(Product_styles_templateObject16()));

;// CONCATENATED MODULE: ./src/views/Product/OtherProducts.tsx


// import { PrismicRichText } from "@prismicio/react";



var OtherProducts_OtherProducts = function(param) {
    var products = param.products;
    var intl = (0,useIntl/* default */.Z)();
    if (products.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProducts, {
            className: "product-page__other-products",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherProductsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProductsTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: intl.formatMessage({
                                defaultMessage: "What others bought",
                                id: "pLFP9o"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProductsList, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* ProductList */.c, {
                            innerList: true,
                            products: products
                        })
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ var Product_OtherProducts = (OtherProducts_OtherProducts);

;// CONCATENATED MODULE: ./src/views/Product/ProductConfiguratorBody.tsx










function ProductConfiguratorBody(param) {
    var product = param.product, productDetails = param.productDetails;
    var ref;
    var locale = (0,router.useRouter)().locale;
    var ref1 = (0,generatedHooks/* useProductCategoryDetailsQuery */.Gs)({
        variables: (0,_object_spread/* default */.Z)({
            id: product.category.id
        }, (0,regions/* localeToSaleorQuery */.KK)(locale))
    }), dataCategory = ref1.data;
    var ref2 = dataCategory || {}, saleorCategory = ref2.category;
    var labeledIcons = productDetails === null || productDetails === void 0 ? void 0 : (ref = productDetails.body) === null || ref === void 0 ? void 0 : ref.filter(function(slice) {
        return slice.type === "labeled_icons";
    });
    var inspiration = productDetails === null || productDetails === void 0 ? void 0 : productDetails.body.filter(function(slice) {
        return slice.type === "inspiration";
    });
    var features = productDetails === null || productDetails === void 0 ? void 0 : productDetails.body.filter(function(slice) {
        return slice.type === "product_features";
    });
    var details = productDetails === null || productDetails === void 0 ? void 0 : productDetails.body.filter(function(slice) {
        return slice.type === "product_details";
    });
    var colorSample = productDetails === null || productDetails === void 0 ? void 0 : productDetails.body.filter(function(slice) {
        return slice.type === "color_sample";
    });
    var instagramPosts = productDetails === null || productDetails === void 0 ? void 0 : productDetails.body.filter(function(slice) {
        return slice.type === "instagram_posts";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            labeledIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: labeledIcons,
                components: components
            }),
            inspiration && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: inspiration,
                components: components
            }),
            features && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: features,
                components: components
            }),
            colorSample && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: colorSample,
                components: components,
                context: {
                    isMinimalist: (0,ModelFactory/* isMinimalist */.GG)(product.productType.slug)
                }
            }),
            saleorCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews/* ProductReviews */.v, {
                reviews: saleorCategory.reviews.edges.map(function(param) {
                    var node = param.node;
                    return node;
                })
            }),
            details && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: details,
                components: components
            }),
            instagramPosts && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                slices: instagramPosts,
                components: components
            }),
            saleorCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_OtherProducts, {
                products: saleorCategory.products.edges.filter(function(e) {
                    return e.node.id !== product.id;
                }).map(function(param) {
                    var node = param.node;
                    return node;
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Product/ProductStandardBody.tsx



function ProductStandardBody(param) {
    var productDetails = param.productDetails;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
        slices: productDetails === null || productDetails === void 0 ? void 0 : productDetails.body,
        components: components
    });
}

// EXTERNAL MODULE: ./src/views/Product/types.ts
var types = __webpack_require__(43065);
;// CONCATENATED MODULE: ./src/views/Product/Page.tsx











// import { useMediaQuery } from '@hooks/useMediaQuery';
// import { xSmallScreen } from '@styles/constants';



// import { ProductConfigurator } from '@components/organisms/ProductConfigurator';













var ProductConfigurator = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1182), __webpack_require__.e(4727)]).then(__webpack_require__.bind(__webpack_require__, 55094)).then(function(module) {
        return module.ProductConfigurator;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55094)
            ];
        }
    },
    ssr: false
});
var Page = function(param) {
    var product = param.product, productDetails = param.productDetails, addToCart = param.addToCart, items = param.items;
    // const [isXSmallScreen] = useMediaQuery(`(max-width: ${xSmallScreen}px)`);
    var isConfiguratorType = types/* CONFIGURATOR_PRODUCT_TYPES.includes */.d.includes(product.productType.slug);
    var isSampleType = types/* SAMPLE_PRODUCT_TYPES.includes */.q.includes(product.productType.slug);
    var isStandardType = !(isSampleType || isConfiguratorType);
    var ref = (0,react.useState)(null), activeImage = ref[0], setActiveImage = ref[1];
    var attributes = (0,react.useMemo)(function() {
        return (0,Product_utils/* getProductAttributes */.pg)(product);
    }, [
        product
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useQueryState/* useQueryStates */.XI)(attributes.reduce(function(acc, attr) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), // able to chose multiple values for samples
        (0,_define_property/* default */.Z)({}, attr.attribute.slug, isSampleType ? useQueryState/* queryTypes.array */.SS.array(useQueryState/* queryTypes.string */.SS.string).withDefault([]) : useQueryState/* queryTypes.string */.SS.string));
    }, {})), 2), query = ref1[0], setQuery = ref1[1];
    var formConfig = (0,react.useMemo)(function() {
        var attributesSlugs = attributes.map(function(attr) {
            return attr.attribute.slug;
        });
        var defaultValues = pick_default()((0,Product_utils/* getDefaultValues */.O4)(product, pickBy_default()(query)), attributesSlugs);
        return {
            defaultValues: defaultValues
        };
    }, [
        attributes,
        product,
        query
    ]);
    var formMethods = (0,index_esm/* useForm */.cI)(formConfig);
    var formAttributes = (0,hooks/* useDeepCompareMemoize */.Uf)(formMethods.watch());
    (0,react.useEffect)(function() {
        setQuery(pickBy_default()(formAttributes));
    }, [
        formAttributes
    ]);
    var ref2 = useVariantId(formAttributes, product), variantId = ref2.variantId, variantStock = ref2.variantStock, variantPricing = ref2.variantPricing;
    var selectedProductAttributes = (0,react.useMemo)(function() {
        return (0,Product_utils/* getSelectedProductAttributes */.ME)(formAttributes, product.attributes);
    }, [
        formAttributes,
        product.attributes
    ]);
    var debouncedAttributes = (0,hooks/* useDebounce */.Nr)(formAttributes, 300);
    var handleAddToCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(quantity) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, selectedVariant;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        selectedVariant = product.variants.find(function(o) {
                            return (o === null || o === void 0 ? void 0 : o.id) === variantId;
                        });
                        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("Product Added", {
                            currency: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.pricing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : ref3.currency,
                            name: (ref4 = product.productType) === null || ref4 === void 0 ? void 0 : ref4.slug,
                            price: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref5 = selectedVariant.pricing) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.price) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.gross) === null || ref7 === void 0 ? void 0 : ref7.amount,
                            product_id: product.slug,
                            order_quantity: quantity,
                            quantity: quantity,
                            variant: variantId,
                            value: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref8 = selectedVariant.pricing) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.price) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.gross) === null || ref10 === void 0 ? void 0 : ref10.amount,
                            total: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref11 = selectedVariant.pricing) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.price) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.gross) === null || ref13 === void 0 ? void 0 : ref13.amount
                        });
                        return [
                            4,
                            addToCart(variantId, quantity, selectedProductAttributes)
                        ];
                    case 1:
                        _state.sent();
                        esm/* default.show */.ZP.show(Cart/* CartModal */.k);
                        return [
                            2
                        ];
                }
            });
        });
        return function(quantity) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToCart,
        product,
        selectedProductAttributes,
        variantId
    ]);
    (0,react.useEffect)(function() {
        var // console.log('Page - product viewed');
        // @ analytics
        ref;
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("Product Viewed", {
            currency: product.pricing.priceRange.start.gross.currency,
            name: product.productType.slug,
            price: product.pricing.priceRange.start.gross.amount,
            product_id: product.slug
        });
    }, []);
    (0,hooks/* useUpdateEffect */.rf)(function() {
        var ref, ref1, ref2, ref3, ref4;
        // Ensure that we track the second show_variation with variantId defined
        // console.log('Page - show_variation');
        // console.log(debouncedAttributes)
        // @ analytics
        var selectedVariant = product.variants.find(function(o) {
            return (o === null || o === void 0 ? void 0 : o.id) === variantId;
        });
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("show_variation_new", {
            currency: product.pricing.priceRange.start.gross.currency,
            name: (ref1 = product.productType) === null || ref1 === void 0 ? void 0 : ref1.slug,
            price: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.pricing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.gross) === null || ref4 === void 0 ? void 0 : ref4.amount,
            product_id: product.slug,
            variant: variantId
        });
    }, [
        debouncedAttributes,
        product.id
    ]);
    /*
  const getImages = () => {
    if (product.variants && variantId) {
      const variant = product.variants.find(
        (variant) => variant.id === variantId
      );

      if (variant.images.length > 0) {
        return variant.images;
      }
    }

    return product.images;
  };
  */ var getActiveImage = function() {
        if (activeImage) {
            return {
                url: activeImage
            };
        }
        return product.images[0];
    };
    var productViewSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBoundary/* ErrorBoundary */.S, {
        children: [
            isConfiguratorType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductConfigurator, {
                productType: product.productType.slug,
                attributes: attributes,
                formAttributes: formAttributes
            }),
            isSampleType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                image: getActiveImage()
            }),
            isStandardType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery, {
                productSlug: product.slug
            })
        ]
    });
    var addToCartSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartSection_AddToCartSection, {
        items: items,
        product: product,
        attributes: attributes,
        formAttributes: formAttributes,
        productId: product.id,
        productName: isConfiguratorType ? product.productType.name : (0,translations/* translate */.I)(product, "name"),
        variantId: variantId,
        productAttributes: selectedProductAttributes,
        isSampleType: isSampleType,
        onAddToCart: handleAddToCart,
        setActiveImage: setActiveImage,
        productPricing: product.pricing,
        variantPricing: variantPricing,
        variantStock: variantStock
    });
    var productBodySection = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-body",
        children: [
            isConfiguratorType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductConfiguratorBody, {
                product: product,
                productDetails: productDetails
            }),
            isSampleType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStandardBody, {
                productDetails: productDetails
            }),
            isStandardType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStandardBody, {
                productDetails: productDetails
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Product_styles_Wrapper, {
        className: "product-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                className: "product-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductViewWr, {
                            className: "product-details_product-view-wr",
                            children: productViewSection
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductControlsWr, {
                            className: "product-details__controls-wr",
                            children: addToCartSection
                        })
                    ]
                }))
            }),
            productBodySection
        ]
    });
};
Page.displayName = "ProductPage";
/* harmony default export */ var Product_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Product/View.tsx














var View = function(param) {
    var product = param.product, productDetails = param.productDetails, seo = param.seo, _params = param.params, productId = _params.id;
    var ref = (0,CheckoutProvider/* useCheckout */.Mg)(), addItem = ref.addItem, checkout = ref.checkout;
    var items = (checkout === null || checkout === void 0 ? void 0 : checkout.lines) || [];
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    var intl = (0,useIntl/* default */.Z)();
    (0,react.useEffect)(function() {
        var ref;
        var modal = layout === null || layout === void 0 ? void 0 : (ref = layout.modals) === null || ref === void 0 ? void 0 : ref.find(function(m) {
            return (m === null || m === void 0 ? void 0 : m.id) === "modal-configurator-new-website";
        });
        if (modal) {
            esm/* default.show */.ZP.show(Message_Message, {
                title: modal.title,
                text: asText/* asText */.S(modal.text),
                // image: desktopIcon,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "button",
                    onClick: function() {
                        return esm/* default.hide */.ZP.hide(Message_Message);
                    },
                    fullWidth: true,
                    children: intl.formatMessage({
                        defaultMessage: "Okay",
                        id: "gZlFBP"
                    })
                })
            });
        }
    }, [
        layout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: structuredData(product)
                    }
                }, "product-jsonld")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_Page, {
                product: product,
                productDetails: productDetails,
                addToCart: addItem,
                items: items
            })
        ]
    });
};
/* harmony default export */ var Product_View = (View);

;// CONCATENATED MODULE: ./src/views/Product/index.tsx


;// CONCATENATED MODULE: ./src/pages/product/[slug]/[id].ts

var __N_SSG = true;
/* harmony default export */ var _id_ = (Product_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3737,2962,3537,1555,8940,9062,7453,4547,6416,6050,8626,9774,2888,179], function() { return __webpack_exec__(34428); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);